// AUTO-GENERATED from US Census county boundaries (all 50 states + DC).
// County bounding boxes [minLat, minLng, maxLat, maxLng]. Used to scope a
// Trail Lab harvest/search to a single county so we never process a whole
// large state at once. Regenerate with /tmp/gen_counties.py if needed.
export const COUNTY_BBOX = {
  AK: [
    { name: "Aleutians East", bbox: [54.0364, -166.1122, 56.8512, -158.891] },
    { name: "Aleutians West", bbox: [51.2199, -179.1473, 57.2297, 179.7785] },
    { name: "Anchorage", bbox: [60.7339, -150.0755, 61.4839, -148.46] },
    { name: "Bethel", bbox: [58.5518, -173.1208, 62.2953, -153.0013] },
    { name: "Bristol Bay", bbox: [58.6096, -157.2674, 58.8949, -156.3177] },
    { name: "Denali", bbox: [62.723, -153.0013, 64.3651, -146.972] },
    { name: "Dillingham", bbox: [58.3901, -161.0349, 61.0005, -155.9536] },
    { name: "Fairbanks North Star", bbox: [64.2579, -148.6638, 65.4545, -143.8848] },
    { name: "Haines", bbox: [58.1899, -136.4866, 59.7295, -134.3638] },
    { name: "Hoonah-Angoon", bbox: [57.0237, -137.9443, 59.2611, -132.368] },
    { name: "Juneau", bbox: [57.7864, -135.2191, 58.975, -133.1764] },
    { name: "Kenai Peninsula", bbox: [58.6468, -154.7477, 61.4281, -148.5624] },
    { name: "Ketchikan Gateway", bbox: [54.7169, -132.2015, 56.4074, -129.9801] },
    { name: "Kodiak Island", bbox: [55.76, -156.7508, 58.8558, -151.9638] },
    { name: "Lake and Peninsula", bbox: [55.633, -159.9037, 60.9085, -153.3943] },
    { name: "Matanuska-Susitna", bbox: [61.192, -153.0022, 63.4829, -146.4263] },
    { name: "Nome", bbox: [62.9375, -171.85, 66.5811, -159.3848] },
    { name: "North Slope", bbox: [67.9989, -166.8506, 71.3526, -141.0027] },
    { name: "Northwest Arctic", bbox: [65.4359, -165.36, 68.301, -154.1416] },
    { name: "Petersburg", bbox: [55.8287, -134.4198, 57.4263, -132.0801] },
    { name: "Prince of Wales-Hyder", bbox: [54.6691, -133.9456, 56.3525, -130.0043] },
    { name: "Sitka", bbox: [56.1669, -136.3707, 58.0014, -134.616] },
    { name: "Skagway", bbox: [59.3406, -135.7225, 59.7996, -135.0052] },
    { name: "Southeast Fairbanks", bbox: [61.901, -147.0032, 65.8394, -141.002] },
    { name: "Valdez-Cordova", bbox: [59.7833, -148.746, 63.2222, -141.0018] },
    { name: "Wade Hampton", bbox: [60.9174, -166.1827, 63.2757, -160.1867] },
    { name: "Wrangell", bbox: [55.6386, -133.0709, 56.9242, -130.9987] },
    { name: "Yakutat", bbox: [58.8023, -143.89, 60.5277, -137.4986] },
    { name: "Yukon-Koyukuk", bbox: [61.9456, -161.0478, 68.5073, -141.0025] },
  ],
  AL: [
    { name: "Autauga", bbox: [32.3408, -86.9176, 32.7074, -86.4112] },
    { name: "Baldwin", bbox: [30.2211, -88.0293, 31.2973, -87.3942] },
    { name: "Barbour", bbox: [31.618, -85.7483, 32.1483, -85.0502] },
    { name: "Bibb", bbox: [32.8315, -87.4219, 33.2469, -86.8761] },
    { name: "Blount", bbox: [33.7653, -86.9634, 34.2593, -86.3035] },
    { name: "Bullock", bbox: [31.8803, -85.9992, 32.2744, -85.4102] },
    { name: "Butler", bbox: [31.5237, -86.9089, 31.9646, -86.4482] },
    { name: "Calhoun", bbox: [33.5562, -86.1456, 33.9685, -85.5294] },
    { name: "Chambers", bbox: [32.7285, -85.5932, 33.1081, -85.1234] },
    { name: "Cherokee", bbox: [33.9414, -85.8436, 34.5241, -85.3988] },
    { name: "Chilton", bbox: [32.6617, -87.0192, 33.0719, -86.375] },
    { name: "Choctaw", bbox: [31.698, -88.4712, 32.3106, -87.9307] },
    { name: "Clarke", bbox: [31.1874, -88.1804, 31.9914, -87.5009] },
    { name: "Clay", bbox: [33.0903, -86.1744, 33.4987, -85.6435] },
    { name: "Cleburne", bbox: [33.4693, -85.8878, 33.9641, -85.3044] },
    { name: "Coffee", bbox: [31.1922, -86.1964, 31.618, -85.7891] },
    { name: "Colbert", bbox: [34.5671, -88.14, 34.8922, -87.4165] },
    { name: "Conecuh", bbox: [31.1922, -87.4275, 31.753, -86.6672] },
    { name: "Coosa", bbox: [32.7536, -86.5173, 33.1044, -86.0072] },
    { name: "Covington", bbox: [30.9932, -86.7016, 31.5285, -86.1872] },
    { name: "Crenshaw", bbox: [31.4401, -86.4995, 32.0517, -86.144] },
    { name: "Cullman", bbox: [33.8582, -87.151, 34.3138, -86.453] },
    { name: "Dale", bbox: [31.1952, -85.7914, 31.6195, -85.4164] },
    { name: "Dallas", bbox: [32.0475, -87.4731, 32.7295, -86.8103] },
    { name: "DeKalb", bbox: [34.2, -86.1104, 34.8604, -85.5137] },
    { name: "Elmore", bbox: [32.4099, -86.4133, 32.7675, -85.8799] },
    { name: "Escambia", bbox: [30.995, -87.6159, 31.2613, -86.6883] },
    { name: "Etowah", bbox: [33.8416, -86.3702, 34.2008, -85.739] },
    { name: "Fayette", bbox: [33.5217, -87.9518, 33.9199, -87.4237] },
    { name: "Franklin", bbox: [34.3046, -88.1736, 34.5817, -87.5297] },
    { name: "Geneva", bbox: [30.9931, -86.1935, 31.1999, -85.4858] },
    { name: "Greene", bbox: [32.5204, -88.2073, 33.1536, -87.7157] },
    { name: "Hale", bbox: [32.4809, -87.8705, 33.0068, -87.4201] },
    { name: "Henry", bbox: [31.3077, -85.4174, 31.7631, -85.0413] },
    { name: "Houston", bbox: [30.997, -85.7109, 31.315, -84.9994] },
    { name: "Jackson", bbox: [34.476, -86.359, 34.9911, -85.5831] },
    { name: "Jefferson", bbox: [33.2464, -87.3308, 33.8406, -86.5168] },
    { name: "Lamar", bbox: [33.5241, -88.2746, 34.0583, -87.9465] },
    { name: "Lauderdale", bbox: [34.7412, -88.2001, 35.0077, -87.2108] },
    { name: "Lawrence", bbox: [34.2993, -87.5297, 34.8, -87.1051] },
    { name: "Lee", bbox: [32.4098, -85.6968, 32.7465, -85.001] },
    { name: "Limestone", bbox: [34.5508, -87.2607, 34.999, -86.7836] },
    { name: "Lowndes", bbox: [31.9622, -86.9083, 32.4028, -86.4063] },
    { name: "Macon", bbox: [32.232, -86.023, 32.5959, -85.4335] },
    { name: "Madison", bbox: [34.4796, -86.7901, 34.9921, -86.3113] },
    { name: "Marengo", bbox: [31.9899, -88.0735, 32.5467, -87.4722] },
    { name: "Marion", bbox: [33.9153, -88.2072, 34.3211, -87.6347] },
    { name: "Marshall", bbox: [34.0991, -86.5819, 34.6001, -86.0577] },
    { name: "Mobile", bbox: [30.228, -88.432, 31.1627, -87.9412] },
    { name: "Monroe", bbox: [31.2445, -87.7848, 31.8306, -86.9059] },
    { name: "Montgomery", bbox: [31.9651, -86.4968, 32.495, -85.9193] },
    { name: "Morgan", bbox: [34.3047, -87.1101, 34.686, -86.5502] },
    { name: "Perry", bbox: [32.3073, -87.5252, 32.8751, -87.0178] },
    { name: "Pickens", bbox: [32.9912, -88.3404, 33.534, -87.8375] },
    { name: "Pike", bbox: [31.6177, -86.1994, 32.051, -85.6577] },
    { name: "Randolph", bbox: [33.1066, -85.6537, 33.4959, -85.2324] },
    { name: "Russell", bbox: [32.0617, -85.434, 32.5102, -84.9091] },
    { name: "Shelby", bbox: [33.0206, -87.0268, 33.5459, -86.3573] },
    { name: "St. Clair", bbox: [33.391, -86.5778, 33.9889, -86.044] },
    { name: "Sumter", bbox: [32.3087, -88.4215, 32.9959, -87.8409] },
    { name: "Talladega", bbox: [33.1029, -86.5031, 33.6791, -85.7946] },
    { name: "Tallapoosa", bbox: [32.4931, -86.0092, 33.1073, -85.5932] },
    { name: "Tuscaloosa", bbox: [33.0034, -87.8407, 33.6098, -87.0657] },
    { name: "Walker", bbox: [33.5129, -87.6361, 34.0022, -86.9537] },
    { name: "Washington", bbox: [31.1143, -88.4644, 31.6993, -87.9061] },
    { name: "Wilcox", bbox: [31.8271, -87.6678, 32.2649, -86.8566] },
    { name: "Winston", bbox: [33.9924, -87.6361, 34.307, -87.1099] },
  ],
  AR: [
    { name: "Arkansas", bbox: [33.9549, -91.7118, 34.568, -91.0563] },
    { name: "Ashley", bbox: [33.0062, -92.1375, 33.3982, -91.4574] },
    { name: "Baxter", bbox: [35.974, -92.5931, 36.4986, -92.1503] },
    { name: "Benton", bbox: [36.0994, -94.6179, 36.4995, -93.8156] },
    { name: "Boone", bbox: [36.1141, -93.3008, 36.4984, -92.854] },
    { name: "Bradley", bbox: [33.163, -92.3745, 33.7078, -91.9758] },
    { name: "Calhoun", bbox: [33.2749, -92.7767, 33.8022, -92.3111] },
    { name: "Carroll", bbox: [36.1213, -93.8668, 36.4992, -93.2961] },
    { name: "Chicot", bbox: [33.0041, -91.4604, 33.5637, -91.086] },
    { name: "Clark", bbox: [33.777, -93.4786, 34.3409, -92.8863] },
    { name: "Clay", bbox: [36.2006, -90.8066, 36.4986, -90.064] },
    { name: "Cleburne", bbox: [35.3583, -92.2528, 35.7122, -91.7898] },
    { name: "Cleveland", bbox: [33.7044, -92.4756, 34.0641, -91.9538] },
    { name: "Columbia", bbox: [33.0173, -93.4905, 33.4529, -92.9785] },
    { name: "Conway", bbox: [35.0717, -93.0405, 35.4629, -92.4793] },
    { name: "Craighead", bbox: [35.6999, -91.037, 35.9964, -90.2867] },
    { name: "Crawford", bbox: [35.3537, -94.4929, 35.7609, -93.9108] },
    { name: "Crittenden", bbox: [34.8328, -90.503, 35.4418, -90.0646] },
    { name: "Cross", bbox: [35.1442, -91.0427, 35.4447, -90.5024] },
    { name: "Dallas", bbox: [33.7951, -92.9612, 34.1559, -92.3342] },
    { name: "Desha", bbox: [33.5171, -91.5576, 34.1245, -90.8792] },
    { name: "Drew", bbox: [33.389, -92.0079, 33.7922, -91.4503] },
    { name: "Faulkner", bbox: [34.9276, -92.5936, 35.3684, -92.1115] },
    { name: "Franklin", bbox: [35.2138, -94.0828, 35.7742, -93.696] },
    { name: "Fulton", bbox: [36.2499, -92.1592, 36.4995, -91.45] },
    { name: "Garland", bbox: [34.3893, -93.4072, 34.7732, -92.7932] },
    { name: "Grant", bbox: [34.0596, -92.6784, 34.4958, -92.208] },
    { name: "Greene", bbox: [35.9647, -90.8521, 36.2669, -90.1987] },
    { name: "Hempstead", bbox: [33.4761, -93.9656, 34.0089, -93.4567] },
    { name: "Hot Spring", bbox: [34.1496, -93.4081, 34.5061, -92.6687] },
    { name: "Howard", bbox: [33.7477, -94.2547, 34.3555, -93.8207] },
    { name: "Independence", bbox: [35.5264, -91.871, 35.9429, -91.1986] },
    { name: "Izard", bbox: [35.8674, -92.1954, 36.2612, -91.6823] },
    { name: "Jackson", bbox: [35.3543, -91.5847, 35.89, -91.0325] },
    { name: "Jefferson", bbox: [34.0623, -92.2334, 34.4928, -91.4456] },
    { name: "Johnson", bbox: [35.3268, -93.7101, 35.7686, -93.1645] },
    { name: "Lafayette", bbox: [33.0184, -93.8604, 33.482, -93.3656] },
    { name: "Lawrence", bbox: [35.8809, -91.3572, 36.2579, -90.7474] },
    { name: "Lee", bbox: [34.6414, -91.1025, 34.9118, -90.408] },
    { name: "Lincoln", bbox: [33.7834, -91.9764, 34.1741, -91.4217] },
    { name: "Little River", bbox: [33.5432, -94.4859, 33.9409, -93.8259] },
    { name: "Logan", bbox: [35.0197, -94.1406, 35.43, -93.2783] },
    { name: "Lonoke", bbox: [34.4819, -92.1213, 35.0763, -91.6385] },
    { name: "Madison", bbox: [35.7598, -93.9629, 36.3066, -93.4507] },
    { name: "Marion", bbox: [36.0628, -92.8907, 36.4981, -92.4115] },
    { name: "Miller", bbox: [33.0191, -94.0435, 33.6135, -93.6655] },
    { name: "Mississippi", bbox: [35.4368, -90.2889, 36.0006, -89.6869] },
    { name: "Monroe", bbox: [34.3364, -91.4478, 35.0025, -91.0005] },
    { name: "Montgomery", bbox: [34.3395, -93.9354, 34.7453, -93.3943] },
    { name: "Nevada", bbox: [33.4445, -93.484, 33.9571, -93.1043] },
    { name: "Newton", bbox: [35.7247, -93.5236, 36.1251, -92.9447] },
    { name: "Ouachita", bbox: [33.3556, -93.119, 33.8099, -92.5672] },
    { name: "Perry", bbox: [34.7719, -93.2883, 35.1133, -92.5443] },
    { name: "Phillips", bbox: [34.1188, -91.1179, 34.6457, -90.5658] },
    { name: "Pike", bbox: [33.9432, -93.9354, 34.3501, -93.3734] },
    { name: "Poinsett", bbox: [35.4386, -91.0392, 35.7084, -90.2867] },
    { name: "Polk", bbox: [34.1899, -94.4703, 34.729, -93.9305] },
    { name: "Pope", bbox: [35.1274, -93.299, 35.7288, -92.8098] },
    { name: "Prairie", bbox: [34.4805, -91.8037, 35.0916, -91.3638] },
    { name: "Pulaski", bbox: [34.4894, -92.7536, 35.0145, -92.0295] },
    { name: "Randolph", bbox: [36.1496, -91.4071, 36.4985, -90.7486] },
    { name: "Saline", bbox: [34.4142, -93.0752, 34.8581, -92.2442] },
    { name: "Scott", bbox: [34.6656, -94.4546, 35.0997, -93.7049] },
    { name: "Searcy", bbox: [35.7184, -92.9513, 36.1151, -92.4115] },
    { name: "Sebastian", bbox: [34.9339, -94.4479, 35.45, -94.0285] },
    { name: "Sevier", bbox: [33.751, -94.4773, 34.1925, -93.9588] },
    { name: "Sharp", bbox: [35.8906, -91.7106, 36.4975, -91.2589] },
    { name: "St. Francis", bbox: [34.8671, -91.1525, 35.1482, -90.4004] },
    { name: "Stone", bbox: [35.7049, -92.4184, 36.1328, -91.8372] },
    { name: "Union", bbox: [33.0082, -92.9887, 33.3773, -92.0691] },
    { name: "Van Buren", bbox: [35.3637, -92.8506, 35.7908, -92.2405] },
    { name: "Washington", bbox: [35.7504, -94.5522, 36.235, -93.8878] },
    { name: "White", bbox: [35.0246, -92.1197, 35.5341, -91.3473] },
    { name: "Woodruff", bbox: [34.9125, -91.4651, 35.4458, -91.0398] },
    { name: "Yell", bbox: [34.7434, -93.7103, 35.3174, -92.8961] },
  ],
  AZ: [
    { name: "Apache", bbox: [33.4883, -110.0007, 36.9993, -109.0452] },
    { name: "Cochise", bbox: [31.3325, -110.4602, 32.4274, -109.0479] },
    { name: "Coconino", bbox: [34.2633, -113.3542, 37.0032, -110.7507] },
    { name: "Gila", bbox: [32.9837, -111.7207, 34.4981, -110.0006] },
    { name: "Graham", bbox: [32.4245, -110.4572, 33.6527, -109.114] },
    { name: "Greenlee", bbox: [32.4262, -109.4957, 33.7782, -109.0466] },
    { name: "La Paz", bbox: [33.0257, -114.7212, 34.3179, -113.3333] },
    { name: "Maricopa", bbox: [32.5049, -113.3339, 34.0482, -111.0399] },
    { name: "Mohave", bbox: [34.231, -114.7556, 37.0008, -112.5386] },
    { name: "Navajo", bbox: [33.5678, -110.7507, 37.0039, -109.8269] },
    { name: "Pima", bbox: [31.4259, -113.3339, 32.5138, -110.4512] },
    { name: "Pinal", bbox: [32.5014, -112.2037, 33.4661, -110.449] },
    { name: "Santa Cruz", bbox: [31.3326, -111.3666, 31.7313, -110.4517] },
    { name: "Yavapai", bbox: [33.8823, -113.3342, 35.5311, -111.4779] },
    { name: "Yuma", bbox: [32.0385, -114.8136, 33.4647, -113.3332] },
  ],
  CA: [
    { name: "Alameda", bbox: [37.4597, -122.3357, 37.8982, -121.4719] },
    { name: "Alpine", bbox: [38.3269, -120.0725, 38.9333, -119.5429] },
    { name: "Amador", bbox: [38.2213, -121.0275, 38.709, -120.0724] },
    { name: "Butte", bbox: [39.2956, -122.0465, 40.1519, -121.0767] },
    { name: "Calaveras", bbox: [37.8314, -120.9955, 38.5099, -120.02] },
    { name: "Colusa", bbox: [38.9239, -122.7851, 39.4145, -121.8355] },
    { name: "Contra Costa", bbox: [37.7186, -122.4301, 38.0944, -121.5366] },
    { name: "Del Norte", bbox: [41.3808, -124.256, 42.0004, -123.5181] },
    { name: "El Dorado", bbox: [38.5031, -121.141, 39.0675, -119.8803] },
    { name: "Fresno", bbox: [35.9072, -120.9187, 37.5857, -118.3606] },
    { name: "Glenn", bbox: [39.3833, -122.9377, 39.7982, -121.8565] },
    { name: "Humboldt", bbox: [40.0013, -124.4096, 41.4647, -123.4083] },
    { name: "Imperial", bbox: [32.6183, -116.1062, 33.4336, -114.4629] },
    { name: "Inyo", bbox: [35.7892, -118.7867, 37.4649, -115.648] },
    { name: "Kern", bbox: [34.7906, -120.1941, 35.7973, -117.6162] },
    { name: "Kings", bbox: [35.7892, -120.3151, 36.4888, -119.4746] },
    { name: "Lake", bbox: [38.6675, -123.093, 39.5807, -122.3402] },
    { name: "Lassen", bbox: [39.7077, -121.3318, 41.184, -119.9959] },
    { name: "Los Angeles", bbox: [32.8006, -118.9449, 34.8225, -117.6505] },
    { name: "Madera", bbox: [36.7697, -120.5417, 37.778, -119.0224] },
    { name: "Marin", bbox: [37.8221, -123.0241, 38.3169, -122.4383] },
    { name: "Mariposa", bbox: [37.1831, -120.3919, 37.9041, -119.309] },
    { name: "Mendocino", bbox: [38.7684, -124.0239, 40.0019, -122.8216] },
    { name: "Merced", bbox: [36.7404, -121.2268, 37.6334, -120.0521] },
    { name: "Modoc", bbox: [41.1835, -121.4475, 41.9972, -119.9992] },
    { name: "Mono", bbox: [37.4631, -119.6392, 38.7132, -117.8327] },
    { name: "Monterey", bbox: [35.7893, -121.9786, 36.9093, -120.214] },
    { name: "Napa", bbox: [38.155, -122.6463, 38.8642, -122.0648] },
    { name: "Nevada", bbox: [39.0052, -121.2795, 39.5269, -120.0031] },
    { name: "Orange", bbox: [33.3866, -118.1167, 33.9464, -117.413] },
    { name: "Placer", bbox: [38.7115, -121.4844, 39.3165, -120.0025] },
    { name: "Plumas", bbox: [39.5973, -121.4976, 40.4465, -120.1088] },
    { name: "Riverside", bbox: [33.4259, -117.6737, 34.0797, -114.4349] },
    { name: "Sacramento", bbox: [38.0266, -121.8625, 38.7364, -121.0271] },
    { name: "San Benito", bbox: [36.1968, -121.644, 36.9719, -120.5966] },
    { name: "San Bernardino", bbox: [33.8708, -117.7833, 35.8096, -114.1315] },
    { name: "San Diego", bbox: [32.5342, -117.5959, 33.505, -116.0811] },
    { name: "San Francisco", bbox: [37.6894, -123.0143, 37.8722, -122.3568] },
    { name: "San Joaquin", bbox: [37.4818, -121.58, 38.3003, -120.9207] },
    { name: "San Luis Obispo", bbox: [34.8976, -121.3464, 35.7952, -119.4727] },
    { name: "San Mateo", bbox: [37.1073, -122.5195, 37.7083, -122.0815] },
    { name: "Santa Barbara", bbox: [33.8957, -120.6708, 35.1141, -119.4404] },
    { name: "Santa Clara", bbox: [36.8992, -122.1904, 37.4845, -121.2154] },
    { name: "Santa Cruz", bbox: [36.8506, -122.3177, 37.2861, -121.5814] },
    { name: "Shasta", bbox: [40.287, -123.0688, 41.1839, -121.32] },
    { name: "Sierra", bbox: [39.3916, -121.0344, 39.7759, -120.0013] },
    { name: "Siskiyou", bbox: [40.994, -123.7191, 42.0095, -121.4465] },
    { name: "Solano", bbox: [38.0357, -122.407, 38.5334, -121.5933] },
    { name: "Sonoma", bbox: [38.1098, -123.5335, 38.8524, -122.379] },
    { name: "Stanislaus", bbox: [37.1348, -121.4726, 38.0774, -120.3873] },
    { name: "Sutter", bbox: [38.7346, -121.9455, 39.3039, -121.4149] },
    { name: "Tehama", bbox: [39.7976, -123.0654, 40.4456, -121.3456] },
    { name: "Trinity", bbox: [39.977, -123.6238, 41.359, -122.4455] },
    { name: "Tulare", bbox: [35.7892, -119.5732, 36.7448, -117.9808] },
    { name: "Tuolumne", bbox: [37.6337, -120.6527, 38.4335, -119.2003] },
    { name: "Ventura", bbox: [33.2154, -119.5789, 34.9013, -118.6335] },
    { name: "Yolo", bbox: [38.3131, -122.3951, 38.9245, -121.5041] },
    { name: "Yuba", bbox: [38.9389, -121.6238, 39.6395, -121.0095] },
  ],
  CO: [
    { name: "Adams", bbox: [39.7399, -105.0533, 40.0014, -103.7057] },
    { name: "Alamosa", bbox: [37.3568, -106.0393, 37.7515, -105.4573] },
    { name: "Arapahoe", bbox: [39.5659, -105.0541, 39.7403, -103.7065] },
    { name: "Archuleta", bbox: [36.9924, -107.4821, 37.4229, -106.4762] },
    { name: "Baca", bbox: [36.9931, -103.0861, 37.6443, -102.0416] },
    { name: "Bent", bbox: [37.6434, -103.4043, 38.267, -102.7423] },
    { name: "Boulder", bbox: [39.9129, -105.6758, 40.2618, -105.0528] },
    { name: "Broomfield", bbox: [39.9138, -105.1473, 40.0442, -104.9612] },
    { name: "Chaffee", bbox: [38.4228, -106.5992, 39.0579, -105.8792] },
    { name: "Cheyenne", bbox: [38.6125, -103.1729, 39.047, -102.0451] },
    { name: "Clear Creek", bbox: [39.5649, -105.9246, 39.852, -105.3979] },
    { name: "Conejos", bbox: [36.9935, -106.6784, 37.4036, -105.7185] },
    { name: "Costilla", bbox: [36.9952, -105.7702, 37.6544, -105.1542] },
    { name: "Crowley", bbox: [38.1133, -104.0582, 38.5224, -103.5018] },
    { name: "Custer", bbox: [37.896, -105.7969, 38.265, -105.0492] },
    { name: "Delta", bbox: [38.6681, -108.379, 39.2179, -107.5006] },
    { name: "Denver", bbox: [39.6143, -105.1099, 39.9142, -104.6004] },
    { name: "Dolores", bbox: [37.4852, -109.0431, 37.8944, -107.8608] },
    { name: "Douglas", bbox: [39.1295, -105.3292, 39.5661, -104.6606] },
    { name: "Eagle", bbox: [39.3619, -107.1137, 39.9249, -106.1776] },
    { name: "El Paso", bbox: [38.5196, -105.0722, 39.1298, -104.0517] },
    { name: "Elbert", bbox: [38.8668, -104.6629, 39.5663, -103.7144] },
    { name: "Fremont", bbox: [38.258, -106.0108, 38.6972, -104.9404] },
    { name: "Garfield", bbox: [39.3661, -109.0514, 40.0915, -107.034] },
    { name: "Gilpin", bbox: [39.7471, -105.6903, 39.9349, -105.3975] },
    { name: "Grand", bbox: [39.6884, -106.6521, 40.4863, -105.6388] },
    { name: "Gunnison", bbox: [38.1471, -107.635, 39.2563, -106.2469] },
    { name: "Hinsdale", bbox: [37.4227, -107.5689, 38.1473, -107.0006] },
    { name: "Huerfano", bbox: [37.2931, -105.4855, 38.0076, -104.3511] },
    { name: "Jackson", bbox: [40.3234, -106.8578, 41.0031, -105.8549] },
    { name: "Jefferson", bbox: [39.1296, -105.3989, 39.9139, -105.0487] },
    { name: "Kiowa", bbox: [38.265, -103.5047, 38.6152, -102.0446] },
    { name: "Kit Carson", bbox: [39.0376, -103.163, 39.5741, -102.0466] },
    { name: "La Plata", bbox: [36.9995, -108.3792, 37.6396, -107.4817] },
    { name: "Lake", bbox: [39.0561, -106.578, 39.3797, -106.1355] },
    { name: "Larimer", bbox: [40.2605, -106.1906, 40.9982, -104.9434] },
    { name: "Las Animas", bbox: [36.9933, -105.155, 37.8175, -103.0759] },
    { name: "Lincoln", bbox: [38.5164, -104.0555, 39.5663, -103.1544] },
    { name: "Logan", bbox: [40.4363, -103.5818, 41.0025, -102.6513] },
    { name: "Mesa", bbox: [38.5, -109.06, 39.3667, -107.3945] },
    { name: "Mineral", bbox: [37.3924, -107.1451, 37.9611, -106.6935] },
    { name: "Moffat", bbox: [40.2205, -109.0509, 41.003, -107.3142] },
    { name: "Montezuma", bbox: [36.9989, -109.0458, 37.6396, -107.9701] },
    { name: "Montrose", bbox: [38.1523, -109.0601, 38.6686, -107.5] },
    { name: "Morgan", bbox: [40.0009, -104.1505, 40.5243, -103.4654] },
    { name: "Otero", bbox: [37.6436, -104.0611, 38.2654, -103.3999] },
    { name: "Ouray", bbox: [37.9054, -108.1324, 38.3321, -107.5109] },
    { name: "Park", bbox: [38.6936, -106.191, 39.5682, -105.3291] },
    { name: "Phillips", bbox: [40.4385, -102.6648, 40.7496, -102.0513] },
    { name: "Pitkin", bbox: [38.9783, -107.466, 39.3662, -106.4265] },
    { name: "Prowers", bbox: [37.6436, -102.7476, 38.2687, -102.0416] },
    { name: "Pueblo", bbox: [37.7347, -105.0499, 38.5224, -104.0539] },
    { name: "Rio Blanco", bbox: [39.6605, -109.0512, 40.2254, -107.0374] },
    { name: "Rio Grande", bbox: [37.4009, -106.7116, 37.8352, -106.0384] },
    { name: "Routt", bbox: [39.9187, -107.4394, 41.0034, -106.6266] },
    { name: "Saguache", bbox: [37.7478, -107.0011, 38.4466, -105.4289] },
    { name: "San Juan", bbox: [37.6395, -107.9701, 37.965, -107.4688] },
    { name: "San Miguel", bbox: [37.7755, -109.0431, 38.153, -107.7383] },
    { name: "Sedgwick", bbox: [40.7494, -102.6535, 41.0026, -102.0513] },
    { name: "Summit", bbox: [39.3655, -106.4345, 39.9249, -105.7931] },
    { name: "Teller", bbox: [38.6476, -105.3304, 39.1298, -104.939] },
    { name: "Washington", bbox: [39.5657, -103.7071, 40.4384, -102.78] },
    { name: "Weld", bbox: [40.0003, -105.0567, 41.0019, -103.5745] },
    { name: "Yuma", bbox: [39.5678, -102.8038, 40.44, -102.0498] },
  ],
  CT: [
    { name: "Fairfield", bbox: [40.9852, -73.7278, 41.6666, -72.9851] },
    { name: "Hartford", bbox: [41.5568, -73.0295, 42.0394, -72.4106] },
    { name: "Litchfield", bbox: [41.4674, -73.5175, 42.0496, -72.8871] },
    { name: "Middlesex", bbox: [41.2556, -72.7529, 41.6427, -72.3055] },
    { name: "New Haven", bbox: [41.2344, -73.3271, 41.6396, -72.5378] },
    { name: "New London", bbox: [41.2778, -72.4667, 41.7142, -71.7894] },
    { name: "Tolland", bbox: [41.6018, -72.5173, 42.0346, -72.0992] },
    { name: "Windham", bbox: [41.6348, -72.2396, 42.029, -71.7895] },
  ],
  DC: [
    { name: "District of Columbia", bbox: [38.7915, -77.1199, 38.9951, -76.9094] },
  ],
  DE: [
    { name: "Kent", bbox: [38.8299, -75.7601, 39.3657, -75.3116] },
    { name: "New Castle", bbox: [39.2968, -75.7887, 39.8385, -75.415] },
    { name: "Sussex", bbox: [38.451, -75.7226, 38.9613, -75.0489] },
  ],
  FL: [
    { name: "Alachua", bbox: [29.4318, -82.6586, 29.9409, -82.0503] },
    { name: "Baker", bbox: [30.1364, -82.4598, 30.5843, -82.0492] },
    { name: "Bay", bbox: [29.9244, -85.9961, 30.5676, -85.3839] },
    { name: "Bradford", bbox: [29.7182, -82.4187, 30.1431, -82.0461] },
    { name: "Brevard", bbox: [27.8221, -80.9873, 28.7912, -80.447] },
    { name: "Broward", bbox: [25.9568, -80.8812, 26.3344, -80.0748] },
    { name: "Calhoun", bbox: [30.2, -85.3897, 30.608, -84.9325] },
    { name: "Charlotte", bbox: [26.7174, -82.3757, 27.0338, -81.5622] },
    { name: "Citrus", bbox: [28.6659, -82.7589, 29.0449, -82.1708] },
    { name: "Clay", bbox: [29.7187, -82.0494, 30.1912, -81.5812] },
    { name: "Collier", bbox: [25.8033, -81.8458, 26.5171, -80.8727] },
    { name: "Columbia", bbox: [29.8301, -82.8005, 30.5977, -82.4584] },
    { name: "DeSoto", bbox: [27.0321, -82.0575, 27.3407, -81.5622] },
    { name: "Dixie", bbox: [29.2889, -83.4123, 29.8241, -82.9206] },
    { name: "Duval", bbox: [30.106, -82.0494, 30.5862, -81.3799] },
    { name: "Escambia", bbox: [30.2804, -87.6349, 30.9991, -86.9193] },
    { name: "Flagler", bbox: [29.2612, -81.5237, 29.6707, -81.1019] },
    { name: "Franklin", bbox: [29.5869, -85.2225, 30.0139, -84.3337] },
    { name: "Gadsden", bbox: [30.3883, -84.9325, 30.7115, -84.2826] },
    { name: "Gilchrist", bbox: [29.5648, -82.9497, 29.9321, -82.6563] },
    { name: "Glades", bbox: [26.769, -81.5659, 27.2106, -80.8712] },
    { name: "Gulf", bbox: [29.6548, -85.418, 30.2014, -85.0122] },
    { name: "Hamilton", bbox: [30.337, -83.3093, 30.6344, -82.6458] },
    { name: "Hardee", bbox: [27.3383, -82.0558, 27.6466, -81.5633] },
    { name: "Hendry", bbox: [26.253, -81.5659, 26.9589, -80.8798] },
    { name: "Hernando", bbox: [28.4335, -82.6804, 28.6949, -82.0545] },
    { name: "Highlands", bbox: [27.0325, -81.5637, 27.6466, -80.9432] },
    { name: "Hillsborough", bbox: [27.6451, -82.6512, 28.1733, -82.054] },
    { name: "Holmes", bbox: [30.7031, -86.0376, 30.9969, -85.498] },
    { name: "Indian River", bbox: [27.5574, -80.8731, 27.8608, -80.3213] },
    { name: "Jackson", bbox: [30.5643, -85.5999, 31.0009, -84.8647] },
    { name: "Jefferson", bbox: [30.0839, -84.076, 30.6721, -83.6042] },
    { name: "Lafayette", bbox: [29.8226, -83.3709, 30.2607, -82.8756] },
    { name: "Lake", bbox: [28.3452, -81.9576, 29.2768, -81.3546] },
    { name: "Lee", bbox: [26.3173, -82.268, 26.7704, -81.5622] },
    { name: "Leon", bbox: [30.2736, -84.7134, 30.6853, -83.9772] },
    { name: "Levy", bbox: [28.9931, -83.1661, 29.5913, -82.4032] },
    { name: "Liberty", bbox: [29.9714, -85.1538, 30.6064, -84.5444] },
    { name: "Madison", bbox: [30.2604, -83.8202, 30.6513, -83.171] },
    { name: "Manatee", bbox: [27.2078, -82.7457, 27.6464, -82.0543] },
    { name: "Marion", bbox: [28.9599, -82.5356, 29.521, -81.6392] },
    { name: "Martin", bbox: [26.9572, -80.8856, 27.2637, -80.0795] },
    { name: "Miami-Dade", bbox: [25.1391, -80.8732, 25.9794, -80.1178] },
    { name: "Monroe", bbox: [24.5447, -82.1652, 25.8054, -80.174] },
    { name: "Nassau", bbox: [30.2734, -82.0504, 30.8222, -81.4274] },
    { name: "Okaloosa", bbox: [30.3786, -86.8003, 30.997, -86.3886] },
    { name: "Okeechobee", bbox: [26.9589, -81.2137, 27.6432, -80.6774] },
    { name: "Orange", bbox: [28.3471, -81.6581, 28.786, -80.8629] },
    { name: "Osceola", bbox: [27.6423, -81.6573, 28.3481, -80.8628] },
    { name: "Palm Beach", bbox: [26.3208, -80.8861, 26.9705, -80.0314] },
    { name: "Pasco", bbox: [28.1716, -82.8051, 28.4785, -82.0547] },
    { name: "Pinellas", bbox: [27.613, -82.8511, 28.1733, -82.5668] },
    { name: "Polk", bbox: [27.6432, -82.1062, 28.3617, -81.1315] },
    { name: "Putnam", bbox: [29.3244, -82.0559, 29.8402, -81.434] },
    { name: "Santa Rosa", bbox: [30.349, -87.3136, 30.9996, -86.7857] },
    { name: "Sarasota", bbox: [26.9453, -82.6428, 27.3897, -82.0565] },
    { name: "Seminole", bbox: [28.6103, -81.4597, 28.8792, -80.9873] },
    { name: "St. Johns", bbox: [29.6224, -81.6889, 30.2529, -81.2129] },
    { name: "St. Lucie", bbox: [27.206, -80.6798, 27.5585, -80.1993] },
    { name: "Sumter", bbox: [28.3128, -82.3117, 28.9604, -81.9536] },
    { name: "Suwannee", bbox: [29.8868, -83.2473, 30.4381, -82.7946] },
    { name: "Taylor", bbox: [29.666, -83.9916, 30.3042, -83.3189] },
    { name: "Union", bbox: [29.9231, -82.576, 30.1431, -82.1426] },
    { name: "Volusia", bbox: [28.613, -81.6809, 29.4271, -80.7322] },
    { name: "Wakulla", bbox: [29.9608, -84.7134, 30.3035, -84.0755] },
    { name: "Walton", bbox: [30.2691, -86.3973, 30.9945, -85.8444] },
    { name: "Washington", bbox: [30.3893, -85.9927, 30.8306, -85.4323] },
  ],
  GA: [
    { name: "Appling", bbox: [31.4713, -82.5214, 31.9662, -82.0486] },
    { name: "Atkinson", bbox: [31.1837, -83.1405, 31.4204, -82.629] },
    { name: "Bacon", bbox: [31.4171, -82.6273, 31.7108, -82.2266] },
    { name: "Baker", bbox: [31.0784, -84.6417, 31.4402, -84.1411] },
    { name: "Baldwin", bbox: [32.9261, -83.4291, 33.1872, -83.0522] },
    { name: "Banks", bbox: [34.1975, -83.6695, 34.4917, -83.3553] },
    { name: "Barrow", bbox: [33.8967, -83.8691, 34.1275, -83.5374] },
    { name: "Bartow", bbox: [34.078, -85.0469, 34.4126, -84.6532] },
    { name: "Ben Hill", bbox: [31.6517, -83.4802, 31.8479, -82.9957] },
    { name: "Berrien", bbox: [31.0254, -83.4345, 31.476, -83.0335] },
    { name: "Bibb", bbox: [32.6643, -83.8919, 32.9528, -83.5026] },
    { name: "Bleckley", bbox: [32.2725, -83.498, 32.5842, -83.139] },
    { name: "Brantley", bbox: [31.0107, -82.2846, 31.3737, -81.7317] },
    { name: "Brooks", bbox: [30.6374, -83.7437, 31.0781, -83.3577] },
    { name: "Bryan", bbox: [31.7261, -81.7809, 32.2413, -81.1385] },
    { name: "Bulloch", bbox: [32.1529, -82.0302, 32.6491, -81.4358] },
    { name: "Burke", bbox: [32.8127, -82.3165, 33.2968, -81.5418] },
    { name: "Butts", bbox: [33.1802, -84.1238, 33.4442, -83.8141] },
    { name: "Calhoun", bbox: [31.4339, -84.8198, 31.6219, -84.4299] },
    { name: "Camden", bbox: [30.7097, -81.936, 31.1696, -81.4034] },
    { name: "Candler", bbox: [32.2688, -82.2528, 32.5388, -81.9187] },
    { name: "Carroll", bbox: [33.4255, -85.338, 33.8119, -84.8089] },
    { name: "Catoosa", bbox: [34.7676, -85.2651, 34.9876, -84.9799] },
    { name: "Charlton", bbox: [30.358, -82.4204, 31.0758, -81.892] },
    { name: "Chatham", bbox: [31.7209, -81.3917, 32.2375, -80.8405] },
    { name: "Chattahoochee", bbox: [32.2315, -85.0081, 32.535, -84.6373] },
    { name: "Chattooga", bbox: [34.2861, -85.5271, 34.5887, -85.1077] },
    { name: "Cherokee", bbox: [34.0733, -84.6592, 34.4126, -84.2576] },
    { name: "Clarke", bbox: [33.848, -83.5374, 34.0406, -83.2409] },
    { name: "Clay", bbox: [31.4861, -85.1387, 31.7804, -84.8178] },
    { name: "Clayton", bbox: [33.3525, -84.4589, 33.6489, -84.2813] },
    { name: "Clinch", bbox: [30.5817, -82.9713, 31.184, -82.4189] },
    { name: "Cobb", bbox: [33.7435, -84.7378, 34.0794, -84.383] },
    { name: "Coffee", bbox: [31.3639, -83.1508, 31.8162, -82.5975] },
    { name: "Colquitt", bbox: [31.0339, -84.0039, 31.335, -83.5098] },
    { name: "Columbia", bbox: [33.3546, -82.4368, 33.7006, -82.0282] },
    { name: "Cook", bbox: [31.0273, -83.5749, 31.3504, -83.2951] },
    { name: "Coweta", bbox: [33.1912, -85.0154, 33.5115, -84.4975] },
    { name: "Crawford", bbox: [32.5299, -84.2026, 32.8496, -83.7011] },
    { name: "Crisp", bbox: [31.8035, -83.9613, 32.0306, -83.6097] },
    { name: "Dade", bbox: [34.6238, -85.6052, 34.9847, -85.3639] },
    { name: "Dawson", bbox: [34.334, -84.3456, 34.6179, -83.9571] },
    { name: "DeKalb", bbox: [33.6307, -84.3502, 33.9577, -84.0237] },
    { name: "Decatur", bbox: [30.6897, -84.8635, 31.079, -84.3766] },
    { name: "Dodge", bbox: [31.9003, -83.3465, 32.4525, -82.8718] },
    { name: "Dooly", bbox: [32.0279, -84.0279, 32.291, -83.6084] },
    { name: "Dougherty", bbox: [31.4367, -84.4504, 31.6503, -83.9826] },
    { name: "Douglas", bbox: [33.5734, -84.9058, 33.8062, -84.5781] },
    { name: "Early", bbox: [31.0726, -85.1119, 31.5175, -84.6376] },
    { name: "Echols", bbox: [30.5918, -83.1366, 30.8722, -82.584] },
    { name: "Effingham", bbox: [32.0959, -81.548, 32.5954, -81.1203] },
    { name: "Elbert", bbox: [33.9557, -83.1021, 34.2935, -82.5645] },
    { name: "Emanuel", bbox: [32.2922, -82.6477, 32.8358, -82.0012] },
    { name: "Evans", bbox: [32.0479, -82.0253, 32.2789, -81.7187] },
    { name: "Fannin", bbox: [34.6027, -84.6215, 34.9884, -84.0932] },
    { name: "Fayette", bbox: [33.2565, -84.6272, 33.5509, -84.3818] },
    { name: "Floyd", bbox: [34.0808, -85.4623, 34.5875, -85.0058] },
    { name: "Forsyth", bbox: [34.0507, -84.2589, 34.3352, -83.9273] },
    { name: "Franklin", bbox: [34.2237, -83.3984, 34.5341, -83.0522] },
    { name: "Fulton", bbox: [33.5025, -84.8507, 34.1861, -84.0977] },
    { name: "Gilmer", bbox: [34.5489, -84.6571, 34.8554, -84.1968] },
    { name: "Glascock", bbox: [33.1263, -82.7558, 33.3273, -82.432] },
    { name: "Glynn", bbox: [31.013, -81.7663, 31.453, -81.2699] },
    { name: "Gordon", bbox: [34.3924, -85.0868, 34.6341, -84.6532] },
    { name: "Grady", bbox: [30.676, -84.3807, 31.0789, -84.077] },
    { name: "Greene", bbox: [33.355, -83.4062, 33.7618, -82.9511] },
    { name: "Gwinnett", bbox: [33.7528, -84.2768, 34.1679, -83.7991] },
    { name: "Habersham", bbox: [34.4317, -83.6816, 34.823, -83.3379] },
    { name: "Hall", bbox: [34.0983, -84.0628, 34.5055, -83.6153] },
    { name: "Hancock", bbox: [33.0498, -83.2741, 33.4692, -82.7472] },
    { name: "Haralson", bbox: [33.6531, -85.3867, 33.9045, -85.0367] },
    { name: "Harris", bbox: [32.5834, -85.1841, 32.8725, -84.6946] },
    { name: "Hart", bbox: [34.2115, -83.1156, 34.4931, -82.7661] },
    { name: "Heard", bbox: [33.1296, -85.2939, 33.4281, -84.939] },
    { name: "Henry", bbox: [33.2982, -84.3544, 33.6474, -83.9239] },
    { name: "Houston", bbox: [32.2886, -83.8484, 32.6922, -83.4826] },
    { name: "Irwin", bbox: [31.4721, -83.5007, 31.7579, -82.9984] },
    { name: "Jackson", bbox: [33.9659, -83.8177, 34.2953, -83.36] },
    { name: "Jasper", bbox: [33.1318, -83.8631, 33.5262, -83.5337] },
    { name: "Jeff Davis", bbox: [31.6714, -82.8366, 31.9717, -82.4314] },
    { name: "Jefferson", bbox: [32.7623, -82.6619, 33.3127, -82.2326] },
    { name: "Jenkins", bbox: [32.6069, -82.145, 32.9539, -81.7676] },
    { name: "Johnson", bbox: [32.5125, -82.9571, 32.8224, -82.4341] },
    { name: "Jones", bbox: [32.8449, -83.816, 33.1854, -83.3577] },
    { name: "Lamar", bbox: [32.9322, -84.2701, 33.2028, -84.0415] },
    { name: "Lanier", bbox: [30.8447, -83.198, 31.184, -82.9712] },
    { name: "Laurens", bbox: [32.1473, -83.2265, 32.7158, -82.6477] },
    { name: "Lee", bbox: [31.622, -84.3382, 31.9162, -83.9225] },
    { name: "Liberty", bbox: [31.5555, -81.8244, 32.0894, -81.1311] },
    { name: "Lincoln", bbox: [33.6375, -82.6455, 33.9842, -82.2186] },
    { name: "Long", bbox: [31.5387, -81.9691, 32.0149, -81.4918] },
    { name: "Lowndes", bbox: [30.6243, -83.4825, 31.032, -83.0194] },
    { name: "Lumpkin", bbox: [34.4184, -84.191, 34.7409, -83.8434] },
    { name: "Macon", bbox: [32.1711, -84.2559, 32.5218, -83.8467] },
    { name: "Madison", bbox: [33.9991, -83.4024, 34.2735, -82.9763] },
    { name: "Marion", bbox: [32.1341, -84.6589, 32.5621, -84.3923] },
    { name: "McDuffie", bbox: [33.3109, -82.6497, 33.6551, -82.2942] },
    { name: "McIntosh", bbox: [31.2945, -81.6632, 31.6996, -81.1773] },
    { name: "Meriwether", bbox: [32.8446, -84.8624, 33.2236, -84.4929] },
    { name: "Miller", bbox: [31.0692, -84.9224, 31.259, -84.5371] },
    { name: "Mitchell", bbox: [31.0772, -84.5081, 31.4438, -83.9978] },
    { name: "Monroe", bbox: [32.8484, -84.1243, 33.2026, -83.7107] },
    { name: "Montgomery", bbox: [31.9589, -82.6555, 32.3537, -82.4091] },
    { name: "Morgan", bbox: [33.4345, -83.6874, 33.8178, -83.2692] },
    { name: "Murray", bbox: [34.5832, -84.9337, 34.9883, -84.5823] },
    { name: "Muscogee", bbox: [32.3816, -85.0825, 32.6076, -84.6945] },
    { name: "Newton", bbox: [33.3683, -84.0445, 33.7442, -83.6746] },
    { name: "Oconee", bbox: [33.6983, -83.647, 33.9659, -83.2759] },
    { name: "Oglethorpe", bbox: [33.6936, -83.2803, 34.0476, -82.7795] },
    { name: "Paulding", bbox: [33.7748, -85.0503, 34.0825, -84.724] },
    { name: "Peach", bbox: [32.4685, -84.0085, 32.6926, -83.7011] },
    { name: "Pickens", bbox: [34.381, -84.6544, 34.5627, -84.2569] },
    { name: "Pierce", bbox: [31.2076, -82.4172, 31.5307, -82.0068] },
    { name: "Pike", bbox: [32.9705, -84.527, 33.2089, -84.2482] },
    { name: "Polk", bbox: [33.9017, -85.4217, 34.1007, -84.9227] },
    { name: "Pulaski", bbox: [32.1059, -83.6156, 32.4017, -83.2911] },
    { name: "Putnam", bbox: [33.1719, -83.5459, 33.4834, -83.1458] },
    { name: "Quitman", bbox: [31.7768, -85.1418, 31.9919, -84.907] },
    { name: "Rabun", bbox: [34.7161, -83.6568, 35.0008, -83.1085] },
    { name: "Randolph", bbox: [31.6187, -84.9586, 31.9245, -84.5355] },
    { name: "Richmond", bbox: [33.2302, -82.3535, 33.5449, -81.852] },
    { name: "Rockdale", bbox: [33.5258, -84.1841, 33.7861, -83.9148] },
    { name: "Schley", bbox: [32.1585, -84.4302, 32.414, -84.1817] },
    { name: "Screven", bbox: [32.4893, -81.8679, 33.0457, -81.3893] },
    { name: "Seminole", bbox: [30.7115, -85.0221, 31.0755, -84.7309] },
    { name: "Spalding", bbox: [33.1839, -84.5089, 33.3525, -84.1026] },
    { name: "Stephens", bbox: [34.4609, -83.4598, 34.6877, -83.1069] },
    { name: "Stewart", bbox: [31.9203, -85.0622, 32.233, -84.6493] },
    { name: "Sumter", bbox: [31.8736, -84.4438, 32.2297, -83.9225] },
    { name: "Talbot", bbox: [32.5187, -84.7005, 32.8818, -84.2862] },
    { name: "Taliaferro", bbox: [33.4435, -83.014, 33.7333, -82.68] },
    { name: "Tattnall", bbox: [31.7844, -82.2328, 32.3188, -81.7617] },
    { name: "Taylor", bbox: [32.3721, -84.4444, 32.7476, -84.0011] },
    { name: "Telfair", bbox: [31.781, -83.2057, 32.1533, -82.6457] },
    { name: "Terrell", bbox: [31.6212, -84.6031, 31.9675, -84.2865] },
    { name: "Thomas", bbox: [30.6584, -84.1191, 31.078, -83.7362] },
    { name: "Tift", bbox: [31.3263, -83.6541, 31.5965, -83.3387] },
    { name: "Toombs", bbox: [31.9131, -82.4831, 32.3538, -82.182] },
    { name: "Towns", bbox: [34.7905, -83.9364, 34.9925, -83.5494] },
    { name: "Treutlen", bbox: [32.2976, -82.7371, 32.5125, -82.3819] },
    { name: "Troup", bbox: [32.8705, -85.2365, 33.2247, -84.8618] },
    { name: "Turner", bbox: [31.568, -83.8022, 31.8541, -83.4536] },
    { name: "Twiggs", bbox: [32.4522, -83.5977, 32.8982, -83.2265] },
    { name: "Union", bbox: [34.6419, -84.1787, 34.9875, -83.7804] },
    { name: "Upson", bbox: [32.69, -84.527, 32.9937, -84.1224] },
    { name: "Walker", bbox: [34.5872, -85.5344, 34.9851, -85.0504] },
    { name: "Walton", bbox: [33.5969, -83.982, 33.9298, -83.5059] },
    { name: "Ware", bbox: [30.567, -82.6992, 31.4694, -82.1317] },
    { name: "Warren", bbox: [33.2534, -82.852, 33.6112, -82.3838] },
    { name: "Washington", bbox: [32.7594, -83.0736, 33.2383, -82.5109] },
    { name: "Wayne", bbox: [31.33, -82.133, 31.8271, -81.6243] },
    { name: "Webster", bbox: [31.9192, -84.6558, 32.233, -84.4312] },
    { name: "Wheeler", bbox: [31.9189, -82.9279, 32.3093, -82.5437] },
    { name: "White", bbox: [34.5036, -83.8773, 34.8012, -83.6155] },
    { name: "Whitfield", bbox: [34.6225, -85.1689, 34.988, -84.8105] },
    { name: "Wilcox", bbox: [31.8473, -83.6123, 32.1184, -83.1775] },
    { name: "Wilkes", bbox: [33.5967, -82.9873, 33.9842, -82.4795] },
    { name: "Wilkinson", bbox: [32.5842, -83.407, 33.0028, -82.9464] },
    { name: "Worth", bbox: [31.3307, -84.0323, 31.8479, -83.6494] },
  ],
  HI: [
    { name: "Hawaii", bbox: [18.9175, -156.0644, 20.2715, -154.8094] },
    { name: "Honolulu", bbox: [21.2577, -158.2795, 21.7127, -157.6518] },
    { name: "Kalawao", bbox: [21.1295, -157.0146, 21.2185, -156.8989] },
    { name: "Kauai", bbox: [21.6454, -160.5558, 22.2332, -159.2953] },
    { name: "Maui", bbox: [20.5047, -157.3133, 21.2273, -155.9846] },
  ],
  IA: [
    { name: "Adair", bbox: [41.1571, -94.7006, 41.5041, -94.2416] },
    { name: "Adams", bbox: [40.8995, -94.9285, 41.1585, -94.4706] },
    { name: "Allamakee", bbox: [43.0802, -91.6108, 43.5009, -91.0579] },
    { name: "Appanoose", bbox: [40.584, -93.0976, 40.8989, -92.6379] },
    { name: "Audubon", bbox: [41.5041, -95.0929, 41.8634, -94.7006] },
    { name: "Benton", bbox: [41.8619, -92.2988, 42.2991, -91.8311] },
    { name: "Black Hawk", bbox: [42.297, -92.5546, 42.6423, -92.0648] },
    { name: "Boone", bbox: [41.8632, -94.1647, 42.2101, -93.698] },
    { name: "Bremer", bbox: [42.6421, -92.5545, 42.9071, -92.0816] },
    { name: "Buchanan", bbox: [42.2964, -92.0817, 42.644, -91.597] },
    { name: "Buena Vista", bbox: [42.5603, -95.3882, 42.9099, -94.9139] },
    { name: "Butler", bbox: [42.5559, -93.027, 42.9075, -92.5542] },
    { name: "Calhoun", bbox: [42.2092, -94.9145, 42.5603, -94.3975] },
    { name: "Carroll", bbox: [41.8624, -95.0929, 42.2104, -94.6287] },
    { name: "Cass", bbox: [41.1579, -95.1559, 41.5052, -94.7006] },
    { name: "Cedar", bbox: [41.5971, -91.3664, 41.9474, -90.8984] },
    { name: "Cerro Gordo", bbox: [42.9075, -93.4986, 43.2555, -93.0241] },
    { name: "Cherokee", bbox: [42.5606, -95.8599, 42.9099, -95.388] },
    { name: "Chickasaw", bbox: [42.907, -92.5544, 43.2129, -92.081] },
    { name: "Clarke", bbox: [40.897, -94.0148, 41.162, -93.5565] },
    { name: "Clay", bbox: [42.9097, -95.3882, 43.2552, -94.9137] },
    { name: "Clayton", bbox: [42.644, -91.6071, 43.0817, -90.897] },
    { name: "Clinton", bbox: [41.7291, -90.8985, 42.0335, -90.1406] },
    { name: "Crawford", bbox: [41.8631, -95.6728, 42.2114, -95.0909] },
    { name: "Dallas", bbox: [41.5031, -94.2803, 41.8634, -93.7906] },
    { name: "Davis", bbox: [40.5909, -92.6391, 40.8997, -92.179] },
    { name: "Decatur", bbox: [40.5739, -94.0155, 40.8983, -93.5565] },
    { name: "Delaware", bbox: [42.2958, -91.6071, 42.6458, -91.1301] },
    { name: "Des Moines", bbox: [40.6962, -91.4093, 41.0741, -90.9423] },
    { name: "Dickinson", bbox: [43.2551, -95.3881, 43.5009, -94.9137] },
    { name: "Dubuque", bbox: [42.2947, -91.1328, 42.6744, -90.4748] },
    { name: "Emmet", bbox: [43.255, -94.9148, 43.5006, -94.4428] },
    { name: "Fayette", bbox: [42.6421, -92.0817, 43.0828, -91.6053] },
    { name: "Floyd", bbox: [42.9071, -93.0251, 43.2128, -92.5542] },
    { name: "Franklin", bbox: [42.5568, -93.4995, 42.9085, -93.0251] },
    { name: "Fremont", bbox: [40.5805, -95.8889, 40.9017, -95.3739] },
    { name: "Greene", bbox: [41.8628, -94.6288, 42.2099, -94.1641] },
    { name: "Grundy", bbox: [42.2093, -93.027, 42.5568, -92.5335] },
    { name: "Guthrie", bbox: [41.5037, -94.7449, 41.863, -94.2416] },
    { name: "Hamilton", bbox: [42.2093, -93.9716, 42.5581, -93.4626] },
    { name: "Hancock", bbox: [42.9078, -93.9712, 43.2555, -93.4976] },
    { name: "Hardin", bbox: [42.2089, -93.4995, 42.5577, -93.0017] },
    { name: "Harrison", bbox: [41.5061, -96.1396, 41.8663, -95.4978] },
    { name: "Henry", bbox: [40.8126, -91.7188, 41.1628, -91.3703] },
    { name: "Howard", bbox: [43.2128, -92.5544, 43.5007, -92.0798] },
    { name: "Humboldt", bbox: [42.6447, -94.4431, 42.9081, -93.9712] },
    { name: "Ida", bbox: [42.2109, -95.7418, 42.5617, -95.3224] },
    { name: "Iowa", bbox: [41.5098, -92.2982, 41.8628, -91.8292] },
    { name: "Jackson", bbox: [42.0331, -90.8984, 42.3822, -90.1542] },
    { name: "Jasper", bbox: [41.5078, -93.3487, 41.8631, -92.7565] },
    { name: "Jefferson", bbox: [40.8997, -92.18, 41.1636, -91.7159] },
    { name: "Johnson", bbox: [41.4232, -91.8314, 41.8619, -91.3661] },
    { name: "Jones", bbox: [41.9462, -91.3658, 42.2964, -90.898] },
    { name: "Keokuk", bbox: [41.1619, -92.412, 41.5107, -91.9456] },
    { name: "Kossuth", bbox: [42.9078, -94.4431, 43.5006, -93.9704] },
    { name: "Lee", bbox: [40.3783, -91.7188, 40.8135, -91.1123] },
    { name: "Linn", bbox: [41.8601, -91.8314, 42.2991, -91.3633] },
    { name: "Louisa", bbox: [41.0727, -91.4857, 41.4238, -90.9466] },
    { name: "Lucas", bbox: [40.8983, -93.5576, 41.1613, -93.0976] },
    { name: "Lyon", bbox: [43.2492, -96.6029, 43.5005, -95.8609] },
    { name: "Madison", bbox: [41.1566, -94.2416, 41.5119, -93.7892] },
    { name: "Mahaska", bbox: [41.1611, -92.8714, 41.5095, -92.4102] },
    { name: "Marion", bbox: [41.1607, -93.3286, 41.5085, -92.8698] },
    { name: "Marshall", bbox: [41.8624, -93.2319, 42.2101, -92.766] },
    { name: "Mills", bbox: [40.9009, -95.8673, 41.1603, -95.3843] },
    { name: "Mitchell", bbox: [43.2128, -93.0243, 43.5003, -92.5531] },
    { name: "Monona", bbox: [41.8631, -96.3599, 42.2151, -95.6708] },
    { name: "Monroe", bbox: [40.8985, -93.0992, 41.1613, -92.6391] },
    { name: "Montgomery", bbox: [40.9007, -95.385, 41.16, -94.9276] },
    { name: "Muscatine", bbox: [41.3337, -91.3693, 41.5984, -90.7838] },
    { name: "O'Brien", bbox: [42.9091, -95.8619, 43.2576, -95.3881] },
    { name: "Osceola", bbox: [43.2552, -95.8619, 43.5006, -95.3878] },
    { name: "Page", bbox: [40.5751, -95.385, 40.9016, -94.9149] },
    { name: "Palo Alto", bbox: [42.9081, -94.9139, 43.2551, -94.443] },
    { name: "Plymouth", bbox: [42.5606, -96.6397, 42.9091, -95.8594] },
    { name: "Pocahontas", bbox: [42.5588, -94.9145, 42.9097, -94.443] },
    { name: "Polk", bbox: [41.4909, -93.8155, 41.8634, -93.3284] },
    { name: "Pottawattamie", bbox: [41.1592, -95.9813, 41.5068, -95.1547] },
    { name: "Poweshiek", bbox: [41.5088, -92.766, 41.8628, -92.2975] },
    { name: "Ringgold", bbox: [40.5708, -94.4712, 40.8995, -94.0148] },
    { name: "Sac", bbox: [42.2097, -95.388, 42.5617, -94.8567] },
    { name: "Scott", bbox: [41.4501, -90.8999, 41.7735, -90.317] },
    { name: "Shelby", bbox: [41.5047, -95.5581, 41.8634, -95.0407] },
    { name: "Sioux", bbox: [42.9091, -96.5725, 43.26, -95.8594] },
    { name: "Story", bbox: [41.8627, -93.6984, 42.2093, -93.2317] },
    { name: "Tama", bbox: [41.8624, -92.7681, 42.2975, -92.2982] },
    { name: "Taylor", bbox: [40.5707, -94.9285, 40.9007, -94.4708] },
    { name: "Union", bbox: [40.897, -94.4708, 41.1576, -94.0142] },
    { name: "Van Buren", bbox: [40.5985, -92.1798, 40.9008, -91.7168] },
    { name: "Wapello", bbox: [40.8989, -92.6404, 41.1627, -92.1791] },
    { name: "Warren", bbox: [41.1607, -93.7906, 41.5119, -93.3279] },
    { name: "Washington", bbox: [41.1615, -91.946, 41.5115, -91.484] },
    { name: "Wayne", bbox: [40.5799, -93.5569, 40.8985, -93.0973] },
    { name: "Webster", bbox: [42.2092, -94.4431, 42.6452, -93.9316] },
    { name: "Winnebago", bbox: [43.2554, -93.9708, 43.4996, -93.4973] },
    { name: "Winneshiek", bbox: [43.0817, -92.0811, 43.5008, -91.6053] },
    { name: "Woodbury", bbox: [42.2114, -96.4813, 42.5613, -95.6693] },
    { name: "Worth", bbox: [43.2555, -93.4976, 43.4996, -93.0241] },
    { name: "Wright", bbox: [42.5577, -93.9717, 42.9085, -93.4986] },
  ],
  ID: [
    { name: "Ada", bbox: [43.1126, -116.5134, 43.8072, -115.9749] },
    { name: "Adams", bbox: [44.4438, -116.8915, 45.2692, -116.0894] },
    { name: "Bannock", bbox: [42.2566, -112.7505, 43.0224, -111.8756] },
    { name: "Bear Lake", bbox: [41.9995, -111.6349, 42.6021, -111.0462] },
    { name: "Benewah", bbox: [47.0224, -117.04, 47.4147, -116.3295] },
    { name: "Bingham", bbox: [42.8631, -113.0078, 43.6266, -111.5878] },
    { name: "Blaine", bbox: [42.6253, -114.9894, 43.993, -113.0073] },
    { name: "Boise", bbox: [43.5913, -116.2817, 44.3394, -114.9908] },
    { name: "Bonner", bbox: [47.8902, -117.0419, 48.8474, -116.0484] },
    { name: "Bonneville", bbox: [43.0201, -112.52, 43.6267, -111.044] },
    { name: "Boundary", bbox: [48.5006, -117.0332, 49.0009, -116.049] },
    { name: "Butte", bbox: [43.2847, -113.798, 44.234, -112.695] },
    { name: "Camas", bbox: [43.1983, -115.0865, 43.8586, -114.3749] },
    { name: "Canyon", bbox: [43.2903, -117.0268, 43.88, -116.4735] },
    { name: "Caribou", bbox: [42.4158, -112.1498, 43.0224, -111.0439] },
    { name: "Cassia", bbox: [41.9881, -114.2854, 42.6879, -113.0008] },
    { name: "Clark", bbox: [43.9719, -112.9954, 44.5643, -111.6175] },
    { name: "Clearwater", bbox: [46.2657, -116.4559, 46.9345, -114.5947] },
    { name: "Custer", bbox: [43.5688, -115.3048, 44.8789, -113.3207] },
    { name: "Elmore", bbox: [42.7677, -116.2662, 44.0987, -114.9713] },
    { name: "Franklin", bbox: [41.9971, -112.1263, 42.4163, -111.5073] },
    { name: "Fremont", bbox: [43.8833, -112.1564, 44.7517, -111.0481] },
    { name: "Gem", bbox: [43.8069, -116.7127, 44.499, -116.1523] },
    { name: "Gooding", bbox: [42.6494, -115.0868, 43.1984, -114.5944] },
    { name: "Idaho", bbox: [45.1076, -116.7964, 46.6542, -114.3311] },
    { name: "Jefferson", bbox: [43.623, -112.6974, 44.0585, -111.6264] },
    { name: "Jerome", bbox: [42.495, -114.6174, 42.8508, -113.9318] },
    { name: "Kootenai", bbox: [47.3661, -117.0427, 47.9915, -116.3228] },
    { name: "Latah", bbox: [46.5418, -117.0398, 47.1273, -116.3293] },
    { name: "Lemhi", bbox: [44.2304, -114.8199, 45.7052, -112.8139] },
    { name: "Lewis", bbox: [45.9962, -116.7132, 46.4669, -116.0127] },
    { name: "Lincoln", bbox: [42.7645, -114.5947, 43.2, -113.7139] },
    { name: "Madison", bbox: [43.622, -111.9834, 43.9293, -111.3989] },
    { name: "Minidoka", bbox: [42.5353, -113.9329, 43.2, -113.413] },
    { name: "Nez Perce", bbox: [45.8538, -117.061, 46.6291, -116.3623] },
    { name: "Oneida", bbox: [41.9967, -113.0008, 42.503, -112.071] },
    { name: "Owyhee", bbox: [41.996, -117.027, 43.6809, -115.0377] },
    { name: "Payette", bbox: [43.7926, -116.9792, 44.1525, -116.452] },
    { name: "Power", bbox: [42.3275, -113.2435, 43.1111, -112.3796] },
    { name: "Shoshone", bbox: [46.9329, -116.3296, 48.0677, -114.9758] },
    { name: "Teton", bbox: [43.5011, -111.3999, 43.9831, -111.0452] },
    { name: "Twin Falls", bbox: [41.9943, -115.0383, 42.9119, -114.0007] },
    { name: "Valley", bbox: [44.1478, -116.2121, 45.2197, -114.6941] },
    { name: "Washington", bbox: [44.1511, -117.2149, 44.8405, -116.2998] },
  ],
  IL: [
    { name: "Adams", bbox: [39.7571, -91.513, 40.2011, -90.912] },
    { name: "Alexander", bbox: [36.9703, -89.5184, 37.3351, -89.1327] },
    { name: "Bond", bbox: [38.7405, -89.6393, 39.0282, -89.2504] },
    { name: "Boone", bbox: [42.1523, -88.9404, 42.495, -88.7056] },
    { name: "Brown", bbox: [39.8393, -90.9166, 40.1045, -90.5137] },
    { name: "Bureau", bbox: [41.1486, -89.8624, 41.5853, -89.1637] },
    { name: "Calhoun", bbox: [38.8688, -90.94, 39.3958, -90.4508] },
    { name: "Carroll", bbox: [41.9289, -90.3163, 42.1991, -89.6854] },
    { name: "Cass", bbox: [39.8729, -90.5835, 40.1242, -89.9944] },
    { name: "Champaign", bbox: [39.8791, -88.4622, 40.3994, -87.9329] },
    { name: "Christian", bbox: [39.3459, -89.535, 39.8257, -89.0254] },
    { name: "Clark", bbox: [39.1574, -88.0142, 39.4813, -87.5314] },
    { name: "Clay", bbox: [38.5995, -88.6985, 38.9153, -88.2539] },
    { name: "Clinton", bbox: [38.4157, -89.707, 38.7432, -89.1384] },
    { name: "Coles", bbox: [39.3745, -88.4721, 39.6859, -87.9602] },
    { name: "Cook", bbox: [41.4696, -88.2629, 42.1543, -87.524] },
    { name: "Crawford", bbox: [38.8495, -87.9504, 39.1792, -87.5122] },
    { name: "Cumberland", bbox: [39.1711, -88.4711, 39.379, -88.0078] },
    { name: "De Witt", bbox: [40.0489, -89.1488, 40.2821, -88.5749] },
    { name: "DeKalb", bbox: [41.6283, -88.9413, 42.1536, -88.5887] },
    { name: "Douglas", bbox: [39.6516, -88.4732, 39.8798, -87.9376] },
    { name: "DuPage", bbox: [41.6855, -88.2631, 41.994, -87.9143] },
    { name: "Edgar", bbox: [39.4771, -87.9666, 39.883, -87.5316] },
    { name: "Edwards", bbox: [38.2557, -88.1509, 38.5701, -87.9539] },
    { name: "Effingham", bbox: [38.9108, -88.8068, 39.2163, -88.3607] },
    { name: "Fayette", bbox: [38.7363, -89.2542, 39.2179, -88.6935] },
    { name: "Ford", bbox: [40.3989, -88.46, 40.9978, -87.9318] },
    { name: "Franklin", bbox: [37.862, -89.1776, 38.1252, -88.7046] },
    { name: "Fulton", bbox: [40.1839, -90.4515, 40.7147, -89.8725] },
    { name: "Gallatin", bbox: [37.5743, -88.3753, 37.9091, -88.0278] },
    { name: "Greene", bbox: [39.1176, -90.6137, 39.5217, -90.1481] },
    { name: "Grundy", bbox: [41.1083, -88.596, 41.4631, -88.2409] },
    { name: "Hamilton", bbox: [37.9068, -88.7066, 38.2567, -88.3705] },
    { name: "Hancock", bbox: [40.1931, -91.5103, 40.6392, -90.9042] },
    { name: "Hardin", bbox: [37.4049, -88.4151, 37.5999, -88.0613] },
    { name: "Henderson", bbox: [40.6358, -91.1854, 41.0702, -90.7852] },
    { name: "Henry", bbox: [41.149, -90.4377, 41.5847, -89.8566] },
    { name: "Iroquois", bbox: [40.4859, -88.1319, 41.0104, -87.5258] },
    { name: "Jackson", bbox: [37.5721, -89.6743, 37.9553, -89.1508] },
    { name: "Jasper", bbox: [38.8475, -88.3618, 39.1749, -87.9459] },
    { name: "Jefferson", bbox: [38.1247, -89.1497, 38.4749, -88.699] },
    { name: "Jersey", bbox: [38.9265, -90.6036, 39.2619, -90.146] },
    { name: "Jo Daviess", bbox: [42.1936, -90.6565, 42.5083, -89.9197] },
    { name: "Johnson", bbox: [37.3026, -89.0448, 37.5993, -88.7085] },
    { name: "Kane", bbox: [41.7196, -88.6019, 42.1543, -88.2384] },
    { name: "Kankakee", bbox: [40.9946, -88.252, 41.2981, -87.5263] },
    { name: "Kendall", bbox: [41.457, -88.6036, 41.7247, -88.2521] },
    { name: "Knox", bbox: [40.7123, -90.4443, 41.1513, -89.9846] },
    { name: "LaSalle", bbox: [40.9257, -89.1672, 41.6314, -88.5862] },
    { name: "Lake", bbox: [42.1524, -88.1996, 42.496, -87.7593] },
    { name: "Lawrence", bbox: [38.5682, -87.9123, 38.8525, -87.4952] },
    { name: "Lee", bbox: [41.5849, -89.6315, 41.9016, -88.9386] },
    { name: "Livingston", bbox: [40.6165, -88.9314, 41.1142, -88.2349] },
    { name: "Logan", bbox: [39.917, -89.603, 40.3253, -89.1435] },
    { name: "Macon", bbox: [39.6532, -89.2178, 40.0552, -88.7452] },
    { name: "Macoupin", bbox: [38.9983, -90.1538, 39.5234, -89.6986] },
    { name: "Madison", bbox: [38.6552, -90.2759, 39.0, -89.5951] },
    { name: "Marion", bbox: [38.4739, -89.1444, 38.8263, -88.6952] },
    { name: "Marshall", bbox: [40.9212, -89.6387, 41.1486, -89.0477] },
    { name: "Mason", bbox: [40.0525, -90.3552, 40.4359, -89.6016] },
    { name: "Massac", bbox: [37.0652, -88.9291, 37.3371, -88.4903] },
    { name: "McDonough", bbox: [40.2763, -90.9098, 40.6392, -90.4455] },
    { name: "McHenry", bbox: [42.1536, -88.7074, 42.496, -88.1988] },
    { name: "McLean", bbox: [40.2809, -89.2694, 40.7576, -88.4595] },
    { name: "Menard", bbox: [39.9019, -89.9947, 40.1549, -89.5783] },
    { name: "Mercer", bbox: [41.064, -91.1142, 41.3361, -90.4338] },
    { name: "Monroe", bbox: [38.0888, -90.3739, 38.5202, -89.8991] },
    { name: "Montgomery", bbox: [38.999, -89.7016, 39.5246, -89.1398] },
    { name: "Morgan", bbox: [39.5202, -90.5991, 39.8768, -89.926] },
    { name: "Moultrie", bbox: [39.447, -88.8127, 39.7921, -88.4705] },
    { name: "Ogle", bbox: [41.8881, -89.6885, 42.2042, -88.9397] },
    { name: "Peoria", bbox: [40.5131, -89.989, 40.9747, -89.4477] },
    { name: "Perry", bbox: [37.9503, -89.5951, 38.2193, -89.1296] },
    { name: "Piatt", bbox: [39.7918, -88.746, 40.2819, -88.4604] },
    { name: "Pike", bbox: [39.3936, -91.37, 39.8451, -90.567] },
    { name: "Pope", bbox: [37.0667, -88.7107, 37.5999, -88.4121] },
    { name: "Pulaski", bbox: [37.0682, -89.2736, 37.3351, -88.928] },
    { name: "Putnam", bbox: [41.1037, -89.4665, 41.3102, -89.1622] },
    { name: "Randolph", bbox: [37.8032, -90.2038, 38.2231, -89.5928] },
    { name: "Richland", bbox: [38.5691, -88.2586, 38.8501, -87.9081] },
    { name: "Rock Island", bbox: [41.327, -91.0787, 41.7838, -90.1648] },
    { name: "Saline", bbox: [37.5993, -88.7085, 37.9078, -88.3739] },
    { name: "Sangamon", bbox: [39.5221, -89.9945, 39.9761, -89.2175] },
    { name: "Schuyler", bbox: [39.9817, -90.9136, 40.2844, -90.1996] },
    { name: "Scott", bbox: [39.5202, -90.646, 39.7901, -90.3007] },
    { name: "Shelby", bbox: [39.215, -89.1401, 39.6542, -88.4705] },
    { name: "St. Clair", bbox: [38.2194, -90.2631, 38.6605, -89.7033] },
    { name: "Stark", bbox: [40.9737, -89.9855, 41.2345, -89.6384] },
    { name: "Stephenson", bbox: [42.1963, -89.9262, 42.5058, -89.3962] },
    { name: "Tazewell", bbox: [40.3192, -89.9247, 40.7483, -89.2637] },
    { name: "Union", bbox: [37.3298, -89.5217, 37.6005, -89.0414] },
    { name: "Vermilion", bbox: [39.8798, -87.9376, 40.4912, -87.5264] },
    { name: "Wabash", bbox: [38.2396, -87.9906, 38.5701, -87.6515] },
    { name: "Warren", bbox: [40.6278, -90.7897, 41.0687, -90.4394] },
    { name: "Washington", bbox: [38.2129, -89.7044, 38.5165, -89.1439] },
    { name: "Wayne", bbox: [38.2554, -88.7024, 38.6071, -88.1478] },
    { name: "White", bbox: [37.8881, -88.3745, 38.2598, -87.9108] },
    { name: "Whiteside", bbox: [41.584, -90.2427, 41.9303, -89.6289] },
    { name: "Will", bbox: [41.2015, -88.2615, 41.7289, -87.5256] },
    { name: "Williamson", bbox: [37.5966, -89.1537, 37.8633, -88.7068] },
    { name: "Winnebago", bbox: [42.1503, -89.4014, 42.5004, -88.9397] },
    { name: "Woodford", bbox: [40.5943, -89.555, 40.9277, -88.9293] },
  ],
  IN: [
    { name: "Adams", bbox: [40.5682, -85.0739, 40.9226, -84.8021] },
    { name: "Allen", bbox: [40.9166, -85.3386, 41.2713, -84.8029] },
    { name: "Bartholomew", bbox: [39.0409, -86.0856, 39.35, -85.6845] },
    { name: "Benton", bbox: [40.4757, -87.5265, 40.7369, -87.0937] },
    { name: "Blackford", bbox: [40.379, -85.447, 40.5672, -85.2011] },
    { name: "Boone", bbox: [39.9228, -86.6958, 40.1808, -86.2397] },
    { name: "Brown", bbox: [39.0484, -86.3814, 39.3442, -86.0803] },
    { name: "Carroll", bbox: [40.4319, -86.7713, 40.7375, -86.3735] },
    { name: "Cass", bbox: [40.5614, -86.5817, 40.9109, -86.165] },
    { name: "Clark", bbox: [38.2672, -85.9946, 38.6062, -85.4156] },
    { name: "Clay", bbox: [39.168, -87.2407, 39.6071, -86.94] },
    { name: "Clinton", bbox: [40.1772, -86.6958, 40.4322, -86.2424] },
    { name: "Crawford", bbox: [38.0818, -86.6814, 38.4229, -86.255] },
    { name: "Daviess", bbox: [38.5054, -87.2793, 38.9042, -86.9043] },
    { name: "DeKalb", bbox: [41.2642, -85.1941, 41.5301, -84.8036] },
    { name: "Dearborn", bbox: [38.9481, -85.1325, 39.3072, -84.8195] },
    { name: "Decatur", bbox: [39.1309, -85.6873, 39.4533, -85.2965] },
    { name: "Delaware", bbox: [40.0768, -85.5786, 40.3795, -85.2144] },
    { name: "Dubois", bbox: [38.2036, -87.0731, 38.5264, -86.6795] },
    { name: "Elkhart", bbox: [41.4358, -86.0626, 41.7603, -85.6535] },
    { name: "Fayette", bbox: [39.5255, -85.3016, 39.7884, -85.0346] },
    { name: "Floyd", bbox: [38.1803, -86.0328, 38.4191, -85.7608] },
    { name: "Fountain", bbox: [39.9525, -87.4388, 40.3666, -87.09] },
    { name: "Franklin", bbox: [39.2683, -85.2986, 39.5262, -84.8154] },
    { name: "Fulton", bbox: [40.9098, -86.4685, 41.1729, -85.9454] },
    { name: "Gibson", bbox: [38.1654, -87.9553, 38.5335, -87.316] },
    { name: "Grant", bbox: [40.3784, -85.8648, 40.6536, -85.4443] },
    { name: "Greene", bbox: [38.9025, -87.241, 39.1718, -86.6823] },
    { name: "Hamilton", bbox: [39.9261, -86.2427, 40.2189, -85.8619] },
    { name: "Hancock", bbox: [39.6971, -85.9517, 39.9458, -85.5762] },
    { name: "Harrison", bbox: [37.9926, -86.3143, 38.4227, -85.8996] },
    { name: "Hendricks", bbox: [39.6008, -86.6951, 39.924, -86.3263] },
    { name: "Henry", bbox: [39.7865, -85.5969, 40.0771, -85.2015] },
    { name: "Howard", bbox: [40.3737, -86.3758, 40.5655, -85.8621] },
    { name: "Huntington", bbox: [40.6531, -85.6438, 41.0052, -85.3347] },
    { name: "Jackson", bbox: [38.7344, -86.3181, 39.0685, -85.7954] },
    { name: "Jasper", bbox: [40.7365, -87.2759, 41.2862, -86.9296] },
    { name: "Jay", bbox: [40.3067, -85.22, 40.5722, -84.8023] },
    { name: "Jefferson", bbox: [38.5867, -85.6838, 38.9138, -85.2015] },
    { name: "Jennings", bbox: [38.8075, -85.7998, 39.1956, -85.4401] },
    { name: "Johnson", bbox: [39.3417, -86.2517, 39.6383, -85.9508] },
    { name: "Knox", bbox: [38.4157, -87.74, 38.908, -87.0988] },
    { name: "Kosciusko", bbox: [41.0426, -86.0776, 41.4369, -85.6519] },
    { name: "LaGrange", bbox: [41.5233, -85.6598, 41.7601, -85.1941] },
    { name: "LaPorte", bbox: [41.2368, -86.9327, 41.7603, -86.4864] },
    { name: "Lake", bbox: [41.1622, -87.5268, 41.7099, -87.2189] },
    { name: "Lawrence", bbox: [38.6866, -86.6831, 38.9924, -86.2753] },
    { name: "Madison", bbox: [39.9436, -85.8625, 40.3798, -85.5762] },
    { name: "Marion", bbox: [39.6322, -86.3266, 39.9271, -85.9376] },
    { name: "Marshall", bbox: [41.1714, -86.4671, 41.4792, -86.054] },
    { name: "Martin", bbox: [38.5054, -86.9242, 38.9047, -86.6824] },
    { name: "Miami", bbox: [40.5626, -86.169, 40.9992, -85.8636] },
    { name: "Monroe", bbox: [38.9909, -86.6856, 39.3469, -86.3174] },
    { name: "Montgomery", bbox: [39.8648, -87.0926, 40.2148, -86.6951] },
    { name: "Morgan", bbox: [39.3397, -86.6857, 39.6336, -86.2499] },
    { name: "Newton", bbox: [40.7366, -87.5267, 41.2186, -87.2673] },
    { name: "Noble", bbox: [41.2642, -85.6547, 41.5264, -85.1921] },
    { name: "Ohio", bbox: [38.9009, -85.1403, 39.0303, -84.8132] },
    { name: "Orange", bbox: [38.3941, -86.6831, 38.6881, -86.3079] },
    { name: "Owen", bbox: [39.1657, -87.0546, 39.4733, -86.6308] },
    { name: "Parke", bbox: [39.6048, -87.4202, 39.9534, -87.0095] },
    { name: "Perry", bbox: [37.8414, -86.8148, 38.2663, -86.4265] },
    { name: "Pike", bbox: [38.2326, -87.4629, 38.5449, -87.0724] },
    { name: "Porter", bbox: [41.2197, -87.2226, 41.711, -86.9294] },
    { name: "Posey", bbox: [37.7768, -88.0714, 38.23, -87.6884] },
    { name: "Pulaski", bbox: [40.9099, -86.9308, 41.1723, -86.467] },
    { name: "Putnam", bbox: [39.4701, -87.0145, 39.8667, -86.6566] },
    { name: "Randolph", bbox: [40.0044, -85.2188, 40.3101, -84.8039] },
    { name: "Ripley", bbox: [38.913, -85.4449, 39.3085, -85.0656] },
    { name: "Rush", bbox: [39.4528, -85.6335, 39.7876, -85.2976] },
    { name: "Scott", bbox: [38.5613, -85.8883, 38.8154, -85.57] },
    { name: "Shelby", bbox: [39.3474, -85.9532, 39.6985, -85.6293] },
    { name: "Spencer", bbox: [37.7825, -87.2696, 38.2051, -86.7724] },
    { name: "St. Joseph", bbox: [41.4328, -86.5267, 41.7606, -86.0595] },
    { name: "Starke", bbox: [41.1714, -86.9302, 41.433, -86.4666] },
    { name: "Steuben", bbox: [41.5264, -85.1968, 41.7601, -84.8047] },
    { name: "Sullivan", bbox: [38.9079, -87.6587, 39.2595, -87.2404] },
    { name: "Switzerland", bbox: [38.6876, -85.2032, 38.9306, -84.7851] },
    { name: "Tippecanoe", bbox: [40.2144, -87.0954, 40.5629, -86.6947] },
    { name: "Tipton", bbox: [40.2158, -86.243, 40.4069, -85.8612] },
    { name: "Union", bbox: [39.5219, -85.0361, 39.7266, -84.8141] },
    { name: "Vanderburgh", bbox: [37.8259, -87.7004, 38.1684, -87.4512] },
    { name: "Vermillion", bbox: [39.6073, -87.5332, 40.1481, -87.3539] },
    { name: "Vigo", bbox: [39.2591, -87.6101, 39.6079, -87.199] },
    { name: "Wabash", bbox: [40.651, -85.9464, 41.0467, -85.6386] },
    { name: "Warren", bbox: [40.1275, -87.5314, 40.4769, -87.0921] },
    { name: "Warrick", bbox: [37.8772, -87.4673, 38.2461, -87.0175] },
    { name: "Washington", bbox: [38.4179, -86.3087, 38.7834, -85.8479] },
    { name: "Wayne", bbox: [39.7148, -85.2211, 40.0051, -84.8107] },
    { name: "Wells", bbox: [40.5669, -85.449, 40.9178, -85.0685] },
    { name: "White", bbox: [40.5621, -87.0998, 40.9125, -86.5815] },
    { name: "Whitley", bbox: [41.0019, -85.6866, 41.2948, -85.3078] },
  ],
  KS: [
    { name: "Allen", bbox: [37.7325, -95.5255, 38.0382, -95.0779] },
    { name: "Anderson", bbox: [38.0377, -95.519, 38.3903, -95.0658] },
    { name: "Atchison", bbox: [39.4189, -95.5704, 39.653, -94.9691] },
    { name: "Barber", bbox: [36.998, -99.0126, 37.471, -98.3471] },
    { name: "Barton", bbox: [38.2608, -99.033, 38.6969, -98.4798] },
    { name: "Bourbon", bbox: [37.6731, -95.0881, 38.0377, -94.614] },
    { name: "Brown", bbox: [39.6529, -95.7889, 40.0005, -95.3397] },
    { name: "Butler", bbox: [37.4755, -97.1533, 38.0877, -96.5228] },
    { name: "Chase", bbox: [38.0856, -96.8408, 38.5225, -96.3538] },
    { name: "Chautauqua", bbox: [36.9989, -96.5255, 37.3027, -95.9643] },
    { name: "Cherokee", bbox: [36.9981, -95.0752, 37.3399, -94.6176] },
    { name: "Cheyenne", bbox: [39.5682, -102.0517, 40.0032, -101.411] },
    { name: "Clark", bbox: [36.9995, -100.1072, 37.4748, -99.5411] },
    { name: "Clay", bbox: [39.132, -97.3712, 39.567, -96.9589] },
    { name: "Cloud", bbox: [39.306, -97.9318, 39.654, -97.3684] },
    { name: "Coffey", bbox: [38.0382, -95.959, 38.4341, -95.5083] },
    { name: "Comanche", bbox: [36.9994, -99.5432, 37.3843, -99.0003] },
    { name: "Cowley", bbox: [36.9989, -97.1533, 37.4764, -96.5249] },
    { name: "Crawford", bbox: [37.3384, -95.0882, 37.6745, -94.6168] },
    { name: "Decatur", bbox: [39.5669, -100.7409, 40.0023, -100.1778] },
    { name: "Dickinson", bbox: [38.6091, -97.3719, 39.1323, -96.8902] },
    { name: "Doniphan", bbox: [39.6151, -95.3399, 40.0, -94.8953] },
    { name: "Douglas", bbox: [38.7386, -95.501, 39.0567, -95.0562] },
    { name: "Edwards", bbox: [37.733, -99.5699, 38.0876, -99.0133] },
    { name: "Elk", bbox: [37.2992, -96.5257, 37.607, -95.961] },
    { name: "Ellis", bbox: [38.6965, -99.5983, 39.1331, -99.0375] },
    { name: "Ellsworth", bbox: [38.5218, -98.4861, 38.8711, -97.9243] },
    { name: "Finney", bbox: [37.7363, -101.1038, 38.2646, -100.2266] },
    { name: "Ford", bbox: [37.4674, -100.2271, 37.914, -99.5561] },
    { name: "Franklin", bbox: [38.3899, -95.5083, 38.7388, -95.0564] },
    { name: "Geary", bbox: [38.8697, -96.9635, 39.2201, -96.5012] },
    { name: "Gove", bbox: [38.6973, -100.8187, 39.1334, -100.1479] },
    { name: "Graham", bbox: [39.1319, -100.1642, 39.5674, -99.6023] },
    { name: "Grant", bbox: [37.3877, -101.5271, 37.7363, -101.0897] },
    { name: "Gray", bbox: [37.4748, -100.6642, 38.0025, -100.2146] },
    { name: "Greeley", bbox: [38.2624, -102.0453, 38.6997, -101.5671] },
    { name: "Greenwood", bbox: [37.6038, -96.5253, 38.1727, -95.9586] },
    { name: "Hamilton", bbox: [37.7363, -102.0445, 38.2632, -101.5271] },
    { name: "Harper", bbox: [36.9978, -98.3498, 37.3863, -97.8023] },
    { name: "Harvey", bbox: [37.9113, -97.702, 38.1746, -97.1525] },
    { name: "Haskell", bbox: [37.3876, -101.0897, 37.7363, -100.6523] },
    { name: "Hodgeman", bbox: [37.913, -100.2271, 38.2622, -99.5695] },
    { name: "Jackson", bbox: [39.2161, -96.036, 39.653, -95.5641] },
    { name: "Jefferson", bbox: [39.0322, -95.5968, 39.4192, -95.1809] },
    { name: "Jewell", bbox: [39.5669, -98.5053, 40.0026, -97.9315] },
    { name: "Johnson", bbox: [38.7381, -95.0564, 39.0591, -94.6074] },
    { name: "Kearny", bbox: [37.7363, -101.5428, 38.2646, -101.0897] },
    { name: "Kingman", bbox: [37.3841, -98.465, 37.7339, -97.8071] },
    { name: "Kiowa", bbox: [37.3811, -99.5596, 37.7349, -99.0115] },
    { name: "Labette", bbox: [36.9992, -95.5224, 37.384, -95.0735] },
    { name: "Lane", bbox: [38.2623, -100.688, 38.7, -100.2444] },
    { name: "Leavenworth", bbox: [38.9816, -95.1871, 39.4192, -94.7939] },
    { name: "Lincoln", bbox: [38.8708, -98.4902, 39.2198, -97.9286] },
    { name: "Linn", bbox: [38.0371, -95.0779, 38.3899, -94.6126] },
    { name: "Logan", bbox: [38.6999, -101.4844, 39.1351, -100.8119] },
    { name: "Lyon", bbox: [38.1709, -96.3573, 38.7391, -95.9459] },
    { name: "Marion", bbox: [38.0856, -97.3719, 38.6094, -96.8197] },
    { name: "Marshall", bbox: [39.5662, -96.8065, 40.0014, -96.239] },
    { name: "McPherson", bbox: [38.1737, -97.9248, 38.6099, -97.3718] },
    { name: "Meade", bbox: [36.9999, -100.6527, 37.4752, -100.0895] },
    { name: "Miami", bbox: [38.3887, -95.0658, 38.7386, -94.6095] },
    { name: "Mitchell", bbox: [39.2193, -98.4901, 39.5675, -97.9285] },
    { name: "Montgomery", bbox: [36.9991, -95.9647, 37.3867, -95.518] },
    { name: "Morris", bbox: [38.5217, -96.9303, 38.8701, -96.3526] },
    { name: "Morton", bbox: [36.9931, -102.0422, 37.3892, -101.5553] },
    { name: "Nemaha", bbox: [39.5659, -96.2396, 40.0007, -95.7881] },
    { name: "Neosho", bbox: [37.3838, -95.5256, 37.7328, -95.088] },
    { name: "Ness", bbox: [38.2622, -100.2472, 38.6982, -99.5842] },
    { name: "Norton", bbox: [39.5669, -100.1804, 40.0019, -99.6253] },
    { name: "Osage", bbox: [38.4339, -95.9503, 38.87, -95.5007] },
    { name: "Osborne", bbox: [39.1327, -99.0477, 39.568, -98.4874] },
    { name: "Ottawa", bbox: [38.9579, -97.9316, 39.3065, -97.3698] },
    { name: "Pawnee", bbox: [38.0002, -99.5848, 38.3494, -98.9126] },
    { name: "Phillips", bbox: [39.5673, -99.628, 40.0022, -99.0662] },
    { name: "Pottawatomie", bbox: [39.1265, -96.7269, 39.5663, -96.0356] },
    { name: "Pratt", bbox: [37.4704, -99.0135, 37.8253, -98.4647] },
    { name: "Rawlins", bbox: [39.568, -101.4139, 40.0027, -100.7388] },
    { name: "Reno", bbox: [37.7327, -98.4728, 38.1738, -97.6987] },
    { name: "Republic", bbox: [39.6538, -97.9318, 40.0022, -97.3687] },
    { name: "Rice", bbox: [38.1728, -98.4804, 38.5228, -97.9221] },
    { name: "Riley", bbox: [39.0433, -96.9614, 39.5664, -96.3889] },
    { name: "Rooks", bbox: [39.1324, -99.6052, 39.5681, -99.0444] },
    { name: "Rush", bbox: [38.3483, -99.5851, 38.6968, -99.0324] },
    { name: "Russell", bbox: [38.6968, -99.0426, 39.1331, -98.4837] },
    { name: "Saline", bbox: [38.6094, -97.929, 38.9584, -97.3716] },
    { name: "Scott", bbox: [38.2642, -101.1284, 38.7006, -100.6846] },
    { name: "Sedgwick", bbox: [37.4742, -97.8078, 37.9127, -97.1525] },
    { name: "Seward", bbox: [36.9979, -101.0679, 37.3878, -100.6333] },
    { name: "Shawnee", bbox: [38.8698, -96.0391, 39.2165, -95.5003] },
    { name: "Sheridan", bbox: [39.1321, -100.7213, 39.568, -100.1617] },
    { name: "Sherman", bbox: [39.1331, -102.0498, 39.5684, -101.3891] },
    { name: "Smith", bbox: [39.5676, -99.067, 40.0025, -98.5045] },
    { name: "Stafford", bbox: [37.8245, -99.0226, 38.2611, -98.4723] },
    { name: "Stanton", bbox: [37.3884, -102.042, 37.7385, -101.5258] },
    { name: "Stevens", bbox: [36.9954, -101.5566, 37.3885, -101.0665] },
    { name: "Sumner", bbox: [36.9987, -97.8076, 37.4755, -97.1477] },
    { name: "Thomas", bbox: [39.1333, -101.3917, 39.5684, -100.7202] },
    { name: "Trego", bbox: [38.6965, -100.1538, 39.1325, -99.5918] },
    { name: "Wabaunsee", bbox: [38.739, -96.5016, 39.2123, -95.9459] },
    { name: "Wallace", bbox: [38.6976, -102.0472, 39.1348, -101.4782] },
    { name: "Washington", bbox: [39.5664, -97.3692, 40.0021, -96.8058] },
    { name: "Wichita", bbox: [38.2631, -101.5675, 38.7006, -101.1254] },
    { name: "Wilson", bbox: [37.384, -95.9616, 37.7343, -95.5255] },
    { name: "Woodson", bbox: [37.7328, -95.9609, 38.0402, -95.519] },
    { name: "Wyandotte", bbox: [38.9914, -94.9088, 39.2029, -94.5899] },
  ],
  KY: [
    { name: "Adair", bbox: [36.9251, -85.5269, 37.3104, -85.0433] },
    { name: "Allen", bbox: [36.6284, -86.4114, 36.934, -85.9764] },
    { name: "Anderson", bbox: [37.8915, -85.1678, 38.1291, -84.7963] },
    { name: "Ballard", bbox: [36.9195, -89.1825, 37.2299, -88.816] },
    { name: "Barren", bbox: [36.7227, -86.1667, 37.1698, -85.7393] },
    { name: "Bath", bbox: [37.9926, -83.9779, 38.2969, -83.4988] },
    { name: "Bell", bbox: [36.5826, -83.9573, 36.9558, -83.461] },
    { name: "Boone", bbox: [38.7773, -84.8974, 39.1475, -84.598] },
    { name: "Bourbon", bbox: [38.067, -84.4427, 38.3717, -83.9779] },
    { name: "Boyd", bbox: [38.2438, -82.8175, 38.5057, -82.5719] },
    { name: "Boyle", bbox: [37.5452, -85.0397, 37.7131, -84.6583] },
    { name: "Bracken", bbox: [38.5509, -84.23, 38.8276, -83.9039] },
    { name: "Breathitt", bbox: [37.3344, -83.5792, 37.6907, -82.9485] },
    { name: "Breckinridge", bbox: [37.5627, -86.6779, 38.0458, -86.1513] },
    { name: "Bullitt", bbox: [37.8118, -85.9383, 38.1184, -85.4288] },
    { name: "Butler", bbox: [36.9998, -86.9414, 37.3951, -86.3992] },
    { name: "Caldwell", bbox: [36.9601, -88.0958, 37.3794, -87.6806] },
    { name: "Calloway", bbox: [36.4971, -88.4891, 36.7503, -88.0325] },
    { name: "Campbell", bbox: [38.8066, -84.5061, 39.1025, -84.2321] },
    { name: "Carlisle", bbox: [36.7731, -89.1792, 36.9541, -88.8129] },
    { name: "Carroll", bbox: [38.5854, -85.3333, 38.7633, -84.9345] },
    { name: "Carter", bbox: [38.1751, -83.3413, 38.504, -82.7717] },
    { name: "Casey", bbox: [37.1023, -85.1652, 37.5479, -84.7207] },
    { name: "Christian", bbox: [36.6368, -87.7334, 37.1572, -87.2594] },
    { name: "Clark", bbox: [37.8376, -84.3374, 38.1151, -83.9663] },
    { name: "Clay", bbox: [36.9376, -83.969, 37.3581, -83.5079] },
    { name: "Clinton", bbox: [36.6143, -85.296, 36.8587, -84.9749] },
    { name: "Crittenden", bbox: [37.1473, -88.3584, 37.5472, -87.801] },
    { name: "Cumberland", bbox: [36.6182, -85.5962, 36.9381, -85.2154] },
    { name: "Daviess", bbox: [37.5608, -87.4085, 37.9302, -86.8175] },
    { name: "Edmonson", bbox: [37.0533, -86.4691, 37.3356, -86.0491] },
    { name: "Elliott", bbox: [38.007, -83.2633, 38.2645, -82.8891] },
    { name: "Estill", bbox: [37.5429, -84.0904, 37.8531, -83.7221] },
    { name: "Fayette", bbox: [37.8472, -84.6601, 38.2079, -84.2865] },
    { name: "Fleming", bbox: [38.171, -83.98, 38.5254, -83.4528] },
    { name: "Floyd", bbox: [37.2853, -82.9408, 37.7561, -82.5636] },
    { name: "Franklin", bbox: [38.1169, -85.0237, 38.3568, -84.7252] },
    { name: "Fulton", bbox: [36.4977, -89.5715, 36.6505, -88.8349] },
    { name: "Gallatin", bbox: [38.6621, -85.0242, 38.8559, -84.6601] },
    { name: "Garrard", bbox: [37.4727, -84.7449, 37.8262, -84.3478] },
    { name: "Grant", bbox: [38.473, -84.7858, 38.8029, -84.4763] },
    { name: "Graves", bbox: [36.5011, -88.8168, 36.9469, -88.4841] },
    { name: "Grayson", bbox: [37.3211, -86.6641, 37.6222, -86.0191] },
    { name: "Green", bbox: [37.1095, -85.6973, 37.4699, -85.3528] },
    { name: "Greenup", bbox: [38.3739, -83.1664, 38.7566, -82.6655] },
    { name: "Hancock", bbox: [37.6619, -86.9788, 37.9989, -86.6389] },
    { name: "Hardin", bbox: [37.4403, -86.2753, 38.0071, -85.6805] },
    { name: "Harlan", bbox: [36.6649, -83.5117, 37.0211, -82.8557] },
    { name: "Harrison", bbox: [38.2832, -84.5574, 38.582, -84.1021] },
    { name: "Hart", bbox: [37.1484, -86.1576, 37.4499, -85.6573] },
    { name: "Henderson", bbox: [37.6384, -87.9274, 37.9758, -87.2716] },
    { name: "Henry", bbox: [38.3356, -85.3461, 38.5968, -84.8705] },
    { name: "Hickman", bbox: [36.5028, -89.201, 36.7852, -88.8132] },
    { name: "Hopkins", bbox: [37.1053, -87.8508, 37.57, -87.296] },
    { name: "Jackson", bbox: [37.2506, -84.1995, 37.5814, -83.785] },
    { name: "Jefferson", bbox: [37.9988, -85.948, 38.3803, -85.4049] },
    { name: "Jessamine", bbox: [37.7287, -84.7234, 38.0037, -84.4357] },
    { name: "Johnson", bbox: [37.7163, -83.0046, 38.0004, -82.6124] },
    { name: "Kenton", bbox: [38.7912, -84.6237, 39.0951, -84.4181] },
    { name: "Knott", bbox: [37.1724, -83.1347, 37.5262, -82.7108] },
    { name: "Knox", bbox: [36.6873, -84.0919, 37.0549, -83.5811] },
    { name: "Larue", bbox: [37.422, -85.8928, 37.7323, -85.4663] },
    { name: "Laurel", bbox: [36.9395, -84.3682, 37.3198, -83.8713] },
    { name: "Lawrence", bbox: [37.8793, -83.0221, 38.2473, -82.4641] },
    { name: "Lee", bbox: [37.4868, -83.9056, 37.7201, -83.5223] },
    { name: "Leslie", bbox: [36.8954, -83.5513, 37.2957, -83.1821] },
    { name: "Letcher", bbox: [36.9542, -83.1504, 37.2715, -82.5654] },
    { name: "Lewis", bbox: [38.3195, -83.6467, 38.7256, -83.0309] },
    { name: "Lincoln", bbox: [37.2383, -84.8508, 37.6345, -84.4467] },
    { name: "Livingston", bbox: [36.9819, -88.5642, 37.4252, -88.1935] },
    { name: "Logan", bbox: [36.6434, -87.0608, 37.0736, -86.6116] },
    { name: "Lyon", bbox: [36.8672, -88.2404, 37.1797, -87.877] },
    { name: "Madison", bbox: [37.5229, -84.5256, 37.892, -84.0803] },
    { name: "Magoffin", bbox: [37.4865, -83.2697, 37.8641, -82.8787] },
    { name: "Marion", bbox: [37.4137, -85.5213, 37.7307, -85.0302] },
    { name: "Marshall", bbox: [36.7471, -88.4857, 37.0642, -88.1108] },
    { name: "Martin", bbox: [37.6688, -82.6709, 37.9523, -82.319] },
    { name: "Mason", bbox: [38.4563, -83.9916, 38.7681, -83.6419] },
    { name: "McCracken", bbox: [36.9421, -88.9421, 37.2288, -88.483] },
    { name: "McCreary", bbox: [36.5917, -84.7785, 36.9594, -84.2273] },
    { name: "McLean", bbox: [37.3918, -87.4953, 37.6836, -87.0383] },
    { name: "Meade", bbox: [37.7989, -86.4909, 38.1444, -85.9759] },
    { name: "Menifee", bbox: [37.8254, -83.7688, 38.0506, -83.4339] },
    { name: "Mercer", bbox: [37.6789, -85.0305, 37.9701, -84.6891] },
    { name: "Metcalfe", bbox: [36.818, -85.7442, 37.1824, -85.4518] },
    { name: "Monroe", bbox: [36.615, -85.9769, 36.8415, -85.4364] },
    { name: "Montgomery", bbox: [37.9184, -84.0805, 38.1921, -83.7594] },
    { name: "Morgan", bbox: [37.7127, -83.4951, 38.1154, -82.989] },
    { name: "Muhlenberg", bbox: [37.0406, -87.3888, 37.416, -86.8939] },
    { name: "Nelson", bbox: [37.5516, -85.7378, 37.9907, -85.1528] },
    { name: "Nicholas", bbox: [38.1921, -84.1941, 38.4594, -83.8484] },
    { name: "Ohio", bbox: [37.2123, -87.1031, 37.7378, -86.5928] },
    { name: "Oldham", bbox: [38.2853, -85.638, 38.5241, -85.2831] },
    { name: "Owen", bbox: [38.3524, -85.0746, 38.7205, -84.5805] },
    { name: "Owsley", bbox: [37.2585, -83.8853, 37.5375, -83.5269] },
    { name: "Pendleton", bbox: [38.5427, -84.5323, 38.8746, -84.2053] },
    { name: "Perry", bbox: [37.001, -83.5476, 37.4435, -83.0001] },
    { name: "Pike", bbox: [37.1961, -82.7327, 37.7408, -81.9683] },
    { name: "Powell", bbox: [37.7164, -84.002, 37.9308, -83.6311] },
    { name: "Pulaski", bbox: [36.8671, -84.9058, 37.3557, -84.2891] },
    { name: "Robertson", bbox: [38.4392, -84.1839, 38.5937, -83.9303] },
    { name: "Rockcastle", bbox: [37.1517, -84.5029, 37.5391, -84.1379] },
    { name: "Rowan", bbox: [38.034, -83.6352, 38.3818, -83.2443] },
    { name: "Russell", bbox: [36.8273, -85.275, 37.186, -84.8357] },
    { name: "Scott", bbox: [38.1164, -84.7406, 38.4929, -84.4018] },
    { name: "Shelby", bbox: [38.0373, -85.4682, 38.3581, -84.9977] },
    { name: "Simpson", bbox: [36.6335, -86.7633, 36.8831, -86.4005] },
    { name: "Spencer", bbox: [37.94, -85.4892, 38.1474, -85.1016] },
    { name: "Taylor", bbox: [37.1924, -85.5845, 37.4699, -85.0738] },
    { name: "Todd", bbox: [36.6415, -87.336, 37.0724, -87.0532] },
    { name: "Trigg", bbox: [36.6332, -88.1573, 37.0021, -87.6597] },
    { name: "Trimble", bbox: [38.4926, -85.457, 38.7405, -85.1683] },
    { name: "Union", bbox: [37.4801, -88.1602, 37.902, -87.7345] },
    { name: "Warren", bbox: [36.7762, -86.6745, 37.1839, -86.1135] },
    { name: "Washington", bbox: [37.6309, -85.4018, 37.8977, -85.0005] },
    { name: "Wayne", bbox: [36.6032, -85.0643, 36.9976, -84.5782] },
    { name: "Webster", bbox: [37.3506, -87.933, 37.6475, -87.3751] },
    { name: "Whitley", bbox: [36.5882, -84.35, 36.956, -83.8775] },
    { name: "Wolfe", bbox: [37.6385, -83.708, 37.8619, -83.2436] },
    { name: "Woodford", bbox: [37.862, -84.8649, 38.1954, -84.6251] },
  ],
  LA: [
    { name: "Acadia", bbox: [30.0494, -92.632, 30.4811, -92.1422] },
    { name: "Allen", bbox: [30.4236, -93.1312, 30.8961, -92.5974] },
    { name: "Ascension", bbox: [30.0625, -91.106, 30.3452, -90.6328] },
    { name: "Assumption", bbox: [29.6264, -91.2594, 30.0664, -90.8856] },
    { name: "Avoyelles", bbox: [30.8481, -92.2807, 31.3354, -91.6773] },
    { name: "Beauregard", bbox: [30.4025, -93.7417, 30.8782, -92.9769] },
    { name: "Bienville", bbox: [32.1469, -93.4282, 32.5853, -92.7749] },
    { name: "Bossier", bbox: [32.2359, -93.8426, 33.0194, -93.3728] },
    { name: "Caddo", bbox: [32.1955, -94.0431, 33.0194, -93.4712] },
    { name: "Calcasieu", bbox: [30.0385, -93.7658, 30.4905, -92.8876] },
    { name: "Caldwell", bbox: [31.9273, -92.3126, 32.2774, -91.8897] },
    { name: "Cameron", bbox: [29.5791, -93.8985, 30.0526, -92.6156] },
    { name: "Catahoula", bbox: [31.2296, -92.0081, 31.9715, -91.5448] },
    { name: "Claiborne", bbox: [32.5849, -93.2386, 33.018, -92.7247] },
    { name: "Concordia", bbox: [30.9704, -91.8622, 31.7619, -91.3799] },
    { name: "De Soto", bbox: [31.8443, -94.0427, 32.3402, -93.3555] },
    { name: "East Baton Rouge", bbox: [30.3199, -91.2977, 30.7193, -90.849] },
    { name: "East Carroll", bbox: [32.5378, -91.4576, 33.0051, -91.0545] },
    { name: "East Feliciana", bbox: [30.6495, -91.3207, 30.9994, -90.8258] },
    { name: "Evangeline", bbox: [30.4805, -92.6338, 31.0014, -92.1726] },
    { name: "Franklin", bbox: [31.8825, -91.8947, 32.4058, -91.4767] },
    { name: "Grant", bbox: [31.3905, -92.9735, 31.7971, -92.1961] },
    { name: "Iberia", bbox: [29.4739, -92.0412, 30.1085, -91.2244] },
    { name: "Iberville", bbox: [30.0253, -91.7009, 30.4974, -91.021] },
    { name: "Jackson", bbox: [32.1461, -92.8147, 32.4964, -92.3118] },
    { name: "Jefferson", bbox: [29.432, -90.2803, 30.2309, -89.962] },
    { name: "Jefferson Davis", bbox: [30.0373, -93.1312, 30.4882, -92.5911] },
    { name: "La Salle", bbox: [31.3258, -92.3844, 31.9274, -92.0054] },
    { name: "Lafayette", bbox: [30.0369, -92.2847, 30.3782, -91.9055] },
    { name: "Lafourche", bbox: [29.0571, -91.0067, 29.9216, -89.9499] },
    { name: "Lincoln", bbox: [32.453, -92.8808, 32.7595, -92.415] },
    { name: "Livingston", bbox: [30.1766, -90.9915, 30.65, -90.4013] },
    { name: "Madison", bbox: [32.2025, -91.5267, 32.5627, -90.8986] },
    { name: "Morehouse", bbox: [32.5059, -92.0691, 33.0082, -91.4358] },
    { name: "Natchitoches", bbox: [31.3466, -93.4417, 32.1484, -92.719] },
    { name: "Orleans", bbox: [29.8685, -90.1401, 30.1992, -89.6229] },
    { name: "Ouachita", bbox: [32.2771, -92.4154, 32.723, -91.911] },
    { name: "Plaquemines", bbox: [28.925, -90.0757, 29.8955, -89.0007] },
    { name: "Pointe Coupee", bbox: [30.4971, -91.8153, 31.0188, -91.3309] },
    { name: "Rapides", bbox: [30.89, -92.9815, 31.5176, -92.0867] },
    { name: "Red River", bbox: [31.9035, -93.6147, 32.2375, -93.1227] },
    { name: "Richland", bbox: [32.1516, -92.0344, 32.6673, -91.431] },
    { name: "Sabine", bbox: [31.1656, -93.8782, 31.8452, -93.2361] },
    { name: "St. Bernard", bbox: [29.621, -90.0121, 30.0791, -88.817] },
    { name: "St. Charles", bbox: [29.692, -90.5419, 30.2309, -90.1732] },
    { name: "St. Helena", bbox: [30.6494, -90.9107, 30.9997, -90.5659] },
    { name: "St. James", bbox: [29.8892, -90.9637, 30.1664, -90.642] },
    { name: "St. John the Baptist", bbox: [29.8892, -90.6889, 30.2937, -90.2779] },
    { name: "St. Landry", bbox: [30.2988, -92.4933, 30.8486, -91.6789] },
    { name: "St. Martin", bbox: [29.6994, -91.9887, 30.4977, -91.0927] },
    { name: "St. Mary", bbox: [29.4724, -91.881, 29.956, -91.0826] },
    { name: "St. Tammany", bbox: [30.1499, -90.2556, 30.7119, -89.5245] },
    { name: "Tangipahoa", bbox: [30.2244, -90.5672, 31.0004, -90.243] },
    { name: "Tensas", bbox: [31.733, -91.5757, 32.2493, -91.0269] },
    { name: "Terrebonne", bbox: [29.0366, -91.3349, 29.7759, -90.3767] },
    { name: "Union", bbox: [32.581, -92.7254, 33.0144, -92.0652] },
    { name: "Vermilion", bbox: [29.533, -92.7386, 30.1474, -91.9645] },
    { name: "Vernon", bbox: [30.8775, -93.5546, 31.3645, -92.8239] },
    { name: "Washington", bbox: [30.6654, -90.3472, 31.0048, -89.7281] },
    { name: "Webster", bbox: [32.4101, -93.5304, 33.0186, -93.1472] },
    { name: "West Baton Rouge", bbox: [30.3225, -91.4851, 30.6587, -91.1421] },
    { name: "West Carroll", bbox: [32.582, -91.6376, 33.0061, -91.265] },
    { name: "West Feliciana", bbox: [30.654, -91.6625, 30.9994, -91.1761] },
    { name: "Winn", bbox: [31.7089, -92.9735, 32.1479, -92.3122] },
  ],
  MA: [
    { name: "Barnstable", bbox: [41.5133, -70.6948, 42.0823, -69.9283] },
    { name: "Berkshire", bbox: [42.0399, -73.5081, 42.7459, -72.9497] },
    { name: "Bristol", bbox: [41.4974, -71.3817, 42.0957, -70.8209] },
    { name: "Dukes", bbox: [41.301, -70.951, 41.5256, -70.4462] },
    { name: "Essex", bbox: [42.4162, -71.2561, 42.8866, -70.5915] },
    { name: "Franklin", bbox: [42.3033, -73.0229, 42.7411, -72.2248] },
    { name: "Hampden", bbox: [41.9976, -73.0712, 42.3326, -72.135] },
    { name: "Hampshire", bbox: [42.1834, -73.0001, 42.5559, -72.2034] },
    { name: "Middlesex", bbox: [42.1568, -71.8987, 42.7341, -71.0204] },
    { name: "Nantucket", bbox: [41.238, -70.2755, 41.3917, -69.9602] },
    { name: "Norfolk", bbox: [41.985, -71.5009, 42.3281, -70.9063] },
    { name: "Plymouth", bbox: [41.6245, -71.0802, 42.3089, -70.5256] },
    { name: "Suffolk", bbox: [42.2279, -71.1912, 42.4448, -70.953] },
    { name: "Worcester", bbox: [42.0081, -72.3146, 42.722, -71.4781] },
  ],
  MD: [
    { name: "Allegany", bbox: [39.4415, -79.0679, 39.7228, -78.334] },
    { name: "Anne Arundel", bbox: [38.7136, -76.8404, 39.2374, -76.3941] },
    { name: "Baltimore", bbox: [39.1954, -76.8823, 39.7212, -76.3237] },
    { name: "Calvert", bbox: [38.3051, -76.702, 38.7673, -76.3862] },
    { name: "Caroline", bbox: [38.6354, -76.015, 39.1433, -75.7074] },
    { name: "Carroll", bbox: [39.3502, -77.2877, 39.7208, -76.7871] },
    { name: "Cecil", bbox: [39.3608, -76.2333, 39.7219, -75.7667] },
    { name: "Charles", bbox: [38.2545, -77.2742, 38.7058, -76.663] },
    { name: "Dorchester", bbox: [38.1145, -76.3364, 38.6862, -75.7016] },
    { name: "Frederick", bbox: [39.2203, -77.6775, 39.72, -77.1068] },
    { name: "Garrett", bbox: [39.206, -79.4877, 39.7228, -78.9312] },
    { name: "Harford", bbox: [39.3021, -76.5695, 39.7213, -76.0609] },
    { name: "Howard", bbox: [39.1031, -77.1868, 39.354, -76.6971] },
    { name: "Kent", bbox: [39.01, -76.2785, 39.3825, -75.756] },
    { name: "Montgomery", bbox: [38.9343, -77.5273, 39.3535, -76.8885] },
    { name: "Prince George's", bbox: [38.5359, -77.0861, 39.131, -76.6723] },
    { name: "Queen Anne's", bbox: [38.8361, -76.3762, 39.2595, -75.7477] },
    { name: "Somerset", bbox: [37.9117, -76.0593, 38.2852, -75.5409] },
    { name: "St. Mary's", bbox: [38.0365, -76.8718, 38.5137, -76.3195] },
    { name: "Talbot", bbox: [38.5739, -76.348, 38.9443, -75.8968] },
    { name: "Washington", bbox: [39.3187, -78.3428, 39.7227, -77.4691] },
    { name: "Wicomico", bbox: [38.228, -75.9286, 38.5607, -75.307] },
    { name: "Worcester", bbox: [37.9942, -75.6618, 38.452, -75.0489] },
  ],
  ME: [
    { name: "Androscoggin", bbox: [43.9265, -70.4801, 44.4872, -69.9938] },
    { name: "Aroostook", bbox: [45.5728, -70.023, 47.4597, -67.7638] },
    { name: "Cumberland", bbox: [43.5354, -70.8218, 44.171, -69.857] },
    { name: "Franklin", bbox: [44.4589, -70.8316, 45.6619, -69.9305] },
    { name: "Hancock", bbox: [44.0997, -68.8469, 45.2526, -67.9571] },
    { name: "Kennebec", bbox: [44.1077, -70.1294, 44.6988, -69.3931] },
    { name: "Knox", bbox: [43.821, -69.5282, 44.3647, -68.5841] },
    { name: "Lincoln", bbox: [43.7559, -69.8135, 44.2796, -69.2818] },
    { name: "Oxford", bbox: [43.7922, -71.0843, 45.3363, -70.2389] },
    { name: "Penobscot", bbox: [44.644, -69.3557, 46.3958, -67.9398] },
    { name: "Piscataquis", bbox: [45.011, -69.8328, 46.5741, -68.7761] },
    { name: "Sagadahoc", bbox: [43.7036, -70.0518, 44.1679, -69.6897] },
    { name: "Somerset", bbox: [44.5773, -70.551, 46.5741, -69.2668] },
    { name: "Waldo", bbox: [44.2187, -69.5064, 44.7446, -68.7962] },
    { name: "Washington", bbox: [44.3941, -68.105, 45.6802, -66.9499] },
    { name: "York", bbox: [43.0596, -70.989, 43.8141, -70.3497] },
  ],
  MI: [
    { name: "Alcona", bbox: [44.509, -83.8885, 44.8585, -83.2734] },
    { name: "Alger", bbox: [46.1587, -87.1166, 46.6909, -85.8645] },
    { name: "Allegan", bbox: [42.4193, -86.2739, 42.7682, -85.5432] },
    { name: "Alpena", bbox: [44.8565, -83.8885, 45.2071, -83.2659] },
    { name: "Antrim", bbox: [44.8124, -85.4423, 45.2076, -84.8473] },
    { name: "Arenac", bbox: [43.9105, -84.1664, 44.1635, -83.5652] },
    { name: "Baraga", bbox: [46.42, -88.6794, 46.9667, -87.9915] },
    { name: "Barry", bbox: [42.4198, -85.5456, 42.7708, -85.0716] },
    { name: "Bay", bbox: [43.479, -84.1681, 43.997, -83.6988] },
    { name: "Benzie", bbox: [44.513, -86.259, 44.7784, -85.8151] },
    { name: "Berrien", bbox: [41.7594, -86.8248, 42.2434, -86.2229] },
    { name: "Branch", bbox: [41.7594, -85.2936, 42.0725, -84.8251] },
    { name: "Calhoun", bbox: [42.0704, -85.2995, 42.4215, -84.7096] },
    { name: "Cass", bbox: [41.7591, -86.2261, 42.0715, -85.7602] },
    { name: "Charlevoix", bbox: [45.1149, -85.63, 45.7602, -84.7327] },
    { name: "Cheboygan", bbox: [45.1987, -84.7344, 45.7879, -84.2042] },
    { name: "Chippewa", bbox: [45.9126, -85.2379, 46.7728, -83.4732] },
    { name: "Clare", bbox: [43.8137, -85.0888, 44.1642, -84.606] },
    { name: "Clinton", bbox: [42.7699, -84.8371, 43.1189, -84.3637] },
    { name: "Crawford", bbox: [44.5072, -84.8509, 44.858, -84.3706] },
    { name: "Delta", bbox: [45.5501, -87.3678, 46.1589, -86.4599] },
    { name: "Dickinson", bbox: [45.7228, -88.1361, 46.2468, -87.6159] },
    { name: "Eaton", bbox: [42.4214, -85.0742, 42.7708, -84.6004] },
    { name: "Emmet", bbox: [45.2787, -85.1197, 45.7893, -84.7324] },
    { name: "Genesee", bbox: [42.7808, -83.9321, 43.2231, -83.4534] },
    { name: "Gladwin", bbox: [43.8152, -84.6081, 44.1618, -84.1661] },
    { name: "Gogebic", bbox: [46.0973, -90.4181, 46.7658, -88.9906] },
    { name: "Grand Traverse", bbox: [44.5123, -85.8178, 44.9911, -85.3328] },
    { name: "Gratiot", bbox: [43.1179, -84.846, 43.4662, -84.3678] },
    { name: "Hillsdale", bbox: [41.6961, -84.8265, 42.0735, -84.3604] },
    { name: "Houghton", bbox: [46.4197, -88.9912, 47.2861, -88.2276] },
    { name: "Huron", bbox: [43.6676, -83.4674, 44.0705, -82.6062] },
    { name: "Ingham", bbox: [42.422, -84.6028, 42.7766, -84.1407] },
    { name: "Ionia", bbox: [42.7699, -85.3125, 43.1189, -84.8369] },
    { name: "Iosco", bbox: [44.1618, -83.8866, 44.5117, -83.3176] },
    { name: "Iron", bbox: [45.9186, -88.9912, 46.4201, -88.1166] },
    { name: "Isabella", bbox: [43.466, -85.0888, 43.8152, -84.606] },
    { name: "Jackson", bbox: [42.0704, -84.7185, 42.4246, -84.1311] },
    { name: "Kalamazoo", bbox: [42.0693, -85.7644, 42.4214, -85.2936] },
    { name: "Kalkaska", bbox: [44.5111, -85.334, 44.8596, -84.8473] },
    { name: "Kent", bbox: [42.7681, -85.7907, 43.2943, -85.3096] },
    { name: "Keweenaw", bbox: [47.1998, -89.2552, 48.191, -87.7105] },
    { name: "Lake", bbox: [43.8156, -86.042, 44.1671, -85.5624] },
    { name: "Lapeer", bbox: [42.8804, -83.4607, 43.327, -82.9836] },
    { name: "Leelanau", bbox: [44.7745, -86.1567, 45.2107, -85.5267] },
    { name: "Lenawee", bbox: [41.7069, -84.3633, 42.0824, -83.7632] },
    { name: "Livingston", bbox: [42.4241, -84.1582, 42.7833, -83.6648] },
    { name: "Luce", bbox: [46.2446, -85.865, 46.7557, -85.2378] },
    { name: "Mackinac", bbox: [45.7217, -85.8654, 46.2457, -84.1143] },
    { name: "Macomb", bbox: [42.4472, -83.1029, 42.8975, -82.7078] },
    { name: "Manistee", bbox: [44.1642, -86.3869, 44.5183, -85.8178] },
    { name: "Marquette", bbox: [45.9851, -88.1174, 46.9125, -87.1161] },
    { name: "Mason", bbox: [43.8156, -86.5147, 44.1787, -86.0379] },
    { name: "Mecosta", bbox: [43.4662, -85.5624, 43.8156, -85.085] },
    { name: "Menominee", bbox: [45.0953, -87.8881, 45.986, -87.2644] },
    { name: "Midland", bbox: [43.466, -84.6075, 43.8259, -84.1673] },
    { name: "Missaukee", bbox: [44.1614, -85.3348, 44.5123, -84.8509] },
    { name: "Monroe", bbox: [41.7239, -83.7739, 42.0942, -83.1815] },
    { name: "Montcalm", bbox: [43.1188, -85.5625, 43.4682, -84.8369] },
    { name: "Montmorency", bbox: [44.855, -84.3718, 45.2021, -83.8812] },
    { name: "Muskegon", bbox: [43.1184, -86.4622, 43.4723, -85.7904] },
    { name: "Newaygo", bbox: [43.293, -86.0395, 43.8156, -85.5624] },
    { name: "Oakland", bbox: [42.4312, -83.6894, 42.8886, -83.0834] },
    { name: "Oceana", bbox: [43.4674, -86.5409, 43.8196, -86.0379] },
    { name: "Ogemaw", bbox: [44.1605, -84.3706, 44.509, -83.884] },
    { name: "Ontonagon", bbox: [46.333, -89.8887, 47.0322, -88.8639] },
    { name: "Osceola", bbox: [43.8137, -85.5646, 44.1651, -85.087] },
    { name: "Oscoda", bbox: [44.5072, -84.3718, 44.8565, -83.8866] },
    { name: "Otsego", bbox: [44.855, -84.8575, 45.2019, -84.3668] },
    { name: "Ottawa", bbox: [42.7675, -86.272, 43.2059, -85.7825] },
    { name: "Presque Isle", bbox: [45.1987, -84.252, 45.6271, -83.3817] },
    { name: "Roscommon", bbox: [44.1605, -84.8558, 44.5111, -84.3663] },
    { name: "Saginaw", bbox: [43.1285, -84.3699, 43.5689, -83.6956] },
    { name: "Sanilac", bbox: [43.1541, -83.1204, 43.6904, -82.5032] },
    { name: "Schoolcraft", bbox: [45.7569, -86.6156, 46.5059, -85.8649] },
    { name: "Shiawassee", bbox: [42.7758, -84.3679, 43.1328, -83.9225] },
    { name: "St. Clair", bbox: [42.5186, -82.9963, 43.1689, -82.4159] },
    { name: "St. Joseph", bbox: [41.759, -85.7913, 42.0716, -85.2922] },
    { name: "Tuscola", bbox: [43.2214, -83.6994, 43.7289, -83.1038] },
    { name: "Van Buren", bbox: [42.0693, -86.3649, 42.4207, -85.7629] },
    { name: "Washtenaw", bbox: [42.0716, -84.132, 42.4352, -83.5394] },
    { name: "Wayne", bbox: [42.0294, -83.5519, 42.4512, -82.8703] },
    { name: "Wexford", bbox: [44.1642, -85.8212, 44.513, -85.334] },
  ],
  MN: [
    { name: "Aitkin", bbox: [46.154, -93.8115, 47.0304, -93.0539] },
    { name: "Anoka", bbox: [45.0354, -93.5126, 45.4148, -93.0194] },
    { name: "Becker", bbox: [46.7163, -96.1947, 47.1525, -95.163] },
    { name: "Beltrami", bbox: [47.4095, -95.6023, 48.5402, -94.4163] },
    { name: "Benton", bbox: [45.5591, -94.3532, 45.8221, -93.7594] },
    { name: "Big Stone", bbox: [45.1767, -96.8355, 45.5861, -96.1036] },
    { name: "Blue Earth", bbox: [43.8479, -94.3717, 44.2644, -93.7678] },
    { name: "Brown", bbox: [44.108, -95.1088, 44.4982, -94.3688] },
    { name: "Carlton", bbox: [46.4172, -93.0615, 46.7666, -92.2916] },
    { name: "Carver", bbox: [44.6403, -94.0122, 44.9787, -93.5204] },
    { name: "Cass", bbox: [46.2777, -94.7871, 47.478, -93.7739] },
    { name: "Chippewa", bbox: [44.7525, -96.0367, 45.1524, -95.2465] },
    { name: "Chisago", bbox: [45.296, -93.142, 45.7307, -92.6641] },
    { name: "Clay", bbox: [46.6304, -96.8267, 47.1511, -96.1723] },
    { name: "Clearwater", bbox: [47.1515, -95.5829, 48.0206, -95.1692] },
    { name: "Cook", bbox: [47.465, -91.0329, 48.2458, -89.4892] },
    { name: "Cottonwood", bbox: [43.8479, -95.4625, 44.1959, -94.8594] },
    { name: "Crow Wing", bbox: [46.1566, -94.3746, 46.8055, -93.776] },
    { name: "Dakota", bbox: [44.4719, -93.3296, 44.9196, -92.732] },
    { name: "Dodge", bbox: [43.8485, -93.046, 44.1967, -92.6784] },
    { name: "Douglas", bbox: [45.7589, -95.7698, 46.1075, -95.1397] },
    { name: "Faribault", bbox: [43.4995, -94.248, 43.8481, -93.6483] },
    { name: "Fillmore", bbox: [43.5004, -92.4491, 43.8483, -91.7302] },
    { name: "Freeborn", bbox: [43.4994, -93.6485, 43.8484, -93.0492] },
    { name: "Goodhue", bbox: [44.1949, -93.0412, 44.7138, -92.242] },
    { name: "Grant", bbox: [45.7598, -96.2661, 46.1086, -95.7585] },
    { name: "Hennepin", bbox: [44.7911, -93.7674, 45.2466, -93.1785] },
    { name: "Houston", bbox: [43.5004, -91.7305, 43.8471, -91.2177] },
    { name: "Hubbard", bbox: [46.8037, -95.1832, 47.4128, -94.6599] },
    { name: "Isanti", bbox: [45.4118, -93.5137, 45.7343, -93.0196] },
    { name: "Itasca", bbox: [47.0264, -94.419, 47.8989, -93.0559] },
    { name: "Jackson", bbox: [43.5002, -95.4544, 43.8481, -94.8544] },
    { name: "Kanabec", bbox: [45.7307, -93.5181, 46.1581, -93.0539] },
    { name: "Kandiyohi", bbox: [44.8913, -95.2552, 45.4129, -94.7582] },
    { name: "Kittson", bbox: [48.544, -97.2392, 49.0007, -96.3878] },
    { name: "Koochiching", bbox: [47.8458, -94.4319, 48.7119, -93.0812] },
    { name: "Lac qui Parle", bbox: [44.8053, -96.4529, 45.2689, -95.737] },
    { name: "Lake", bbox: [46.9397, -91.7991, 48.2045, -91.0207] },
    { name: "Lake of the Woods", bbox: [48.366, -95.3427, 49.3844, -94.4287] },
    { name: "Le Sueur", bbox: [44.1958, -94.0118, 44.5436, -93.5243] },
    { name: "Lincoln", bbox: [44.1966, -96.4528, 44.6313, -96.0786] },
    { name: "Lyon", bbox: [44.1955, -96.093, 44.6305, -95.5936] },
    { name: "Mahnomen", bbox: [47.1515, -96.0676, 47.5003, -95.5512] },
    { name: "Marshall", bbox: [48.1729, -97.1631, 48.5443, -95.5938] },
    { name: "Martin", bbox: [43.5003, -94.8546, 43.8481, -94.2471] },
    { name: "McLeod", bbox: [44.6299, -94.5024, 44.9797, -94.0105] },
    { name: "Meeker", bbox: [44.8921, -94.7631, 45.3267, -94.2561] },
    { name: "Mille Lacs", bbox: [45.5588, -93.8109, 46.2464, -93.4306] },
    { name: "Morrison", bbox: [45.7739, -94.6535, 46.3487, -93.7639] },
    { name: "Mower", bbox: [43.4995, -93.0495, 43.8486, -92.4489] },
    { name: "Murray", bbox: [43.8479, -96.0646, 44.1964, -95.4624] },
    { name: "Nicollet", bbox: [44.154, -94.7806, 44.4567, -93.9296] },
    { name: "Nobles", bbox: [43.4999, -96.0532, 43.8491, -95.4525] },
    { name: "Norman", bbox: [47.1505, -96.8623, 47.4995, -96.0671] },
    { name: "Olmsted", bbox: [43.8341, -92.6894, 44.1955, -92.0793] },
    { name: "Otter Tail", bbox: [46.1068, -96.281, 46.7179, -95.1459] },
    { name: "Pennington", bbox: [47.934, -96.5008, 48.1741, -95.5822] },
    { name: "Pine", bbox: [45.73, -93.1429, 46.4193, -92.2928] },
    { name: "Pipestone", bbox: [43.849, -96.4534, 44.197, -96.0638] },
    { name: "Polk", bbox: [47.499, -97.1475, 48.1741, -95.5542] },
    { name: "Pope", bbox: [45.4123, -95.7585, 45.7599, -95.1317] },
    { name: "Ramsey", bbox: [44.8883, -93.2277, 45.1245, -92.9842] },
    { name: "Red Lake", bbox: [47.7603, -96.4826, 47.9643, -95.7091] },
    { name: "Redwood", bbox: [44.195, -95.5948, 44.6985, -94.8658] },
    { name: "Renville", bbox: [44.456, -95.4829, 44.8923, -94.4977] },
    { name: "Rice", bbox: [44.196, -93.5252, 44.544, -93.0395] },
    { name: "Rock", bbox: [43.5002, -96.4534, 43.8495, -96.0523] },
    { name: "Roseau", bbox: [48.5385, -96.4054, 48.9998, -95.0899] },
    { name: "Scott", bbox: [44.5432, -93.9104, 44.8043, -93.2815] },
    { name: "Sherburne", bbox: [45.2457, -94.1495, 45.5596, -93.5101] },
    { name: "Sibley", bbox: [44.456, -94.6295, 44.7179, -93.768] },
    { name: "St. Louis", bbox: [46.6492, -93.0965, 48.6276, -91.7879] },
    { name: "Stearns", bbox: [45.2828, -95.1397, 45.7752, -94.0473] },
    { name: "Steele", bbox: [43.8481, -93.4066, 44.1967, -93.0456] },
    { name: "Stevens", bbox: [45.412, -96.254, 45.7599, -95.7474] },
    { name: "Swift", bbox: [45.1522, -96.117, 45.4125, -95.2465] },
    { name: "Todd", bbox: [45.7734, -95.1556, 46.3689, -94.644] },
    { name: "Traverse", bbox: [45.5855, -96.8578, 46.0219, -96.253] },
    { name: "Wabasha", bbox: [44.107, -92.5509, 44.4552, -91.8629] },
    { name: "Wadena", bbox: [46.3686, -95.1637, 46.8047, -94.7314] },
    { name: "Waseca", bbox: [43.848, -93.768, 44.1964, -93.4066] },
    { name: "Washington", bbox: [44.7457, -93.0205, 45.2968, -92.7461] },
    { name: "Watonwan", bbox: [43.848, -94.8598, 44.1087, -94.3688] },
    { name: "Wilkin", bbox: [46.0216, -96.783, 46.6308, -96.2654] },
    { name: "Winona", bbox: [43.8469, -92.0795, 44.193, -91.2841] },
    { name: "Wright", bbox: [44.978, -94.2608, 45.4229, -93.5217] },
    { name: "Yellow Medicine", bbox: [44.5418, -96.4519, 44.9362, -95.3602] },
  ],
  MO: [
    { name: "Adair", bbox: [40.0372, -92.8562, 40.3465, -92.3451] },
    { name: "Andrew", bbox: [39.8122, -95.0431, 40.1301, -94.6028] },
    { name: "Atchison", bbox: [40.2617, -95.7747, 40.5852, -95.1777] },
    { name: "Audrain", bbox: [39.0591, -92.3145, 39.3478, -91.409] },
    { name: "Barry", bbox: [36.4987, -94.0771, 36.9318, -93.5738] },
    { name: "Barton", bbox: [37.3493, -94.6176, 37.6536, -94.0735] },
    { name: "Bates", bbox: [38.0366, -94.6141, 38.4776, -94.0499] },
    { name: "Benton", bbox: [38.0625, -93.5235, 38.5354, -93.0652] },
    { name: "Bollinger", bbox: [37.0412, -90.2232, 37.5993, -89.8611] },
    { name: "Boone", bbox: [38.6432, -92.5651, 39.2488, -92.1044] },
    { name: "Buchanan", bbox: [39.5304, -95.1136, 39.8206, -94.6012] },
    { name: "Butler", bbox: [36.4978, -90.6786, 36.9265, -90.14] },
    { name: "Caldwell", bbox: [39.5246, -94.2084, 39.789, -93.7584] },
    { name: "Callaway", bbox: [38.5571, -92.2207, 39.0645, -91.634] },
    { name: "Camden", bbox: [37.8005, -93.0777, 38.2631, -92.4063] },
    { name: "Cape Girardeau", bbox: [37.1261, -89.8666, 37.5993, -89.4211] },
    { name: "Carroll", bbox: [39.207, -93.7592, 39.6156, -93.1045] },
    { name: "Carter", bbox: [36.8115, -91.2248, 37.0957, -90.6626] },
    { name: "Cass", bbox: [38.4471, -94.6129, 38.8472, -94.0643] },
    { name: "Cedar", bbox: [37.5727, -94.0754, 37.901, -93.616] },
    { name: "Chariton", bbox: [39.2223, -93.2781, 39.7067, -92.6893] },
    { name: "Christian", bbox: [36.8092, -93.6101, 37.0982, -92.9033] },
    { name: "Clark", bbox: [40.2489, -91.9508, 40.6136, -91.4194] },
    { name: "Clay", bbox: [39.1134, -94.6074, 39.4562, -94.2106] },
    { name: "Clinton", bbox: [39.4547, -94.6023, 39.7472, -94.206] },
    { name: "Cole", bbox: [38.3355, -92.4952, 38.7391, -91.9442] },
    { name: "Cooper", bbox: [38.68, -93.06, 39.0645, -92.4984] },
    { name: "Crawford", bbox: [37.6973, -91.5353, 38.211, -91.0958] },
    { name: "Dade", bbox: [37.282, -94.0838, 37.5816, -93.616] },
    { name: "Dallas", bbox: [37.415, -93.1879, 37.9041, -92.8535] },
    { name: "Daviess", bbox: [39.7847, -94.2188, 40.1366, -93.759] },
    { name: "DeKalb", bbox: [39.7458, -94.6054, 40.0392, -94.2035] },
    { name: "Dent", bbox: [37.4153, -91.8091, 37.7913, -91.1533] },
    { name: "Douglas", bbox: [36.794, -92.9093, 37.0707, -92.0887] },
    { name: "Dunklin", bbox: [35.9958, -90.3687, 36.6307, -89.9588] },
    { name: "Franklin", bbox: [38.2041, -91.3692, 38.7067, -90.7323] },
    { name: "Gasconade", bbox: [38.1525, -91.6449, 38.7098, -91.3675] },
    { name: "Gentry", bbox: [40.0349, -94.6066, 40.3867, -94.2143] },
    { name: "Greene", bbox: [37.0887, -93.6258, 37.4274, -93.0653] },
    { name: "Grundy", bbox: [39.9596, -93.764, 40.2663, -93.362] },
    { name: "Harrison", bbox: [40.1329, -94.2322, 40.5776, -93.7633] },
    { name: "Henry", bbox: [38.2072, -94.0752, 38.5674, -93.511] },
    { name: "Hickory", bbox: [37.8027, -93.5741, 38.0726, -93.0652] },
    { name: "Holt", bbox: [39.8619, -95.5525, 40.2644, -94.9933] },
    { name: "Howard", bbox: [38.9707, -92.9416, 39.3436, -92.4302] },
    { name: "Howell", bbox: [36.4984, -92.1204, 37.0562, -91.6556] },
    { name: "Iron", bbox: [37.271, -91.1551, 37.7408, -90.535] },
    { name: "Jackson", bbox: [38.833, -94.6081, 39.2371, -94.1048] },
    { name: "Jasper", bbox: [37.0481, -94.6185, 37.3642, -94.0523] },
    { name: "Jefferson", bbox: [38.0035, -90.7802, 38.5017, -90.2541] },
    { name: "Johnson", bbox: [38.5562, -94.1197, 38.9379, -93.4973] },
    { name: "Knox", bbox: [39.9494, -92.3478, 40.3028, -91.9497] },
    { name: "Laclede", bbox: [37.4729, -92.8554, 37.8957, -92.2489] },
    { name: "Lafayette", bbox: [38.9087, -94.1143, 39.2928, -93.4772] },
    { name: "Lawrence", bbox: [36.9228, -94.0627, 37.2901, -93.6051] },
    { name: "Lewis", bbox: [39.9455, -91.9527, 40.2572, -91.4559] },
    { name: "Lincoln", bbox: [38.8709, -91.2643, 39.2272, -90.6659] },
    { name: "Linn", bbox: [39.7, -93.3648, 40.0373, -92.8475] },
    { name: "Livingston", bbox: [39.6114, -93.762, 39.9676, -93.267] },
    { name: "Macon", bbox: [39.6053, -92.8579, 40.0373, -92.2879] },
    { name: "Madison", bbox: [37.3121, -90.5497, 37.6436, -90.1457] },
    { name: "Maries", bbox: [38.0106, -92.1957, 38.2922, -91.6306] },
    { name: "Marion", bbox: [39.6576, -91.8467, 39.9482, -91.3132] },
    { name: "McDonald", bbox: [36.4986, -94.6183, 36.7666, -94.0689] },
    { name: "Mercer", bbox: [40.264, -93.7743, 40.5805, -93.3669] },
    { name: "Miller", bbox: [38.0163, -92.6959, 38.4308, -92.1854] },
    { name: "Mississippi", bbox: [36.5651, -89.5198, 37.009, -89.1008] },
    { name: "Moniteau", bbox: [38.4278, -92.8419, 38.9221, -92.3796] },
    { name: "Monroe", bbox: [39.3391, -92.31, 39.6629, -91.7152] },
    { name: "Montgomery", bbox: [38.6769, -91.6472, 39.1479, -91.2602] },
    { name: "Morgan", bbox: [38.1895, -93.0777, 38.6931, -92.6252] },
    { name: "New Madrid", bbox: [36.3368, -89.9613, 36.8696, -89.3276] },
    { name: "Newton", bbox: [36.7478, -94.6187, 37.0568, -94.0592] },
    { name: "Nodaway", bbox: [40.1261, -95.2023, 40.5785, -94.5985] },
    { name: "Oregon", bbox: [36.4971, -91.6742, 36.8887, -91.1159] },
    { name: "Osage", bbox: [38.2885, -92.1957, 38.7039, -91.6404] },
    { name: "Ozark", bbox: [36.4977, -92.7723, 36.8061, -92.1123] },
    { name: "Pemiscot", bbox: [35.999, -89.9613, 36.4113, -89.5347] },
    { name: "Perry", bbox: [37.5662, -90.1473, 37.9056, -89.5066] },
    { name: "Pettis", bbox: [38.5063, -93.5127, 38.9428, -93.0505] },
    { name: "Phelps", bbox: [37.5989, -92.0293, 38.1535, -91.525] },
    { name: "Pike", bbox: [39.139, -91.4604, 39.5982, -90.719] },
    { name: "Platte", bbox: [39.1596, -95.1029, 39.5333, -94.6008] },
    { name: "Polk", bbox: [37.4172, -93.6284, 37.8294, -93.1752] },
    { name: "Pulaski", bbox: [37.6025, -92.4137, 38.0212, -92.0212] },
    { name: "Putnam", bbox: [40.3427, -93.3744, 40.5896, -92.6675] },
    { name: "Ralls", bbox: [39.3187, -91.7185, 39.6865, -91.178] },
    { name: "Randolph", bbox: [39.2465, -92.7074, 39.6104, -92.3009] },
    { name: "Ray", bbox: [39.1435, -94.2125, 39.5272, -93.7585] },
    { name: "Reynolds", bbox: [37.0503, -91.3142, 37.603, -90.7355] },
    { name: "Ripley", bbox: [36.4977, -91.1265, 36.8237, -90.5762] },
    { name: "Saline", bbox: [38.9282, -93.4964, 39.4018, -92.8492] },
    { name: "Schuyler", bbox: [40.3435, -92.7146, 40.5973, -92.35] },
    { name: "Scotland", bbox: [40.3008, -92.3508, 40.6059, -91.9431] },
    { name: "Scott", bbox: [36.8595, -89.7868, 37.2486, -89.3227] },
    { name: "Shannon", bbox: [36.8839, -91.6581, 37.4227, -91.0178] },
    { name: "Shelby", bbox: [39.6041, -92.2993, 39.9545, -91.8404] },
    { name: "St. Charles", bbox: [38.5347, -90.9645, 38.9678, -90.1091] },
    { name: "St. Clair", bbox: [37.828, -94.0657, 38.214, -93.504] },
    { name: "St. Francois", bbox: [37.6416, -90.6479, 38.0765, -90.1105] },
    { name: "St. Louis", bbox: [38.387, -90.7363, 38.8878, -90.1177] },
    { name: "Ste. Genevieve", bbox: [37.6696, -90.4591, 38.122, -89.9382] },
    { name: "Stoddard", bbox: [36.6275, -90.2586, 37.1274, -89.6866] },
    { name: "Stone", bbox: [36.4984, -93.611, 36.9958, -93.3044] },
    { name: "Sullivan", bbox: [40.0331, -93.3672, 40.3859, -92.8553] },
    { name: "Taney", bbox: [36.4978, -93.3153, 36.8169, -92.7649] },
    { name: "Texas", bbox: [37.0489, -92.2523, 37.6045, -91.6466] },
    { name: "Vernon", bbox: [37.6397, -94.618, 38.0601, -94.0583] },
    { name: "Warren", bbox: [38.5475, -91.4186, 38.9928, -90.9585] },
    { name: "Washington", bbox: [37.7348, -91.1, 38.2041, -90.64] },
    { name: "Wayne", bbox: [36.922, -90.7796, 37.3176, -90.1104] },
    { name: "Webster", bbox: [37.0671, -93.0734, 37.4874, -92.6859] },
    { name: "Worth", bbox: [40.3843, -94.632, 40.5719, -94.2143] },
    { name: "Wright", bbox: [37.0597, -92.6867, 37.4815, -92.2514] },
  ],
  MS: [
    { name: "Adams", bbox: [31.1923, -91.6, 31.7527, -91.1539] },
    { name: "Alcorn", bbox: [34.7556, -88.8235, 34.9961, -88.3635] },
    { name: "Amite", bbox: [30.9989, -91.0954, 31.3496, -90.5476] },
    { name: "Attala", bbox: [32.8796, -89.9659, 33.2859, -89.3164] },
    { name: "Benton", bbox: [34.5829, -89.3527, 34.9946, -89.0171] },
    { name: "Bolivar", bbox: [33.5294, -91.2323, 34.12, -90.657] },
    { name: "Calhoun", bbox: [33.7218, -89.5097, 34.1621, -89.1379] },
    { name: "Carroll", bbox: [33.2145, -90.1748, 33.677, -89.6453] },
    { name: "Chickasaw", bbox: [33.7386, -89.1918, 34.0749, -88.719] },
    { name: "Choctaw", bbox: [33.1089, -89.454, 33.5332, -89.0883] },
    { name: "Claiborne", bbox: [31.7854, -91.2481, 32.2251, -90.7168] },
    { name: "Clarke", bbox: [31.8266, -88.9138, 32.2277, -88.4317] },
    { name: "Clay", bbox: [33.5062, -89.0345, 33.8124, -88.4803] },
    { name: "Coahoma", bbox: [33.9857, -90.9346, 34.5248, -90.399] },
    { name: "Copiah", bbox: [31.6985, -90.7368, 32.0497, -90.1226] },
    { name: "Covington", bbox: [31.4337, -89.7556, 31.7969, -89.3992] },
    { name: "DeSoto", bbox: [34.7079, -90.3093, 34.9957, -89.7234] },
    { name: "Forrest", bbox: [30.9099, -89.4516, 31.4341, -89.138] },
    { name: "Franklin", bbox: [31.321, -91.1582, 31.6114, -90.6332] },
    { name: "George", bbox: [30.7356, -88.885, 30.9983, -88.4125] },
    { name: "Greene", bbox: [30.9974, -88.8417, 31.4358, -88.4256] },
    { name: "Grenada", bbox: [33.6767, -90.137, 33.898, -89.5069] },
    { name: "Hancock", bbox: [30.1739, -89.6906, 30.6484, -89.3223] },
    { name: "Harrison", bbox: [30.2023, -89.3414, 30.6773, -88.8456] },
    { name: "Hinds", bbox: [32.0484, -90.7286, 32.5738, -90.0657] },
    { name: "Holmes", bbox: [32.8796, -90.4317, 33.3751, -89.7494] },
    { name: "Humphreys", bbox: [32.9225, -90.7163, 33.3295, -90.3303] },
    { name: "Issaquena", bbox: [32.4421, -91.214, 33.0112, -90.693] },
    { name: "Itawamba", bbox: [34.0865, -88.5434, 34.4653, -88.1553] },
    { name: "Jackson", bbox: [30.1966, -88.8845, 30.7356, -88.394] },
    { name: "Jasper", bbox: [31.8021, -89.3227, 32.2242, -88.9105] },
    { name: "Jefferson", bbox: [31.6101, -91.3656, 31.8698, -90.7363] },
    { name: "Jefferson Davis", bbox: [31.39, -89.9761, 31.7747, -89.5868] },
    { name: "Jones", bbox: [31.4335, -89.4012, 31.8246, -88.9434] },
    { name: "Kemper", bbox: [32.577, -88.9145, 32.9291, -88.3477] },
    { name: "Lafayette", bbox: [34.161, -89.7213, 34.5544, -89.2455] },
    { name: "Lamar", bbox: [30.9829, -89.6544, 31.434, -89.3479] },
    { name: "Lauderdale", bbox: [32.2242, -88.9145, 32.5781, -88.3887] },
    { name: "Lawrence", bbox: [31.336, -90.2452, 31.7617, -89.9589] },
    { name: "Leake", bbox: [32.5764, -89.7303, 32.9317, -89.3176] },
    { name: "Lee", bbox: [34.0745, -88.825, 34.5092, -88.5417] },
    { name: "Leflore", bbox: [33.2422, -90.4538, 33.8114, -90.1014] },
    { name: "Lincoln", bbox: [31.3493, -90.7373, 31.7175, -90.2439] },
    { name: "Lowndes", bbox: [33.2869, -88.6713, 33.7456, -88.2484] },
    { name: "Madison", bbox: [32.3995, -90.45, 32.8848, -89.73] },
    { name: "Marion", bbox: [31.0019, -90.0405, 31.4341, -89.654] },
    { name: "Marshall", bbox: [34.4956, -89.7243, 34.9953, -89.2446] },
    { name: "Monroe", bbox: [33.6502, -88.72, 34.0893, -88.2036] },
    { name: "Montgomery", bbox: [33.2855, -89.7869, 33.6776, -89.3811] },
    { name: "Neshoba", bbox: [32.5765, -89.3192, 32.9317, -88.9144] },
    { name: "Newton", bbox: [32.2235, -89.3227, 32.577, -88.9138] },
    { name: "Noxubee", bbox: [32.926, -88.8131, 33.2883, -88.3045] },
    { name: "Oktibbeha", bbox: [33.286, -89.0884, 33.5651, -88.6691] },
    { name: "Panola", bbox: [34.1601, -90.1986, 34.5544, -89.7211] },
    { name: "Pearl River", bbox: [30.4588, -89.8426, 31.0139, -89.3408] },
    { name: "Perry", bbox: [30.9099, -89.1461, 31.4341, -88.8343] },
    { name: "Pike", bbox: [30.9997, -90.5482, 31.3503, -90.2596] },
    { name: "Pontotoc", bbox: [34.0739, -89.2463, 34.3794, -88.8245] },
    { name: "Prentiss", bbox: [34.4636, -88.7365, 34.7568, -88.3292] },
    { name: "Quitman", bbox: [34.0729, -90.451, 34.5111, -90.1344] },
    { name: "Rankin", bbox: [32.0471, -90.2454, 32.5869, -89.7301] },
    { name: "Scott", bbox: [32.222, -89.7841, 32.6342, -89.3226] },
    { name: "Sharkey", bbox: [32.6621, -90.9649, 33.0974, -90.6566] },
    { name: "Simpson", bbox: [31.7527, -90.2303, 32.0497, -89.653] },
    { name: "Smith", bbox: [31.7807, -89.7311, 32.2235, -89.3166] },
    { name: "Stone", bbox: [30.6477, -89.3414, 30.9108, -88.8845] },
    { name: "Sunflower", bbox: [33.27, -90.7638, 33.9876, -90.4503] },
    { name: "Tallahatchie", bbox: [33.6972, -90.4516, 34.1643, -89.9261] },
    { name: "Tate", bbox: [34.5543, -90.24, 34.7725, -89.6684] },
    { name: "Tippah", bbox: [34.5965, -89.0885, 34.9952, -88.7178] },
    { name: "Tishomingo", bbox: [34.4631, -88.3655, 34.9956, -88.0979] },
    { name: "Tunica", bbox: [34.4238, -90.5765, 34.8606, -90.1985] },
    { name: "Union", bbox: [34.3648, -89.2463, 34.5982, -88.7354] },
    { name: "Walthall", bbox: [31.0007, -90.2604, 31.3503, -89.8359] },
    { name: "Warren", bbox: [32.0799, -91.1746, 32.6189, -90.5538] },
    { name: "Washington", bbox: [33.0077, -91.2157, 33.5294, -90.6803] },
    { name: "Wayne", bbox: [31.4335, -88.9435, 31.8938, -88.4494] },
    { name: "Webster", bbox: [33.4598, -89.5071, 33.7394, -89.0186] },
    { name: "Wilkinson", bbox: [30.9989, -91.6369, 31.3609, -91.0594] },
    { name: "Winston", bbox: [32.926, -89.3192, 33.2864, -88.8128] },
    { name: "Yalobusha", bbox: [33.8673, -89.9315, 34.1925, -89.5074] },
    { name: "Yazoo", bbox: [32.5076, -90.7598, 33.0106, -89.9659] },
  ],
  MT: [
    { name: "Beaverhead", bbox: [44.371, -113.9426, 45.9408, -111.4815] },
    { name: "Big Horn", bbox: [44.9938, -108.6996, 46.0436, -106.2636] },
    { name: "Blaine", bbox: [47.7202, -109.5516, 49.0004, -108.2365] },
    { name: "Broadwater", bbox: [45.8335, -111.7879, 46.7625, -111.0572] },
    { name: "Carbon", bbox: [44.9995, -109.7987, 45.611, -108.128] },
    { name: "Carter", bbox: [44.9974, -105.0384, 46.1367, -104.0401] },
    { name: "Cascade", bbox: [46.8236, -112.0473, 47.6986, -110.6393] },
    { name: "Chouteau", bbox: [47.4153, -111.4091, 48.3065, -109.5343] },
    { name: "Custer", bbox: [45.787, -106.1919, 46.8603, -104.7329] },
    { name: "Daniels", bbox: [48.5632, -106.1519, 48.9997, -104.9733] },
    { name: "Dawson", bbox: [46.8609, -105.4065, 47.7908, -104.3056] },
    { name: "Deer Lodge", bbox: [45.7665, -113.5175, 46.2668, -112.5585] },
    { name: "Fallon", bbox: [45.882, -104.9059, 46.6849, -104.044] },
    { name: "Fergus", bbox: [46.6937, -110.2134, 47.7932, -108.3126] },
    { name: "Flathead", bbox: [47.5964, -115.0201, 49.0011, -112.8786] },
    { name: "Gallatin", bbox: [44.4741, -111.8051, 46.1929, -110.784] },
    { name: "Garfield", bbox: [46.8453, -107.9685, 47.983, -106.0865] },
    { name: "Glacier", bbox: [48.3094, -114.0682, 48.9994, -112.1844] },
    { name: "Golden Valley", bbox: [46.0445, -109.6543, 46.751, -108.7791] },
    { name: "Granite", bbox: [45.9399, -113.8759, 46.8321, -113.0368] },
    { name: "Hill", bbox: [48.1326, -110.7556, 49.0003, -109.4643] },
    { name: "Jefferson", bbox: [45.7485, -112.5768, 46.5691, -111.66] },
    { name: "Judith Basin", bbox: [46.6787, -110.7723, 47.4167, -109.746] },
    { name: "Lake", bbox: [47.1382, -114.6043, 48.0519, -113.604] },
    { name: "Lewis and Clark", bbox: [46.421, -113.1659, 47.954, -111.498] },
    { name: "Liberty", bbox: [48.1322, -111.4091, 48.9984, -110.7432] },
    { name: "Lincoln", bbox: [47.8903, -116.0494, 49.0009, -114.6119] },
    { name: "Madison", bbox: [44.7088, -112.6914, 45.8571, -111.3513] },
    { name: "McCone", bbox: [47.093, -106.4186, 48.0979, -105.1947] },
    { name: "Meagher", bbox: [46.1842, -111.6581, 47.0882, -110.2734] },
    { name: "Mineral", bbox: [46.714, -115.6613, 47.4869, -114.4197] },
    { name: "Missoula", bbox: [46.632, -114.7972, 47.6005, -113.3029] },
    { name: "Musselshell", bbox: [46.1324, -109.0098, 46.756, -107.7812] },
    { name: "Park", bbox: [44.9922, -111.0443, 46.1924, -109.7982] },
    { name: "Petroleum", bbox: [46.7494, -108.7367, 47.5983, -107.8278] },
    { name: "Phillips", bbox: [47.4506, -108.891, 48.9996, -107.1799] },
    { name: "Pondera", bbox: [47.9848, -113.3495, 48.4835, -111.4085] },
    { name: "Powder River", bbox: [44.9936, -106.2797, 45.7886, -104.982] },
    { name: "Powell", bbox: [46.2659, -113.4665, 47.6, -112.2986] },
    { name: "Prairie", bbox: [46.5406, -106.0868, 47.1816, -104.6038] },
    { name: "Ravalli", bbox: [45.4685, -114.5662, 46.661, -113.5163] },
    { name: "Richland", bbox: [47.3541, -105.2349, 48.1507, -104.0417] },
    { name: "Roosevelt", bbox: [47.9961, -105.8438, 48.5633, -104.0441] },
    { name: "Rosebud", bbox: [45.1797, -107.8921, 46.8605, -106.0863] },
    { name: "Sanders", bbox: [47.1206, -116.0494, 48.263, -114.1874] },
    { name: "Sheridan", bbox: [48.3892, -105.0575, 48.9999, -104.0469] },
    { name: "Silver Bow", bbox: [45.6249, -113.0855, 46.1838, -112.1903] },
    { name: "Stillwater", bbox: [45.1672, -110.0638, 46.1323, -108.8427] },
    { name: "Sweet Grass", bbox: [45.1721, -110.2927, 46.2205, -109.4173] },
    { name: "Teton", bbox: [47.5051, -113.0169, 48.1325, -111.4085] },
    { name: "Toole", bbox: [48.2194, -112.1936, 48.9982, -111.2707] },
    { name: "Treasure", bbox: [45.8701, -107.7385, 46.4823, -106.939] },
    { name: "Valley", bbox: [47.6614, -107.4149, 48.9998, -105.8043] },
    { name: "Wheatland", bbox: [46.2194, -110.2819, 46.7527, -109.3892] },
    { name: "Wibaux", bbox: [46.6414, -104.607, 47.3975, -104.045] },
    { name: "Yellowstone", bbox: [45.4605, -108.9241, 46.4961, -107.4664] },
  ],
  NC: [
    { name: "Alamance", bbox: [35.8434, -79.5425, 36.2499, -79.2495] },
    { name: "Alexander", bbox: [35.7766, -81.3343, 36.0458, -81.0054] },
    { name: "Alleghany", bbox: [36.3654, -81.3532, 36.575, -80.9018] },
    { name: "Anson", bbox: [34.8066, -80.3204, 35.1961, -79.85] },
    { name: "Ashe", bbox: [36.2403, -81.721, 36.5881, -81.2535] },
    { name: "Avery", bbox: [35.9115, -82.0805, 36.2871, -81.736] },
    { name: "Beaufort", bbox: [35.216, -77.1912, 35.733, -76.4678] },
    { name: "Bertie", bbox: [35.8123, -77.3277, 36.2469, -76.6688] },
    { name: "Bladen", bbox: [34.3671, -78.9011, 34.8565, -78.1765] },
    { name: "Brunswick", bbox: [33.8445, -78.6505, 34.357, -77.9373] },
    { name: "Buncombe", bbox: [35.4233, -82.8837, 35.8181, -82.169] },
    { name: "Burke", bbox: [35.5645, -81.987, 36.0001, -81.3641] },
    { name: "Cabarrus", bbox: [35.184, -80.7843, 35.5072, -80.2952] },
    { name: "Caldwell", bbox: [35.7679, -81.8115, 36.1174, -81.3284] },
    { name: "Camden", bbox: [36.1602, -76.5414, 36.5506, -75.8874] },
    { name: "Carteret", bbox: [34.5886, -77.1658, 35.0771, -76.0359] },
    { name: "Caswell", bbox: [36.2421, -79.5321, 36.5417, -79.1379] },
    { name: "Catawba", bbox: [35.5478, -81.5344, 35.8274, -80.9245] },
    { name: "Chatham", bbox: [35.5151, -79.5559, 35.8768, -78.9062] },
    { name: "Cherokee", bbox: [34.9873, -84.3219, 35.291, -83.7025] },
    { name: "Chowan", bbox: [36.0056, -76.7363, 36.3519, -76.4118] },
    { name: "Clay", bbox: [34.9871, -84.0055, 35.1602, -83.4831] },
    { name: "Cleveland", bbox: [35.1634, -81.7681, 35.5798, -81.3213] },
    { name: "Columbus", bbox: [33.944, -79.0712, 34.4827, -78.1624] },
    { name: "Craven", bbox: [34.8028, -77.4737, 35.419, -76.6542] },
    { name: "Cumberland", bbox: [34.8348, -79.0987, 35.2593, -78.4946] },
    { name: "Currituck", bbox: [36.0717, -76.3132, 36.5508, -75.7733] },
    { name: "Dare", bbox: [35.0619, -76.046, 36.2315, -75.4587] },
    { name: "Davidson", bbox: [35.5043, -80.4641, 36.0268, -80.0433] },
    { name: "Davie", bbox: [35.7428, -80.7077, 36.0511, -80.3657] },
    { name: "Duplin", bbox: [34.7206, -78.2005, 35.1928, -77.6715] },
    { name: "Durham", bbox: [35.8632, -79.0167, 36.2394, -78.6979] },
    { name: "Edgecombe", bbox: [35.6773, -77.8284, 36.153, -77.3425] },
    { name: "Forsyth", bbox: [35.9732, -80.5161, 36.2616, -80.0355] },
    { name: "Franklin", bbox: [35.8177, -78.5465, 36.2662, -78.0066] },
    { name: "Gaston", bbox: [35.146, -81.4565, 35.4196, -80.9554] },
    { name: "Gates", bbox: [36.2962, -76.9318, 36.5507, -76.4537] },
    { name: "Graham", bbox: [35.2169, -84.0381, 35.4641, -83.5855] },
    { name: "Granville", bbox: [36.0218, -78.805, 36.5425, -78.457] },
    { name: "Greene", bbox: [35.3478, -77.827, 35.6523, -77.476] },
    { name: "Guilford", bbox: [35.8996, -80.0467, 36.2575, -79.5324] },
    { name: "Halifax", bbox: [36.0049, -78.0066, 36.5068, -77.2307] },
    { name: "Harnett", bbox: [35.1922, -79.2231, 35.5831, -78.5303] },
    { name: "Haywood", bbox: [35.2919, -83.2555, 35.7941, -82.7444] },
    { name: "Henderson", bbox: [35.1442, -82.7452, 35.4659, -82.2615] },
    { name: "Hertford", bbox: [36.2427, -77.2088, 36.5463, -76.6904] },
    { name: "Hoke", bbox: [34.8334, -79.4592, 35.2107, -79.0347] },
    { name: "Hyde", bbox: [35.3264, -76.638, 35.7052, -75.8699] },
    { name: "Iredell", bbox: [35.4877, -81.1094, 36.0557, -80.6932] },
    { name: "Jackson", bbox: [35.0008, -83.3514, 35.5146, -82.9208] },
    { name: "Johnston", bbox: [35.2626, -78.7086, 35.8177, -78.0646] },
    { name: "Jones", bbox: [34.7849, -77.731, 35.2434, -77.0903] },
    { name: "Lee", bbox: [35.307, -79.35, 35.6282, -78.9698] },
    { name: "Lenoir", bbox: [35.0083, -77.8342, 35.4267, -77.391] },
    { name: "Lincoln", bbox: [35.4008, -81.5378, 35.5688, -80.947] },
    { name: "Macon", bbox: [34.9937, -83.7381, 35.331, -83.1087] },
    { name: "Madison", bbox: [35.6782, -82.9641, 36.0658, -82.4087] },
    { name: "Martin", bbox: [35.6585, -77.4027, 36.0745, -76.7608] },
    { name: "McDowell", bbox: [35.5246, -82.2908, 35.9594, -81.8242] },
    { name: "Mecklenburg", bbox: [35.0016, -81.058, 35.5058, -80.5503] },
    { name: "Mitchell", bbox: [35.8244, -82.4169, 36.159, -81.9817] },
    { name: "Montgomery", bbox: [35.1431, -80.1827, 35.5115, -79.6143] },
    { name: "Moore", bbox: [35.0431, -79.7693, 35.518, -79.0961] },
    { name: "Nash", bbox: [35.7304, -78.2549, 36.2027, -77.6979] },
    { name: "New Hanover", bbox: [33.9286, -78.0299, 34.3894, -77.7159] },
    { name: "Northampton", bbox: [36.1649, -77.8998, 36.5463, -77.1196] },
    { name: "Onslow", bbox: [34.4405, -77.6806, 34.9734, -77.1128] },
    { name: "Orange", bbox: [35.8632, -79.2595, 36.2439, -78.9508] },
    { name: "Pamlico", bbox: [34.9594, -76.987, 35.3378, -76.4678] },
    { name: "Pasquotank", bbox: [36.1163, -76.4915, 36.5105, -76.0471] },
    { name: "Pender", bbox: [34.2927, -78.2563, 34.722, -77.518] },
    { name: "Perquimans", bbox: [36.0754, -76.5899, 36.378, -76.1905] },
    { name: "Person", bbox: [36.2359, -79.1537, 36.5422, -78.7948] },
    { name: "Pitt", bbox: [35.328, -77.7005, 35.8329, -77.0875] },
    { name: "Polk", bbox: [35.1872, -82.3524, 35.393, -81.9688] },
    { name: "Randolph", bbox: [35.5057, -80.0668, 35.9207, -79.542] },
    { name: "Richmond", bbox: [34.805, -80.0754, 35.1834, -79.4592] },
    { name: "Robeson", bbox: [34.2992, -79.4618, 34.9536, -78.8057] },
    { name: "Rockingham", bbox: [36.2413, -80.0355, 36.5425, -79.511] },
    { name: "Rowan", bbox: [35.5029, -80.7715, 35.8529, -80.1827] },
    { name: "Rutherford", bbox: [35.1801, -82.2796, 35.5798, -81.6923] },
    { name: "Sampson", bbox: [34.554, -78.6701, 35.3151, -78.1132] },
    { name: "Scotland", bbox: [34.6304, -79.6929, 35.0431, -79.3491] },
    { name: "Stanly", bbox: [35.1431, -80.5053, 35.5043, -80.0517] },
    { name: "Stokes", bbox: [36.2574, -80.452, 36.5506, -80.0273] },
    { name: "Surry", bbox: [36.2364, -80.9746, 36.5618, -80.4401] },
    { name: "Swain", bbox: [35.2794, -83.9527, 35.6958, -83.1819] },
    { name: "Transylvania", bbox: [35.027, -83.0554, 35.4229, -82.5744] },
    { name: "Tyrrell", bbox: [35.598, -76.406, 35.9933, -75.9994] },
    { name: "Union", bbox: [34.8138, -80.8405, 35.2084, -80.2771] },
    { name: "Vance", bbox: [36.1642, -78.5113, 36.5438, -78.2877] },
    { name: "Wake", bbox: [35.5191, -78.9951, 36.0712, -78.2549] },
    { name: "Warren", bbox: [36.2027, -78.3239, 36.5447, -77.8979] },
    { name: "Washington", bbox: [35.6975, -76.8451, 35.9843, -76.3534] },
    { name: "Watauga", bbox: [36.1115, -81.9181, 36.3875, -81.4556] },
    { name: "Wayne", bbox: [35.1466, -78.3047, 35.5855, -77.8] },
    { name: "Wilkes", bbox: [35.9965, -81.5455, 36.4404, -80.8689] },
    { name: "Wilson", bbox: [35.5835, -78.1921, 35.8672, -77.6613] },
    { name: "Yadkin", bbox: [36.0465, -80.8822, 36.2852, -80.4396] },
    { name: "Yancey", bbox: [35.7044, -82.5059, 36.0729, -82.1332] },
  ],
  ND: [
    { name: "Adams", bbox: [45.9445, -102.9957, 46.2832, -101.9979] },
    { name: "Barnes", bbox: [46.6299, -98.4675, 47.2405, -97.6815] },
    { name: "Benson", bbox: [47.8463, -99.8482, 48.3713, -98.5255] },
    { name: "Billings", bbox: [46.6298, -103.667, 47.3294, -103.0326] },
    { name: "Bottineau", bbox: [48.5447, -101.4967, 48.9997, -100.1455] },
    { name: "Bowman", bbox: [45.9451, -104.0467, 46.2807, -102.9955] },
    { name: "Burke", bbox: [48.5463, -102.9399, 48.999, -102.0211] },
    { name: "Burleigh", bbox: [46.6334, -100.9652, 47.3277, -100.0752] },
    { name: "Cass", bbox: [46.6293, -97.706, 47.24, -96.7675] },
    { name: "Cavalier", bbox: [48.5431, -98.9999, 49.0005, -97.9272] },
    { name: "Dickey", bbox: [45.9361, -99.0058, 46.2829, -98.0067] },
    { name: "Divide", bbox: [48.6333, -104.0489, 48.9999, -102.8858] },
    { name: "Dunn", bbox: [46.9806, -103.0999, 47.8237, -102.1445] },
    { name: "Eddy", bbox: [47.5872, -99.2973, 47.8468, -98.5001] },
    { name: "Emmons", bbox: [45.9417, -100.6619, 46.6345, -99.8784] },
    { name: "Foster", bbox: [47.3265, -99.2663, 47.5876, -98.4992] },
    { name: "Golden Valley", bbox: [46.5407, -104.0456, 47.3301, -103.6092] },
    { name: "Grand Forks", bbox: [47.6721, -97.9034, 48.1949, -96.8907] },
    { name: "Grant", bbox: [46.0068, -102.0966, 46.718, -101.0257] },
    { name: "Griggs", bbox: [47.2405, -98.5002, 47.6724, -97.9612] },
    { name: "Hettinger", bbox: [46.2055, -102.928, 46.631, -101.9979] },
    { name: "Kidder", bbox: [46.6316, -100.1146, 47.3273, -99.4464] },
    { name: "LaMoure", bbox: [46.2828, -99.0374, 46.6311, -98.0339] },
    { name: "Logan", bbox: [46.2828, -99.9168, 46.6329, -99.0366] },
    { name: "McHenry", bbox: [47.8475, -101.06, 48.6324, -100.1976] },
    { name: "McIntosh", bbox: [45.9399, -99.8801, 46.2832, -99.0031] },
    { name: "McKenzie", bbox: [47.3287, -104.0453, 48.1465, -102.553] },
    { name: "McLean", bbox: [47.1566, -102.3858, 47.8487, -100.5851] },
    { name: "Mercer", bbox: [46.9812, -102.2056, 47.5745, -101.257] },
    { name: "Morton", bbox: [46.2842, -102.0971, 46.9828, -100.5446] },
    { name: "Mountrail", bbox: [47.758, -102.8858, 48.5471, -101.8715] },
    { name: "Nelson", bbox: [47.6722, -98.5256, 48.1952, -97.8822] },
    { name: "Oliver", bbox: [46.9813, -101.7644, 47.2933, -100.8822] },
    { name: "Pembina", bbox: [48.5423, -97.9502, 49.0007, -97.0926] },
    { name: "Pierce", bbox: [47.8473, -100.2767, 48.5452, -99.4929] },
    { name: "Ramsey", bbox: [47.9151, -99.2003, 48.5442, -98.2922] },
    { name: "Ransom", bbox: [46.2823, -98.0346, 46.6307, -97.2799] },
    { name: "Renville", bbox: [48.4584, -102.0217, 48.9994, -101.0597] },
    { name: "Richland", bbox: [45.9351, -97.2806, 46.6306, -96.5548] },
    { name: "Rolette", bbox: [48.5448, -100.183, 48.9994, -99.493] },
    { name: "Sargent", bbox: [45.9351, -98.0081, 46.2826, -97.2283] },
    { name: "Sheridan", bbox: [47.3271, -100.6734, 47.8476, -100.0328] },
    { name: "Sioux", bbox: [45.9436, -101.9986, 46.4279, -100.5119] },
    { name: "Slope", bbox: [46.2802, -104.0456, 46.6301, -102.9245] },
    { name: "Stark", bbox: [46.6299, -103.2316, 47.0103, -102.0962] },
    { name: "Steele", bbox: [47.2391, -97.9866, 47.6723, -97.4515] },
    { name: "Stutsman", bbox: [46.6306, -99.4811, 47.3272, -98.4391] },
    { name: "Towner", bbox: [48.3705, -99.5259, 48.9998, -98.9704] },
    { name: "Traill", bbox: [47.2381, -97.4743, 47.6722, -96.833] },
    { name: "Walsh", bbox: [48.1938, -98.3181, 48.5438, -97.1156] },
    { name: "Ward", bbox: [47.8476, -102.2339, 48.8072, -100.9705] },
    { name: "Wells", bbox: [47.3271, -100.0695, 47.8473, -99.2658] },
    { name: "Williams", bbox: [47.956, -104.0482, 48.634, -102.8281] },
  ],
  NE: [
    { name: "Adams", bbox: [40.3503, -98.7244, 40.6989, -98.2781] },
    { name: "Antelope", bbox: [41.915, -98.3006, 42.4377, -97.8333] },
    { name: "Arthur", bbox: [41.3947, -101.9855, 41.7432, -101.4065] },
    { name: "Banner", bbox: [41.3932, -104.053, 41.6992, -103.369] },
    { name: "Blaine", bbox: [41.7398, -100.2681, 42.0861, -99.6868] },
    { name: "Boone", bbox: [41.4807, -98.2958, 41.9163, -97.8298] },
    { name: "Box Butte", bbox: [42.0029, -103.4445, 42.4399, -102.6978] },
    { name: "Boyd", bbox: [42.7612, -99.257, 42.9986, -98.3051] },
    { name: "Brown", bbox: [42.0858, -100.1985, 42.8461, -99.6624] },
    { name: "Buffalo", bbox: [40.6527, -99.426, 41.047, -98.7214] },
    { name: "Burt", bbox: [41.6827, -96.5552, 42.0472, -96.0645] },
    { name: "Butler", bbox: [41.0461, -97.3682, 41.4564, -96.9059] },
    { name: "Cass", bbox: [40.784, -96.4639, 41.0654, -95.8212] },
    { name: "Cedar", bbox: [42.3513, -97.4854, 42.8612, -97.0151] },
    { name: "Chase", bbox: [40.3492, -102.0518, 40.6981, -101.3428] },
    { name: "Cherry", bbox: [42.0858, -102.0825, 42.9994, -100.1676] },
    { name: "Cheyenne", bbox: [41.0018, -103.3825, 41.4391, -102.6094] },
    { name: "Clay", bbox: [40.3503, -98.2781, 40.6986, -97.8241] },
    { name: "Colfax", bbox: [41.3771, -97.2535, 41.7431, -96.9059] },
    { name: "Cuming", bbox: [41.742, -97.0199, 42.0906, -96.5549] },
    { name: "Custer", bbox: [41.0465, -100.2512, 41.7408, -99.2033] },
    { name: "Dakota", bbox: [42.278, -96.7267, 42.5247, -96.3488] },
    { name: "Dawes", bbox: [42.4373, -103.5051, 43.0009, -102.7734] },
    { name: "Dawson", bbox: [40.6708, -100.2242, 41.0466, -99.4173] },
    { name: "Deuel", bbox: [41.0022, -102.621, 41.2216, -102.0517] },
    { name: "Dixon", bbox: [42.2641, -97.0178, 42.7587, -96.636] },
    { name: "Dodge", bbox: [41.3931, -96.9059, 41.7428, -96.329] },
    { name: "Douglas", bbox: [41.19, -96.4707, 41.3932, -95.9025] },
    { name: "Dundy", bbox: [40.0024, -102.052, 40.3506, -101.3234] },
    { name: "Fillmore", bbox: [40.3503, -97.8248, 40.6986, -97.3684] },
    { name: "Franklin", bbox: [40.0019, -99.1794, 40.3507, -98.7264] },
    { name: "Frontier", bbox: [40.3494, -100.7792, 40.7003, -99.9812] },
    { name: "Furnas", bbox: [40.0013, -100.1978, 40.3512, -99.6283] },
    { name: "Gage", bbox: [40.0009, -96.9164, 40.5236, -96.4636] },
    { name: "Garden", bbox: [41.2215, -102.6776, 42.0092, -101.9846] },
    { name: "Garfield", bbox: [41.7404, -99.2227, 42.0885, -98.7591] },
    { name: "Gosper", bbox: [40.3512, -100.0951, 40.7, -99.6422] },
    { name: "Grant", bbox: [41.7421, -102.0679, 42.0963, -101.4259] },
    { name: "Greeley", bbox: [41.3939, -98.7522, 41.7412, -98.2909] },
    { name: "Hall", bbox: [40.6983, -98.722, 41.0467, -98.2824] },
    { name: "Hamilton", bbox: [40.6983, -98.2829, 41.1737, -97.8257] },
    { name: "Harlan", bbox: [40.0019, -99.6305, 40.3511, -99.1791] },
    { name: "Hayes", bbox: [40.3495, -101.3454, 40.7001, -100.7774] },
    { name: "Hitchcock", bbox: [40.0021, -101.3255, 40.3506, -100.7584] },
    { name: "Holt", bbox: [42.0879, -99.257, 42.8941, -98.3002] },
    { name: "Hooker", bbox: [41.7404, -101.4266, 42.0922, -100.8425] },
    { name: "Howard", bbox: [41.0464, -98.7485, 41.3942, -98.2866] },
    { name: "Jefferson", bbox: [40.0013, -97.3692, 40.3504, -96.9151] },
    { name: "Johnson", bbox: [40.262, -96.4637, 40.5231, -96.0667] },
    { name: "Kearney", bbox: [40.3504, -99.1794, 40.6898, -98.7239] },
    { name: "Keith", bbox: [41.0039, -102.0555, 41.3954, -101.25] },
    { name: "Keya Paha", bbox: [42.7176, -100.1985, 42.9987, -99.2542] },
    { name: "Kimball", bbox: [41.0014, -104.0532, 41.3946, -103.3776] },
    { name: "Knox", bbox: [42.4369, -98.3097, 42.8812, -97.4853] },
    { name: "Lancaster", bbox: [40.523, -96.9135, 41.0461, -96.4636] },
    { name: "Lincoln", bbox: [40.6978, -101.2704, 41.3949, -100.2233] },
    { name: "Logan", bbox: [41.3933, -100.7132, 41.7399, -100.2511] },
    { name: "Loup", bbox: [41.7403, -99.687, 42.088, -99.2218] },
    { name: "Madison", bbox: [41.7422, -97.8345, 42.0909, -97.3681] },
    { name: "McPherson", bbox: [41.3935, -101.4073, 41.7432, -100.7117] },
    { name: "Merrick", bbox: [40.8723, -98.2872, 41.3951, -97.5983] },
    { name: "Morrill", bbox: [41.4377, -103.3704, 42.0053, -102.6365] },
    { name: "Nance", bbox: [41.264, -98.2914, 41.5268, -97.7036] },
    { name: "Nemaha", bbox: [40.2614, -96.067, 40.5451, -95.551] },
    { name: "Nuckolls", bbox: [40.0019, -98.274, 40.3506, -97.8208] },
    { name: "Otoe", bbox: [40.5228, -96.4638, 40.784, -95.71] },
    { name: "Pawnee", bbox: [40.0004, -96.4637, 40.2622, -96.0102] },
    { name: "Perkins", bbox: [40.6975, -102.0518, 41.004, -101.248] },
    { name: "Phelps", bbox: [40.3507, -99.6435, 40.6849, -99.1792] },
    { name: "Pierce", bbox: [42.0898, -97.8347, 42.4388, -97.3676] },
    { name: "Platte", bbox: [41.3331, -97.8305, 41.7432, -97.2524] },
    { name: "Polk", bbox: [41.0466, -97.8282, 41.3964, -97.3681] },
    { name: "Red Willow", bbox: [40.0015, -100.7588, 40.35, -100.1936] },
    { name: "Richardson", bbox: [40.0, -96.0107, 40.2619, -95.3083] },
    { name: "Rock", bbox: [42.086, -99.6777, 42.8043, -99.2346] },
    { name: "Saline", bbox: [40.3497, -97.3687, 40.6986, -96.9126] },
    { name: "Sarpy", bbox: [40.9956, -96.3274, 41.191, -95.8528] },
    { name: "Saunders", bbox: [41.0161, -96.9085, 41.4534, -96.3192] },
    { name: "Scotts Bluff", bbox: [41.698, -104.053, 42.0035, -103.3633] },
    { name: "Seward", bbox: [40.6979, -97.3684, 41.0469, -96.9109] },
    { name: "Sheridan", bbox: [42.0048, -102.7921, 43.0, -102.0062] },
    { name: "Sherman", bbox: [41.0466, -99.2076, 41.3942, -98.7443] },
    { name: "Sioux", bbox: [42.0017, -104.0531, 43.0014, -103.4016] },
    { name: "Stanton", bbox: [41.743, -97.3684, 42.0909, -97.0194] },
    { name: "Thayer", bbox: [40.0018, -97.8215, 40.3505, -97.3687] },
    { name: "Thomas", bbox: [41.7398, -100.8461, 42.0882, -100.2655] },
    { name: "Thurston", bbox: [42.0152, -96.8237, 42.282, -96.2729] },
    { name: "Valley", bbox: [41.3941, -99.212, 41.7406, -98.7516] },
    { name: "Washington", bbox: [41.3922, -96.4448, 41.6836, -95.9307] },
    { name: "Wayne", bbox: [42.0904, -97.3684, 42.3519, -96.8225] },
    { name: "Webster", bbox: [40.0022, -98.7268, 40.3504, -98.2736] },
    { name: "Wheeler", bbox: [41.7404, -98.7612, 42.0889, -98.2954] },
    { name: "York", bbox: [40.6985, -97.8263, 41.0469, -97.3681] },
  ],
  NH: [
    { name: "Belknap", bbox: [43.2847, -71.728, 43.765, -71.1601] },
    { name: "Carroll", bbox: [43.5297, -71.5646, 44.2848, -70.9533] },
    { name: "Cheshire", bbox: [42.7122, -72.5562, 43.182, -71.9288] },
    { name: "Coos", bbox: [44.0922, -71.7645, 45.3053, -71.0102] },
    { name: "Grafton", bbox: [43.5284, -72.3347, 44.4064, -71.3619] },
    { name: "Hillsborough", bbox: [42.697, -72.0624, 43.2073, -71.2455] },
    { name: "Merrimack", bbox: [43.009, -72.09, 43.5994, -71.2358] },
    { name: "Rockingham", bbox: [42.7376, -71.4418, 43.2742, -70.7039] },
    { name: "Strafford", bbox: [43.0805, -71.2472, 43.5394, -70.8162] },
    { name: "Sullivan", bbox: [43.1288, -72.4521, 43.6002, -71.9352] },
  ],
  NJ: [
    { name: "Atlantic", bbox: [39.2896, -74.9852, 39.7299, -74.3022] },
    { name: "Bergen", bbox: [40.7865, -74.2705, 41.1338, -73.894] },
    { name: "Burlington", bbox: [39.556, -75.056, 40.1473, -74.3899] },
    { name: "Camden", bbox: [39.6083, -75.1539, 39.996, -74.7363] },
    { name: "Cape May", bbox: [38.9285, -74.972, 39.3238, -74.5414] },
    { name: "Cumberland", bbox: [39.1776, -75.4073, 39.5686, -74.8559] },
    { name: "Essex", bbox: [40.6744, -74.3719, 40.9053, -74.1128] },
    { name: "Gloucester", bbox: [39.5148, -75.4406, 39.9061, -74.8772] },
    { name: "Hudson", bbox: [40.6419, -74.166, 40.8235, -73.9869] },
    { name: "Hunterdon", bbox: [40.3406, -75.1909, 40.7878, -74.7131] },
    { name: "Mercer", bbox: [40.1375, -74.938, 40.4242, -74.4843] },
    { name: "Middlesex", bbox: [40.2514, -74.6196, 40.6089, -74.2067] },
    { name: "Monmouth", bbox: [40.0791, -74.5878, 40.4765, -73.9714] },
    { name: "Morris", bbox: [40.6497, -74.8898, 41.0859, -74.2707] },
    { name: "Ocean", bbox: [39.4999, -74.5531, 40.1724, -74.0313] },
    { name: "Passaic", bbox: [40.82, -74.5029, 41.2034, -74.13] },
    { name: "Salem", bbox: [39.382, -75.5594, 39.7809, -75.062] },
    { name: "Somerset", bbox: [40.3744, -74.7825, 40.758, -74.4083] },
    { name: "Sussex", bbox: [40.9118, -74.9743, 41.3574, -74.3657] },
    { name: "Union", bbox: [40.5919, -74.4634, 40.7392, -74.1367] },
    { name: "Warren", bbox: [40.5913, -75.2039, 41.094, -74.7679] },
  ],
  NM: [
    { name: "Bernalillo", bbox: [34.8701, -107.1962, 35.2193, -106.1496] },
    { name: "Catron", bbox: [33.201, -109.0472, 34.5793, -107.7127] },
    { name: "Chaves", bbox: [32.5188, -105.3539, 34.0883, -103.5097] },
    { name: "Cibola", bbox: [34.5781, -109.0462, 35.3483, -107.0667] },
    { name: "Colfax", bbox: [36.218, -105.3777, 36.9962, -104.0079] },
    { name: "Curry", bbox: [34.3026, -103.74, 34.9541, -103.0425] },
    { name: "De Baca", bbox: [33.9954, -104.8931, 34.7793, -103.9459] },
    { name: "Doña Ana", bbox: [31.7835, -107.2995, 33.0528, -106.3405] },
    { name: "Eddy", bbox: [32.0, -104.8515, 32.9655, -103.7229] },
    { name: "Grant", bbox: [31.8637, -109.0475, 33.209, -107.6083] },
    { name: "Guadalupe", bbox: [34.3467, -105.313, 35.2163, -104.1248] },
    { name: "Harding", bbox: [35.3897, -104.4361, 36.2188, -103.365] },
    { name: "Hidalgo", bbox: [31.3323, -109.05, 32.7776, -108.2084] },
    { name: "Lea", bbox: [32.0002, -103.8146, 33.5706, -103.0526] },
    { name: "Lincoln", bbox: [33.1322, -106.3739, 34.347, -104.8852] },
    { name: "Los Alamos", bbox: [35.7557, -106.4007, 35.9663, -106.1717] },
    { name: "Luna", bbox: [31.7836, -108.2293, 32.6055, -107.2968] },
    { name: "McKinley", bbox: [34.959, -109.0465, 36.0023, -107.3066] },
    { name: "Mora", bbox: [35.7542, -105.7205, 36.2622, -104.3274] },
    { name: "Otero", bbox: [32.0005, -106.3772, 33.3908, -104.8478] },
    { name: "Quay", bbox: [34.6047, -104.1294, 35.74, -103.0414] },
    { name: "Rio Arriba", bbox: [35.9308, -107.6243, 37.0, -105.5304] },
    { name: "Roosevelt", bbox: [33.5703, -103.9488, 34.6051, -103.0435] },
    { name: "San Juan", bbox: [36.0003, -109.046, 37.0, -107.4209] },
    { name: "San Miguel", bbox: [35.0416, -105.7203, 35.871, -103.6371] },
    { name: "Sandoval", bbox: [35.2152, -107.6265, 36.2198, -106.2448] },
    { name: "Santa Fe", bbox: [35.0401, -106.2485, 36.0024, -105.7145] },
    { name: "Sierra", bbox: [32.6054, -108.0006, 33.4801, -106.3405] },
    { name: "Socorro", bbox: [33.4758, -107.7255, 34.5795, -105.924] },
    { name: "Taos", bbox: [36.013, -106.0584, 36.996, -105.2206] },
    { name: "Torrance", bbox: [34.2597, -106.47, 35.0421, -105.2903] },
    { name: "Union", bbox: [35.7393, -104.009, 37.0001, -103.002] },
    { name: "Valencia", bbox: [34.4398, -107.2044, 34.9581, -106.411] },
  ],
  NV: [
    { name: "Carson City", bbox: [39.0849, -120.0045, 39.2509, -119.551] },
    { name: "Churchill", bbox: [39.0737, -119.2252, 40.0025, -117.4616] },
    { name: "Clark", bbox: [35.0021, -115.8969, 36.8535, -114.0464] },
    { name: "Douglas", bbox: [38.5346, -120.0034, 39.114, -119.3107] },
    { name: "Elko", bbox: [40.1169, -117.0184, 41.9999, -114.0399] },
    { name: "Esmeralda", bbox: [36.9709, -118.4286, 38.4738, -117.1656] },
    { name: "Eureka", bbox: [39.1615, -116.6009, 41.0004, -115.8135] },
    { name: "Humboldt", bbox: [40.5261, -119.3311, 42.0003, -117.0183] },
    { name: "Lander", bbox: [39.0934, -117.8062, 41.0004, -116.5868] },
    { name: "Lincoln", bbox: [36.8421, -115.8969, 38.6774, -114.0485] },
    { name: "Lyon", bbox: [38.4147, -119.7126, 39.7404, -118.7538] },
    { name: "Mineral", bbox: [37.8937, -119.1569, 39.0746, -117.691] },
    { name: "Nye", bbox: [35.9636, -118.1963, 39.1634, -115.0008] },
    { name: "Pershing", bbox: [39.9986, -119.3393, 40.9609, -117.3006] },
    { name: "Storey", bbox: [39.2509, -119.7126, 39.6271, -119.2798] },
    { name: "Washoe", bbox: [39.1655, -120.0057, 41.9975, -119.1709] },
    { name: "White Pine", bbox: [38.6773, -115.9077, 40.1278, -114.0466] },
  ],
  NY: [
    { name: "Albany", bbox: [42.4082, -74.2543, 42.8207, -73.6768] },
    { name: "Allegany", bbox: [41.9985, -78.3088, 42.5215, -77.723] },
    { name: "Bronx", bbox: [40.7866, -73.9334, 40.9176, -73.7651] },
    { name: "Broome", bbox: [41.9989, -76.1302, 42.4157, -75.3596] },
    { name: "Cattaraugus", bbox: [41.9976, -79.0613, 42.5379, -78.3081] },
    { name: "Cayuga", bbox: [42.6235, -76.7367, 43.4191, -76.2656] },
    { name: "Chautauqua", bbox: [41.9985, -79.7622, 42.5697, -79.0608] },
    { name: "Chemung", bbox: [42.0001, -76.9657, 42.2937, -76.5383] },
    { name: "Chenango", bbox: [42.1949, -75.8898, 42.7441, -75.2959] },
    { name: "Clinton", bbox: [44.4297, -74.0274, 45.0108, -73.3386] },
    { name: "Columbia", bbox: [41.978, -73.9296, 42.51, -73.3525] },
    { name: "Cortland", bbox: [42.4076, -76.2747, 42.791, -75.864] },
    { name: "Delaware", bbox: [41.8509, -75.4218, 42.5178, -74.4435] },
    { name: "Dutchess", bbox: [41.4389, -74.0001, 42.0788, -73.4873] },
    { name: "Erie", bbox: [42.4426, -79.1367, 43.0887, -78.4639] },
    { name: "Essex", bbox: [43.7445, -74.3368, 44.5468, -73.2936] },
    { name: "Franklin", bbox: [44.0992, -74.725, 45.0059, -73.9097] },
    { name: "Fulton", bbox: [42.9829, -74.7599, 43.2861, -74.0975] },
    { name: "Genesee", bbox: [42.8628, -78.4655, 43.1336, -77.9059] },
    { name: "Greene", bbox: [42.0966, -74.5373, 42.4642, -73.7837] },
    { name: "Hamilton", bbox: [43.2214, -74.8677, 44.1206, -74.0471] },
    { name: "Herkimer", bbox: [42.8249, -75.2191, 44.097, -74.6963] },
    { name: "Jefferson", bbox: [43.6681, -76.367, 44.4033, -75.4461] },
    { name: "Kings", bbox: [40.5662, -74.0424, 40.7393, -73.8499] },
    { name: "Lewis", bbox: [43.4198, -75.8505, 44.2177, -75.1102] },
    { name: "Livingston", bbox: [42.4712, -78.0482, 42.9884, -77.4869] },
    { name: "Madison", bbox: [42.7238, -75.9934, 43.1852, -75.248] },
    { name: "Monroe", bbox: [42.9432, -77.9973, 43.3692, -77.3715] },
    { name: "Montgomery", bbox: [42.773, -74.7633, 43.0474, -74.0839] },
    { name: "Nassau", bbox: [40.5828, -73.7684, 40.9228, -73.4233] },
    { name: "New York", bbox: [40.6795, -74.0473, 40.8821, -73.907] },
    { name: "Niagara", bbox: [43.0301, -79.0705, 43.3748, -78.4604] },
    { name: "Oneida", bbox: [42.8633, -75.8868, 43.6152, -75.0692] },
    { name: "Onondaga", bbox: [42.7713, -76.4993, 43.2716, -75.8961] },
    { name: "Ontario", bbox: [42.5764, -77.6117, 43.0399, -76.9634] },
    { name: "Orange", bbox: [41.1429, -74.7559, 41.6327, -73.9533] },
    { name: "Orleans", bbox: [43.1286, -78.4664, 43.3765, -77.9956] },
    { name: "Oswego", bbox: [43.1556, -76.6171, 43.707, -75.7562] },
    { name: "Otsego", bbox: [42.3142, -75.4153, 42.9084, -74.6306] },
    { name: "Putnam", bbox: [41.3217, -73.9826, 41.5272, -73.5301] },
    { name: "Queens", bbox: [40.5452, -73.9628, 40.8051, -73.7006] },
    { name: "Rensselaer", bbox: [42.4642, -73.7846, 42.9437, -73.265] },
    { name: "Richmond", bbox: [40.4961, -74.2561, 40.6486, -74.0531] },
    { name: "Rockland", bbox: [40.9972, -74.2345, 41.3247, -73.8872] },
    { name: "Saratoga", bbox: [42.7755, -74.1601, 43.398, -73.5733] },
    { name: "Schenectady", bbox: [42.7143, -74.2723, 42.9559, -73.8094] },
    { name: "Schoharie", bbox: [42.355, -74.7116, 42.8296, -74.1697] },
    { name: "Schuyler", bbox: [42.2337, -77.1072, 42.5468, -76.6193] },
    { name: "Seneca", bbox: [42.5415, -76.9714, 43.024, -76.586] },
    { name: "St. Lawrence", bbox: [44.0504, -75.8601, 45.0159, -74.5257] },
    { name: "Steuben", bbox: [41.9988, -77.7499, 42.5804, -76.965] },
    { name: "Suffolk", bbox: [40.6099, -73.4971, 41.2901, -71.8562] },
    { name: "Sullivan", bbox: [41.4268, -75.1464, 42.0164, -74.3671] },
    { name: "Tioga", bbox: [41.9983, -76.5576, 42.4103, -76.0811] },
    { name: "Tompkins", bbox: [42.263, -76.6967, 42.6236, -76.2501] },
    { name: "Ulster", bbox: [41.5825, -74.7807, 42.1704, -73.9107] },
    { name: "Warren", bbox: [43.2538, -74.2146, 43.8037, -73.4381] },
    { name: "Washington", bbox: [42.9413, -73.6355, 43.8085, -73.242] },
    { name: "Wayne", bbox: [43.0125, -77.376, 43.3437, -76.7053] },
    { name: "Westchester", bbox: [40.8793, -73.9826, 41.3664, -73.4827] },
    { name: "Wyoming", bbox: [42.5192, -78.4646, 42.8675, -77.955] },
    { name: "Yates", bbox: [42.4631, -77.3671, 42.7642, -76.8898] },
  ],
  OH: [
    { name: "Adams", bbox: [38.603, -83.706, 39.0552, -83.2658] },
    { name: "Allen", bbox: [40.6431, -84.3974, 40.9204, -83.8801] },
    { name: "Ashland", bbox: [40.555, -82.4369, 41.0658, -82.125] },
    { name: "Ashtabula", bbox: [41.4999, -81.0048, 41.9775, -80.5192] },
    { name: "Athens", bbox: [39.1807, -82.2985, 39.5566, -81.7216] },
    { name: "Auglaize", bbox: [40.3545, -84.4562, 40.686, -83.8799] },
    { name: "Belmont", bbox: [39.8488, -81.2373, 40.1701, -80.7031] },
    { name: "Brown", bbox: [38.6371, -84.0527, 39.2542, -83.673] },
    { name: "Butler", bbox: [39.2923, -84.8195, 39.591, -84.3321] },
    { name: "Carroll", bbox: [40.4247, -81.3217, 40.7278, -80.862] },
    { name: "Champaign", bbox: [40.0102, -84.0361, 40.2735, -83.4945] },
    { name: "Clark", bbox: [39.7688, -84.0537, 40.0402, -83.5162] },
    { name: "Clermont", bbox: [38.7705, -84.3199, 39.2708, -83.9931] },
    { name: "Clinton", bbox: [39.2473, -84.0068, 39.5692, -83.5763] },
    { name: "Columbiana", bbox: [40.5825, -81.0873, 40.9016, -80.519] },
    { name: "Coshocton", bbox: [40.1522, -82.1959, 40.4563, -81.616] },
    { name: "Crawford", bbox: [40.7029, -83.1127, 40.9966, -82.7248] },
    { name: "Cuyahoga", bbox: [41.275, -81.9713, 41.6313, -81.391] },
    { name: "Darke", bbox: [39.9169, -84.8124, 40.3543, -84.4259] },
    { name: "Defiance", bbox: [41.1655, -84.8041, 41.4278, -84.2282] },
    { name: "Delaware", bbox: [40.1259, -83.2486, 40.444, -82.7449] },
    { name: "Erie", bbox: [41.2836, -82.9522, 41.6196, -82.3423] },
    { name: "Fairfield", bbox: [39.5544, -82.843, 39.9412, -82.3745] },
    { name: "Fayette", bbox: [39.3774, -83.6702, 39.7169, -83.2524] },
    { name: "Franklin", bbox: [39.795, -83.2538, 40.1431, -82.7618] },
    { name: "Fulton", bbox: [41.4855, -84.3995, 41.7201, -83.8804] },
    { name: "Gallia", bbox: [38.5826, -82.5827, 39.0351, -82.0955] },
    { name: "Geauga", bbox: [41.3479, -81.3917, 41.7151, -81.003] },
    { name: "Greene", bbox: [39.5503, -84.1142, 39.8505, -83.6472] },
    { name: "Guernsey", bbox: [39.8391, -81.7286, 40.2213, -81.2259] },
    { name: "Hamilton", bbox: [39.0221, -84.8202, 39.3119, -84.2594] },
    { name: "Hancock", bbox: [40.8181, -83.8811, 41.1678, -83.4203] },
    { name: "Hardin", bbox: [40.5041, -83.8802, 40.8199, -83.4153] },
    { name: "Harrison", bbox: [40.1595, -81.3396, 40.4335, -80.8655] },
    { name: "Henry", bbox: [41.1659, -84.3419, 41.4875, -83.8811] },
    { name: "Highland", bbox: [39.0189, -83.8722, 39.3787, -83.3535] },
    { name: "Hocking", bbox: [39.3682, -82.7486, 39.6617, -82.1592] },
    { name: "Holmes", bbox: [40.4439, -82.2207, 40.6682, -81.6492] },
    { name: "Huron", bbox: [40.9929, -82.8415, 41.29, -82.3365] },
    { name: "Jackson", bbox: [38.8445, -82.8071, 39.208, -82.4247] },
    { name: "Jefferson", bbox: [40.1572, -80.9419, 40.5994, -80.5992] },
    { name: "Knox", bbox: [40.2391, -82.7507, 40.5731, -82.1791] },
    { name: "Lake", bbox: [41.5697, -81.4889, 41.8549, -81.0021] },
    { name: "Lawrence", bbox: [38.4043, -82.816, 38.8491, -82.2871] },
    { name: "Licking", bbox: [39.9133, -82.7825, 40.277, -82.1828] },
    { name: "Logan", bbox: [40.2294, -84.0148, 40.5387, -83.5202] },
    { name: "Lorain", bbox: [41.0635, -82.3481, 41.5156, -81.8771] },
    { name: "Lucas", bbox: [41.4145, -83.8832, 41.7326, -83.1657] },
    { name: "Madison", bbox: [39.6954, -83.6533, 40.1115, -83.2063] },
    { name: "Mahoning", bbox: [40.8999, -81.0869, 41.1342, -80.5189] },
    { name: "Marion", bbox: [40.4338, -83.4198, 40.705, -82.8583] },
    { name: "Medina", bbox: [40.9886, -82.1734, 41.2771, -81.685] },
    { name: "Meigs", bbox: [38.8785, -82.3229, 39.2055, -81.7473] },
    { name: "Mercer", bbox: [40.3528, -84.8041, 40.7283, -84.4316] },
    { name: "Miami", bbox: [39.8798, -84.4326, 40.197, -84.0229] },
    { name: "Monroe", bbox: [39.5405, -81.3191, 39.8695, -80.8123] },
    { name: "Montgomery", bbox: [39.578, -84.4854, 39.923, -84.051] },
    { name: "Morgan", bbox: [39.4502, -82.0766, 39.771, -81.5861] },
    { name: "Morrow", bbox: [40.3451, -83.0208, 40.7112, -82.6236] },
    { name: "Muskingum", bbox: [39.7556, -82.234, 40.1669, -81.6941] },
    { name: "Noble", bbox: [39.5833, -81.6974, 39.9513, -81.2341] },
    { name: "Ottawa", bbox: [41.4575, -83.4159, 41.7245, -82.6947] },
    { name: "Paulding", bbox: [40.9894, -84.8036, 41.2535, -84.3416] },
    { name: "Perry", bbox: [39.5508, -82.4724, 39.9304, -82.0242] },
    { name: "Pickaway", bbox: [39.4684, -83.2667, 39.8125, -82.7315] },
    { name: "Pike", bbox: [38.9481, -83.3856, 39.1976, -82.7859] },
    { name: "Portage", bbox: [40.9878, -81.3934, 41.3483, -81.0017] },
    { name: "Preble", bbox: [39.5677, -84.8152, 39.9185, -84.4789] },
    { name: "Putnam", bbox: [40.8591, -84.3995, 41.1678, -83.8804] },
    { name: "Richland", bbox: [40.5499, -82.7272, 40.9956, -82.337] },
    { name: "Ross", bbox: [39.1678, -83.3935, 39.5162, -82.7407] },
    { name: "Sandusky", bbox: [41.254, -83.4198, 41.5002, -82.8401] },
    { name: "Scioto", bbox: [38.5707, -83.2708, 39.0158, -82.65] },
    { name: "Seneca", bbox: [40.9919, -83.4211, 41.2553, -82.8295] },
    { name: "Shelby", bbox: [40.1839, -84.4346, 40.4831, -84.0024] },
    { name: "Stark", bbox: [40.6351, -81.65, 40.9885, -81.0866] },
    { name: "Summit", bbox: [40.9065, -81.6885, 41.3511, -81.3916] },
    { name: "Trumbull", bbox: [41.1334, -81.0033, 41.5017, -80.5187] },
    { name: "Tuscarawas", bbox: [40.2143, -81.7123, 40.6516, -81.2647] },
    { name: "Union", bbox: [40.1069, -83.5513, 40.507, -83.17] },
    { name: "Van Wert", bbox: [40.6849, -84.8033, 40.9903, -84.3405] },
    { name: "Vinton", bbox: [39.0277, -82.7629, 39.3958, -82.2602] },
    { name: "Warren", bbox: [39.2551, -84.3652, 39.5895, -83.977] },
    { name: "Washington", bbox: [39.2124, -81.8537, 39.646, -81.0368] },
    { name: "Wayne", bbox: [40.6681, -82.1293, 40.9918, -81.6477] },
    { name: "Williams", bbox: [41.426, -84.8062, 41.7058, -84.3417] },
    { name: "Wood", bbox: [41.1668, -83.8832, 41.6189, -83.4146] },
    { name: "Wyandot", bbox: [40.6868, -83.5159, 40.9934, -83.1114] },
  ],
  OK: [
    { name: "Adair", bbox: [35.6386, -94.8073, 36.1619, -94.4726] },
    { name: "Alfalfa", bbox: [36.4631, -98.5447, 36.999, -98.1043] },
    { name: "Atoka", bbox: [34.1567, -96.4076, 34.6806, -95.6717] },
    { name: "Beaver", bbox: [36.4992, -100.9542, 37.0022, -100.0026] },
    { name: "Beckham", bbox: [35.0301, -100.0004, 35.5089, -99.3602] },
    { name: "Blaine", bbox: [35.5515, -98.6369, 36.1658, -98.2071] },
    { name: "Bryan", bbox: [33.7168, -96.6247, 34.1573, -95.7572] },
    { name: "Caddo", bbox: [34.8549, -98.6233, 35.5516, -98.0926] },
    { name: "Canadian", bbox: [35.3238, -98.3134, 35.726, -97.6713] },
    { name: "Carter", bbox: [34.071, -97.5626, 34.507, -96.9335] },
    { name: "Cherokee", bbox: [35.6386, -95.2787, 36.1618, -94.7973] },
    { name: "Choctaw", bbox: [33.8663, -95.9916, 34.157, -95.156] },
    { name: "Cimarron", bbox: [36.5001, -103.0026, 37.0001, -102.0282] },
    { name: "Cleveland", bbox: [34.9282, -97.6715, 35.3774, -97.1421] },
    { name: "Coal", bbox: [34.4184, -96.5139, 34.7676, -96.0919] },
    { name: "Comanche", bbox: [34.4059, -98.8261, 34.8555, -98.0891] },
    { name: "Cotton", bbox: [34.0643, -98.662, 34.5071, -98.1391] },
    { name: "Craig", bbox: [36.5099, -95.4317, 36.9996, -94.9994] },
    { name: "Creek", bbox: [35.639, -96.6214, 36.1636, -96.0295] },
    { name: "Custer", bbox: [35.4642, -99.3758, 35.8124, -98.6231] },
    { name: "Delaware", bbox: [36.1614, -95.0113, 36.6706, -94.5628] },
    { name: "Dewey", bbox: [35.8122, -99.3821, 36.1649, -98.632] },
    { name: "Ellis", bbox: [35.8598, -100.0038, 36.5932, -99.381] },
    { name: "Garfield", bbox: [36.1645, -98.1044, 36.5936, -97.4608] },
    { name: "Garvin", bbox: [34.5065, -97.6684, 34.8552, -96.9323] },
    { name: "Grady", bbox: [34.6811, -98.096, 35.3778, -97.6681] },
    { name: "Grant", bbox: [36.5936, -98.112, 36.9991, -97.4623] },
    { name: "Greer", bbox: [34.7246, -99.8886, 35.1168, -99.2465] },
    { name: "Harmon", bbox: [34.505, -100.0004, 35.0304, -99.6665] },
    { name: "Harper", bbox: [36.5928, -100.0032, 37.0017, -99.2952] },
    { name: "Haskell", bbox: [35.0583, -95.455, 35.4589, -94.8136] },
    { name: "Hughes", bbox: [34.7675, -96.4908, 35.2901, -95.9814] },
    { name: "Jackson", bbox: [34.3377, -99.8464, 34.8504, -99.0525] },
    { name: "Jefferson", bbox: [33.8494, -98.1691, 34.2898, -97.5608] },
    { name: "Johnston", bbox: [34.1144, -96.9337, 34.5061, -96.4073] },
    { name: "Kay", bbox: [36.5936, -97.4625, 36.9992, -96.7498] },
    { name: "Kingfisher", bbox: [35.7251, -98.2105, 36.1649, -97.674] },
    { name: "Kiowa", bbox: [34.5944, -99.4093, 35.1167, -98.6198] },
    { name: "Latimer", bbox: [34.6807, -95.5145, 35.0585, -94.9277] },
    { name: "Le Flore", bbox: [34.5068, -95.0596, 35.3865, -94.4318] },
    { name: "Lincoln", bbox: [35.4627, -97.1415, 35.942, -96.6206] },
    { name: "Logan", bbox: [35.7244, -97.6756, 36.1647, -97.1406] },
    { name: "Love", bbox: [33.7172, -97.5611, 34.0711, -96.9345] },
    { name: "Major", bbox: [36.1616, -98.9603, 36.5069, -98.1039] },
    { name: "Marshall", bbox: [33.8244, -96.9696, 34.1726, -96.548] },
    { name: "Mayes", bbox: [36.0745, -95.44, 36.5102, -95.0057] },
    { name: "McClain", bbox: [34.8545, -97.6716, 35.3375, -96.9306] },
    { name: "McCurtain", bbox: [33.6158, -95.1565, 34.5075, -94.4611] },
    { name: "McIntosh", bbox: [35.1516, -95.9837, 35.5522, -95.3447] },
    { name: "Murray", bbox: [34.3327, -97.3522, 34.6368, -96.8273] },
    { name: "Muskogee", bbox: [35.2616, -95.7663, 35.8568, -95.0499] },
    { name: "Noble", bbox: [36.1591, -97.4616, 36.5989, -96.9026] },
    { name: "Nowata", bbox: [36.5975, -95.8098, 36.9994, -95.4076] },
    { name: "Okfuskee", bbox: [35.2899, -96.6249, 35.6391, -95.9813] },
    { name: "Oklahoma", bbox: [35.3769, -97.674, 35.726, -97.1411] },
    { name: "Okmulgee", bbox: [35.3767, -96.1928, 35.857, -95.713] },
    { name: "Osage", bbox: [36.1613, -97.0641, 36.9993, -96.0008] },
    { name: "Ottawa", bbox: [36.6679, -95.0076, 36.9995, -94.618] },
    { name: "Pawnee", bbox: [36.1589, -97.0321, 36.5626, -96.2433] },
    { name: "Payne", bbox: [35.9415, -97.3541, 36.2465, -96.6211] },
    { name: "Pittsburg", bbox: [34.5935, -96.092, 35.296, -95.3492] },
    { name: "Pontotoc", bbox: [34.5054, -96.9325, 34.9644, -96.4062] },
    { name: "Pottawatomie", bbox: [34.9, -97.1423, 35.464, -96.6237] },
    { name: "Pushmataha", bbox: [34.1567, -95.7794, 34.6811, -94.9376] },
    { name: "Roger Mills", bbox: [35.4217, -100.0004, 36.0129, -99.3641] },
    { name: "Rogers", bbox: [36.0752, -95.8154, 36.5976, -95.3282] },
    { name: "Seminole", bbox: [34.8568, -96.7767, 35.4677, -96.4413] },
    { name: "Sequoyah", bbox: [35.295, -95.1324, 35.6389, -94.4312] },
    { name: "Stephens", bbox: [34.2892, -98.1421, 34.6813, -97.5623] },
    { name: "Texas", bbox: [36.4992, -102.0323, 36.9982, -100.9455] },
    { name: "Tillman", bbox: [34.136, -99.2207, 34.6379, -98.6097] },
    { name: "Tulsa", bbox: [35.8559, -96.2979, 36.4237, -95.7617] },
    { name: "Wagoner", bbox: [35.7876, -95.82, 36.1628, -95.2079] },
    { name: "Washington", bbox: [36.4236, -96.0012, 36.9993, -95.7868] },
    { name: "Washita", bbox: [35.0974, -99.3642, 35.4653, -98.6211] },
    { name: "Woods", bbox: [36.3926, -99.4562, 36.9996, -98.5336] },
    { name: "Woodward", bbox: [36.1616, -99.6056, 36.8196, -98.9558] },
  ],
  OR: [
    { name: "Baker", bbox: [44.2551, -118.5193, 45.0808, -116.7839] },
    { name: "Benton", bbox: [44.2836, -123.8169, 44.7212, -123.0736] },
    { name: "Clackamas", bbox: [44.8857, -122.868, 45.4617, -121.6594] },
    { name: "Clatsop", bbox: [45.7732, -124.0243, 46.2695, -123.361] },
    { name: "Columbia", bbox: [45.7215, -123.3636, 46.189, -122.7601] },
    { name: "Coos", bbox: [42.6664, -124.4793, 43.6103, -123.702] },
    { name: "Crook", bbox: [43.6981, -121.1073, 44.564, -119.6556] },
    { name: "Curry", bbox: [41.9955, -124.5524, 42.955, -123.7162] },
    { name: "Deschutes", bbox: [43.6103, -122.0027, 44.3924, -119.8964] },
    { name: "Douglas", bbox: [42.7025, -124.2189, 43.9451, -121.9738] },
    { name: "Gilliam", bbox: [45.0678, -120.6536, 45.8122, -119.7601] },
    { name: "Grant", bbox: [43.9591, -119.672, 44.996, -118.2274] },
    { name: "Harney", bbox: [41.9927, -119.9439, 44.0477, -118.1954] },
    { name: "Hood River", bbox: [45.258, -121.9222, 45.7265, -121.4406] },
    { name: "Jackson", bbox: [42.003, -123.2308, 42.9966, -122.2819] },
    { name: "Jefferson", bbox: [44.39, -121.8427, 44.8256, -120.3714] },
    { name: "Josephine", bbox: [41.9955, -124.042, 42.7842, -123.2299] },
    { name: "Klamath", bbox: [41.9933, -122.2904, 43.6166, -120.8795] },
    { name: "Lake", bbox: [41.9931, -121.3499, 43.6166, -119.3602] },
    { name: "Lane", bbox: [43.4371, -124.1587, 44.2905, -121.7686] },
    { name: "Lincoln", bbox: [44.2763, -124.1158, 45.045, -123.5972] },
    { name: "Linn", bbox: [44.2, -123.2603, 44.7916, -121.7941] },
    { name: "Malheur", bbox: [41.997, -118.2321, 44.4445, -116.8941] },
    { name: "Marion", bbox: [44.6839, -123.1787, 45.2843, -121.7338] },
    { name: "Morrow", bbox: [44.9935, -120.0067, 45.9255, -119.1454] },
    { name: "Multnomah", bbox: [45.4327, -122.9292, 45.7286, -121.8204] },
    { name: "Polk", bbox: [44.7194, -123.7254, 45.0761, -123.0395] },
    { name: "Sherman", bbox: [45.0829, -121.0312, 45.7372, -120.3578] },
    { name: "Tillamook", bbox: [45.044, -124.018, 45.7832, -123.2994] },
    { name: "Umatilla", bbox: [44.9959, -119.4346, 46.001, -117.9729] },
    { name: "Union", bbox: [44.9583, -118.6977, 45.861, -117.2666] },
    { name: "Wallowa", bbox: [45.079, -117.9778, 46.0007, -116.4635] },
    { name: "Wasco", bbox: [44.8216, -121.8051, 45.7049, -120.3714] },
    { name: "Washington", bbox: [45.3174, -123.4847, 45.7797, -122.7436] },
    { name: "Wheeler", bbox: [44.3067, -120.4952, 45.0685, -119.6521] },
    { name: "Yamhill", bbox: [45.0751, -123.7848, 45.4338, -122.8497] },
  ],
  PA: [
    { name: "Adams", bbox: [39.72, -77.4711, 40.0699, -76.9549] },
    { name: "Allegheny", bbox: [40.1944, -80.3609, 40.6743, -79.6926] },
    { name: "Armstrong", bbox: [40.5301, -79.6929, 41.1707, -79.2152] },
    { name: "Beaver", bbox: [40.4774, -80.5191, 40.8552, -80.1449] },
    { name: "Bedford", bbox: [39.7226, -78.8084, 40.327, -78.1349] },
    { name: "Berks", bbox: [40.1371, -76.4402, 40.6773, -75.5297] },
    { name: "Blair", bbox: [40.2421, -78.6204, 40.743, -78.1165] },
    { name: "Bradford", bbox: [41.5413, -76.9271, 42.0018, -76.1152] },
    { name: "Bucks", bbox: [40.0489, -75.4841, 40.6086, -74.7216] },
    { name: "Butler", bbox: [40.6697, -80.1653, 41.1729, -79.69] },
    { name: "Cambria", bbox: [40.2429, -79.056, 40.726, -78.3504] },
    { name: "Cameron", bbox: [41.2169, -78.42, 41.6182, -77.9888] },
    { name: "Carbon", bbox: [40.7354, -75.9973, 41.1223, -75.4742] },
    { name: "Centre", bbox: [40.6916, -78.3765, 41.2528, -77.1442] },
    { name: "Chester", bbox: [39.7216, -76.1356, 40.2419, -75.3611] },
    { name: "Clarion", bbox: [40.9741, -79.695, 41.4361, -79.2072] },
    { name: "Clearfield", bbox: [40.7244, -78.8064, 41.2538, -78.0382] },
    { name: "Clinton", bbox: [40.9629, -78.0934, 41.4786, -77.1437] },
    { name: "Columbia", bbox: [40.7755, -76.6408, 41.3102, -76.2078] },
    { name: "Crawford", bbox: [41.4804, -80.5194, 41.8501, -79.6121] },
    { name: "Cumberland", bbox: [39.9441, -77.6147, 40.3285, -76.859] },
    { name: "Dauphin", bbox: [40.1201, -77.0286, 40.6581, -76.5354] },
    { name: "Delaware", bbox: [39.8018, -75.5948, 40.0655, -75.211] },
    { name: "Elk", bbox: [41.2019, -79.0951, 41.6299, -78.2368] },
    { name: "Erie", bbox: [41.8496, -80.5194, 42.2699, -79.6108] },
    { name: "Fayette", bbox: [39.7207, -79.998, 40.1428, -79.2937] },
    { name: "Forest", bbox: [41.3319, -79.5123, 41.626, -78.956] },
    { name: "Franklin", bbox: [39.72, -78.0991, 40.2898, -77.4594] },
    { name: "Fulton", bbox: [39.7223, -78.3806, 40.1651, -77.8645] },
    { name: "Greene", bbox: [39.7208, -80.5193, 39.9996, -79.9153] },
    { name: "Huntingdon", bbox: [40.0616, -78.2573, 40.7437, -77.6813] },
    { name: "Indiana", bbox: [40.3809, -79.454, 40.9113, -78.8017] },
    { name: "Jefferson", bbox: [40.906, -79.2153, 41.3755, -78.7102] },
    { name: "Juniata", bbox: [40.2636, -77.7521, 40.6936, -76.9397] },
    { name: "Lackawanna", bbox: [41.1615, -75.8347, 41.6423, -75.4414] },
    { name: "Lancaster", bbox: [39.7213, -76.7216, 40.316, -75.8734] },
    { name: "Lawrence", bbox: [40.8513, -80.5198, 41.1265, -80.0969] },
    { name: "Lebanon", bbox: [40.1966, -76.678, 40.5552, -76.1512] },
    { name: "Lehigh", bbox: [40.4185, -75.8915, 40.7874, -75.3335] },
    { name: "Luzerne", bbox: [40.902, -76.3179, 41.4272, -75.6007] },
    { name: "Lycoming", bbox: [41.0688, -77.5993, 41.5969, -76.4476] },
    { name: "McKean", bbox: [41.6022, -78.9561, 42.0, -78.2034] },
    { name: "Mercer", bbox: [41.0698, -80.5193, 41.49, -79.9998] },
    { name: "Mifflin", bbox: [40.3785, -77.9138, 40.8469, -77.2879] },
    { name: "Monroe", bbox: [40.8147, -75.6496, 41.2521, -74.9807] },
    { name: "Montgomery", bbox: [39.977, -75.6968, 40.447, -75.0151] },
    { name: "Montour", bbox: [40.8825, -76.7929, 41.172, -76.515] },
    { name: "Northampton", bbox: [40.5371, -75.609, 40.9683, -75.051] },
    { name: "Northumberland", bbox: [40.6101, -76.9494, 41.1758, -76.3802] },
    { name: "Perry", bbox: [40.1985, -77.6718, 40.6282, -76.915] },
    { name: "Philadelphia", bbox: [39.8657, -75.2765, 40.138, -74.9562] },
    { name: "Pike", bbox: [41.0782, -75.3592, 41.6069, -74.6898] },
    { name: "Potter", bbox: [41.4748, -78.2066, 42.0005, -77.5981] },
    { name: "Schuylkill", bbox: [40.496, -76.7016, 40.9497, -75.7578] },
    { name: "Snyder", bbox: [40.6384, -77.3566, 40.888, -76.7987] },
    { name: "Somerset", bbox: [39.7213, -79.4176, 40.2851, -78.6584] },
    { name: "Sullivan", bbox: [41.2756, -76.8137, 41.59, -76.2201] },
    { name: "Susquehanna", bbox: [41.6414, -76.1455, 41.9993, -75.4624] },
    { name: "Tioga", bbox: [41.5423, -77.61, 42.0017, -76.8747] },
    { name: "Union", bbox: [40.8073, -77.3642, 41.1391, -76.8002] },
    { name: "Venango", bbox: [41.1719, -79.9998, 41.6246, -79.4778] },
    { name: "Warren", bbox: [41.6234, -79.6129, 41.9993, -78.9189] },
    { name: "Washington", bbox: [39.9622, -80.5192, 40.4777, -79.8706] },
    { name: "Wayne", bbox: [41.2325, -75.5056, 41.9994, -75.0482] },
    { name: "Westmoreland", bbox: [40.0404, -79.8774, 40.6697, -78.9746] },
    { name: "Wyoming", bbox: [41.3765, -76.2831, 41.6518, -75.7199] },
    { name: "York", bbox: [39.7201, -77.1374, 40.2263, -76.2398] },
  ],
  RI: [
    { name: "Bristol", bbox: [41.6426, -71.3652, 41.7761, -71.2248] },
    { name: "Kent", bbox: [41.5969, -71.7897, 41.7553, -71.3532] },
    { name: "Newport", bbox: [41.4486, -71.4006, 41.6751, -71.1206] },
    { name: "Providence", bbox: [41.7246, -71.7992, 42.0188, -71.3178] },
    { name: "Washington", bbox: [41.1463, -71.8628, 41.6538, -71.4038] },
  ],
  SC: [
    { name: "Abbeville", bbox: [34.0124, -82.7415, 34.484, -82.2463] },
    { name: "Aiken", bbox: [33.1801, -82.0143, 33.8772, -81.1873] },
    { name: "Allendale", bbox: [32.745, -81.6158, 33.1583, -81.0823] },
    { name: "Anderson", bbox: [34.2087, -82.9922, 34.8195, -82.314] },
    { name: "Bamberg", bbox: [33.0266, -81.2278, 33.44, -80.7979] },
    { name: "Barnwell", bbox: [33.0925, -81.7723, 33.4904, -81.1931] },
    { name: "Beaufort", bbox: [32.0798, -81.0163, 32.7043, -80.4293] },
    { name: "Berkeley", bbox: [32.824, -80.3619, 33.5009, -79.4467] },
    { name: "Calhoun", bbox: [33.471, -81.0585, 33.8801, -80.4963] },
    { name: "Charleston", bbox: [32.5002, -80.4461, 33.2151, -79.2688] },
    { name: "Cherokee", bbox: [34.8393, -81.8744, 35.1841, -81.3666] },
    { name: "Chester", bbox: [34.5431, -81.4785, 34.8215, -80.8603] },
    { name: "Chesterfield", bbox: [34.3662, -80.5617, 34.8175, -79.7782] },
    { name: "Clarendon", bbox: [33.4304, -80.5341, 33.9465, -79.8756] },
    { name: "Colleton", bbox: [32.4707, -81.0823, 33.1811, -80.2496] },
    { name: "Darlington", bbox: [34.086, -80.2887, 34.5319, -79.6578] },
    { name: "Dillon", bbox: [34.2309, -79.6334, 34.621, -79.0712] },
    { name: "Dorchester", bbox: [32.8189, -80.7903, 33.3345, -80.079] },
    { name: "Edgefield", bbox: [33.5303, -82.1724, 33.9754, -81.6518] },
    { name: "Fairfield", bbox: [34.1746, -81.4275, 34.572, -80.7699] },
    { name: "Florence", bbox: [33.7754, -80.0728, 34.3052, -79.3243] },
    { name: "Georgetown", bbox: [33.1101, -79.677, 33.7799, -79.0021] },
    { name: "Greenville", bbox: [34.484, -82.7645, 35.2105, -82.1468] },
    { name: "Greenwood", bbox: [33.9532, -82.3342, 34.4097, -81.8701] },
    { name: "Hampton", bbox: [32.5448, -81.4187, 33.0266, -80.8263] },
    { name: "Horry", bbox: [33.5718, -79.3391, 34.2992, -78.5411] },
    { name: "Jasper", bbox: [32.0346, -81.2868, 32.7531, -80.8295] },
    { name: "Kershaw", bbox: [34.069, -80.8792, 34.6148, -80.2869] },
    { name: "Lancaster", bbox: [34.4578, -80.9064, 35.0766, -80.4084] },
    { name: "Laurens", bbox: [34.2031, -82.314, 34.7856, -81.6436] },
    { name: "Lee", bbox: [33.952, -80.4813, 34.3662, -80.0006] },
    { name: "Lexington", bbox: [33.6529, -81.5715, 34.1976, -80.9263] },
    { name: "Marion", bbox: [33.6942, -79.569, 34.3006, -79.1267] },
    { name: "Marlboro", bbox: [34.298, -79.9276, 34.8066, -79.45] },
    { name: "McCormick", bbox: [33.5897, -82.5971, 34.0719, -82.0451] },
    { name: "Newberry", bbox: [34.0766, -81.945, 34.5337, -81.3169] },
    { name: "Oconee", bbox: [34.4744, -83.3525, 35.056, -82.8403] },
    { name: "Orangeburg", bbox: [33.1769, -81.3735, 33.7071, -80.2223] },
    { name: "Pickens", bbox: [34.6232, -82.9158, 35.0846, -82.4867] },
    { name: "Richland", bbox: [33.7432, -81.3453, 34.2688, -80.6162] },
    { name: "Saluda", bbox: [33.8145, -82.0083, 34.1876, -81.472] },
    { name: "Spartanburg", bbox: [34.5945, -82.2257, 35.196, -81.7117] },
    { name: "Sumter", bbox: [33.6439, -80.6335, 34.1687, -79.8935] },
    { name: "Union", bbox: [34.445, -81.854, 34.9126, -81.4198] },
    { name: "Williamsburg", bbox: [33.3049, -80.1017, 33.8852, -79.317] },
    { name: "York", bbox: [34.8207, -81.4884, 35.1649, -80.8687] },
  ],
  SD: [
    { name: "Aurora", bbox: [43.4987, -98.8078, 43.9377, -98.3206] },
    { name: "Beadle", bbox: [44.1952, -98.7058, 44.6342, -97.853] },
    { name: "Bennett", bbox: [42.9962, -102.1108, 43.3899, -101.2277] },
    { name: "Bon Homme", bbox: [42.7624, -98.1574, 43.1688, -97.6351] },
    { name: "Brookings", bbox: [44.1957, -97.1297, 44.5438, -96.4518] },
    { name: "Brown", bbox: [45.2404, -98.725, 45.9387, -97.9788] },
    { name: "Brule", bbox: [43.4992, -99.4588, 43.9352, -98.7946] },
    { name: "Buffalo", bbox: [43.9338, -99.5766, 44.1966, -98.926] },
    { name: "Butte", bbox: [44.571, -104.0577, 45.2129, -102.9573] },
    { name: "Campbell", bbox: [45.5934, -100.4994, 45.9436, -99.7175] },
    { name: "Charles Mix", bbox: [42.8319, -99.3043, 43.4999, -98.069] },
    { name: "Clark", bbox: [44.5439, -97.9818, 45.1533, -97.4913] },
    { name: "Clay", bbox: [42.7034, -97.1631, 43.0837, -96.8057] },
    { name: "Codington", bbox: [44.804, -97.4943, 45.1518, -96.8823] },
    { name: "Corson", bbox: [45.4724, -102.0007, 45.9446, -100.309] },
    { name: "Custer", bbox: [43.4768, -104.0551, 43.8554, -102.6872] },
    { name: "Davison", bbox: [43.4983, -98.3252, 43.8511, -97.965] },
    { name: "Day", bbox: [45.1516, -97.9818, 45.5885, -97.2262] },
    { name: "Deuel", bbox: [44.5436, -96.8855, 44.9775, -96.4514] },
    { name: "Dewey", bbox: [44.7242, -101.501, 45.4729, -100.2602] },
    { name: "Douglas", bbox: [43.1968, -98.7058, 43.4993, -98.1095] },
    { name: "Edmunds", bbox: [45.2438, -99.709, 45.5934, -98.7222] },
    { name: "Fall River", bbox: [43.0005, -104.0548, 43.4788, -103.0008] },
    { name: "Faulk", bbox: [44.8969, -99.5734, 45.2454, -98.7165] },
    { name: "Grant", bbox: [44.9769, -97.2263, 45.3269, -96.452] },
    { name: "Gregory", bbox: [42.998, -99.5345, 43.4998, -98.4985] },
    { name: "Haakon", bbox: [43.9945, -102.0073, 44.7471, -101.0468] },
    { name: "Hamlin", bbox: [44.5431, -97.4923, 44.8044, -96.8846] },
    { name: "Hand", bbox: [44.1948, -99.3118, 44.8972, -98.7005] },
    { name: "Hanson", bbox: [43.499, -97.9674, 43.8507, -97.607] },
    { name: "Harding", bbox: [45.2129, -104.0454, 45.9453, -102.9421] },
    { name: "Hughes", bbox: [44.1037, -100.574, 44.5481, -99.6122] },
    { name: "Hutchinson", bbox: [43.1683, -98.1148, 43.4998, -97.3992] },
    { name: "Hyde", bbox: [44.1924, -99.6764, 44.8975, -99.3002] },
    { name: "Jackson", bbox: [43.3892, -102.1392, 43.9949, -101.0641] },
    { name: "Jerauld", bbox: [43.9351, -98.927, 44.1967, -98.3315] },
    { name: "Jones", bbox: [43.7076, -101.0643, 44.1687, -100.339] },
    { name: "Kingsbury", bbox: [44.195, -97.8537, 44.5444, -97.128] },
    { name: "Lake", bbox: [43.848, -97.3701, 44.1959, -96.8887] },
    { name: "Lawrence", bbox: [44.1408, -104.0559, 44.6048, -103.4525] },
    { name: "Lincoln", bbox: [43.0834, -96.9248, 43.5005, -96.4366] },
    { name: "Lyman", bbox: [43.4996, -100.3672, 44.2175, -99.2979] },
    { name: "Marshall", bbox: [45.5582, -97.9796, 45.9359, -97.2271] },
    { name: "McCook", bbox: [43.4997, -97.6085, 43.8491, -97.1291] },
    { name: "McPherson", bbox: [45.5913, -99.7181, 45.9411, -98.7244] },
    { name: "Meade", bbox: [44.1402, -103.5744, 45.0396, -102.0] },
    { name: "Mellette", bbox: [43.3892, -101.2283, 43.8579, -100.2142] },
    { name: "Miner", bbox: [43.8485, -97.8511, 44.1952, -97.3695] },
    { name: "Minnehaha", bbox: [43.4997, -97.1295, 43.8495, -96.453] },
    { name: "Moody", bbox: [43.8476, -96.8892, 44.1968, -96.4528] },
    { name: "Pennington", bbox: [43.6878, -104.0551, 44.5109, -102.0011] },
    { name: "Perkins", bbox: [45.038, -102.9574, 45.9455, -101.9998] },
    { name: "Potter", bbox: [44.8973, -100.4048, 45.2468, -99.5727] },
    { name: "Roberts", bbox: [45.2969, -97.2283, 45.9359, -96.47] },
    { name: "Sanborn", bbox: [43.8499, -98.332, 44.1966, -97.8495] },
    { name: "Shannon", bbox: [42.9994, -103.0011, 43.7009, -102.0825] },
    { name: "Spink", bbox: [44.6316, -98.7178, 45.2437, -97.9778] },
    { name: "Stanley", bbox: [44.1681, -101.1668, 44.7832, -99.8921] },
    { name: "Sully", bbox: [44.5474, -100.7176, 44.8977, -99.6731] },
    { name: "Todd", bbox: [42.9978, -101.2282, 43.3903, -100.1984] },
    { name: "Tripp", bbox: [42.9979, -100.2308, 43.7659, -99.534] },
    { name: "Turner", bbox: [43.0831, -97.4014, 43.5, -96.9241] },
    { name: "Union", bbox: [42.4798, -96.8066, 43.0837, -96.4434] },
    { name: "Walworth", bbox: [45.2459, -100.4866, 45.5948, -99.7077] },
    { name: "Yankton", bbox: [42.7934, -97.6375, 43.17, -97.1604] },
    { name: "Ziebach", bbox: [44.5117, -102.0004, 45.4724, -101.1362] },
  ],
  TN: [
    { name: "Anderson", bbox: [35.9102, -84.441, 36.2704, -83.9417] },
    { name: "Bedford", bbox: [35.3207, -86.6582, 35.6976, -86.2452] },
    { name: "Benton", bbox: [35.8157, -88.2174, 36.3601, -87.919] },
    { name: "Bledsoe", bbox: [35.3543, -85.4238, 35.7656, -84.9161] },
    { name: "Blount", bbox: [35.4606, -84.1883, 35.8871, -83.6628] },
    { name: "Bradley", bbox: [34.9876, -85.024, 35.3501, -84.6999] },
    { name: "Campbell", bbox: [36.1776, -84.3727, 36.592, -83.9056] },
    { name: "Cannon", bbox: [35.6601, -86.2071, 35.9611, -85.8852] },
    { name: "Carroll", bbox: [35.7894, -88.7068, 36.1516, -88.1779] },
    { name: "Carter", bbox: [36.1044, -82.3405, 36.5083, -81.933] },
    { name: "Cheatham", bbox: [36.0438, -87.2865, 36.4555, -86.9132] },
    { name: "Chester", bbox: [35.2475, -88.8416, 35.5881, -88.3518] },
    { name: "Claiborne", bbox: [36.3444, -83.9876, 36.6008, -83.3868] },
    { name: "Clay", bbox: [36.4031, -85.8139, 36.6265, -85.2763] },
    { name: "Cocke", bbox: [35.715, -83.3108, 36.1809, -82.898] },
    { name: "Coffee", bbox: [35.2892, -86.2615, 35.7038, -85.877] },
    { name: "Crockett", bbox: [35.671, -89.356, 35.9998, -88.8929] },
    { name: "Cumberland", bbox: [35.7619, -85.2733, 36.1563, -84.6806] },
    { name: "Davidson", bbox: [35.9682, -87.0541, 36.4055, -86.5156] },
    { name: "DeKalb", bbox: [35.8313, -86.0597, 36.1316, -85.6373] },
    { name: "Decatur", bbox: [35.3826, -88.2431, 35.8458, -87.9707] },
    { name: "Dickson", bbox: [35.9592, -87.5668, 36.3347, -87.1393] },
    { name: "Dyer", bbox: [35.8809, -89.7331, 36.2127, -89.1545] },
    { name: "Fayette", bbox: [34.9944, -89.6443, 35.403, -89.1839] },
    { name: "Fentress", bbox: [36.1386, -85.1222, 36.5813, -84.6591] },
    { name: "Franklin", bbox: [34.9884, -86.3203, 35.3626, -85.8639] },
    { name: "Gibson", bbox: [35.7911, -89.1888, 36.2228, -88.6927] },
    { name: "Giles", bbox: [34.9918, -87.2241, 35.4557, -86.8283] },
    { name: "Grainger", bbox: [36.0806, -83.7327, 36.4132, -83.2553] },
    { name: "Greene", bbox: [35.933, -83.1661, 36.4115, -82.5772] },
    { name: "Grundy", bbox: [35.2153, -85.9136, 35.5317, -85.4856] },
    { name: "Hamblen", bbox: [36.0851, -83.4671, 36.3453, -83.0823] },
    { name: "Hamilton", bbox: [34.9834, -85.4745, 35.4586, -84.9463] },
    { name: "Hancock", bbox: [36.3947, -83.4721, 36.5982, -82.8304] },
    { name: "Hardeman", bbox: [34.9943, -89.1983, 35.4328, -88.7818] },
    { name: "Hardin", bbox: [34.9955, -88.3805, 35.4233, -87.9816] },
    { name: "Hawkins", bbox: [36.2423, -83.2806, 36.5941, -82.6092] },
    { name: "Haywood", bbox: [35.3971, -89.5021, 35.8227, -89.0695] },
    { name: "Henderson", bbox: [35.419, -88.6136, 35.8248, -88.1792] },
    { name: "Henry", bbox: [36.1203, -88.5303, 36.5015, -87.9909] },
    { name: "Hickman", bbox: [35.6093, -87.7438, 35.9931, -87.2014] },
    { name: "Houston", bbox: [36.1779, -87.9807, 36.3682, -87.5135] },
    { name: "Humphreys", bbox: [35.8041, -88.0129, 36.2448, -87.5345] },
    { name: "Jackson", bbox: [36.238, -85.8465, 36.5224, -85.4951] },
    { name: "Jefferson", bbox: [35.8958, -83.6747, 36.182, -83.2346] },
    { name: "Johnson", bbox: [36.2649, -82.0589, 36.6142, -81.6469] },
    { name: "Knox", bbox: [35.8051, -84.2716, 36.1864, -83.6546] },
    { name: "Lake", bbox: [36.1854, -89.6998, 36.5032, -89.3461] },
    { name: "Lauderdale", bbox: [35.5379, -89.9589, 35.9466, -89.3428] },
    { name: "Lawrence", bbox: [34.9993, -87.606, 35.4578, -87.2066] },
    { name: "Lewis", bbox: [35.3985, -87.7176, 35.6591, -87.2899] },
    { name: "Lincoln", bbox: [34.9907, -86.8363, 35.371, -86.3182] },
    { name: "Loudon", bbox: [35.6105, -84.5845, 35.8969, -84.1331] },
    { name: "Macon", bbox: [36.4118, -86.2284, 36.6398, -85.7886] },
    { name: "Madison", bbox: [35.4278, -89.0789, 35.7973, -88.6069] },
    { name: "Marion", bbox: [34.984, -85.873, 35.3193, -85.362] },
    { name: "Marshall", bbox: [35.2529, -86.9608, 35.7101, -86.5995] },
    { name: "Maury", bbox: [35.417, -87.3392, 35.8507, -86.782] },
    { name: "McMinn", bbox: [35.241, -84.8602, 35.6447, -84.401] },
    { name: "McNairy", bbox: [34.9953, -88.7869, 35.381, -88.3626] },
    { name: "Meigs", bbox: [35.2878, -85.0163, 35.7529, -84.6199] },
    { name: "Monroe", bbox: [35.2067, -84.5259, 35.6717, -83.9611] },
    { name: "Montgomery", bbox: [36.3219, -87.6411, 36.6424, -87.115] },
    { name: "Moore", bbox: [35.1244, -86.5273, 35.4125, -86.2576] },
    { name: "Morgan", bbox: [35.9085, -84.9078, 36.3708, -84.3418] },
    { name: "Obion", bbox: [36.2016, -89.483, 36.5068, -88.8164] },
    { name: "Overton", bbox: [36.1447, -85.4976, 36.5313, -85.0825] },
    { name: "Perry", bbox: [35.4234, -88.0423, 35.8409, -87.6582] },
    { name: "Pickett", bbox: [36.4072, -85.2849, 36.6265, -84.7318] },
    { name: "Polk", bbox: [34.9878, -84.7759, 35.2855, -84.2923] },
    { name: "Putnam", bbox: [35.9792, -85.8074, 36.3023, -85.1002] },
    { name: "Rhea", bbox: [35.4093, -85.1352, 35.825, -84.7239] },
    { name: "Roane", bbox: [35.6444, -84.7819, 36.049, -84.2634] },
    { name: "Robertson", bbox: [36.3499, -87.1204, 36.6521, -86.5643] },
    { name: "Rutherford", bbox: [35.6189, -86.6862, 36.1006, -86.1532] },
    { name: "Scott", bbox: [36.1635, -84.7854, 36.6034, -84.2596] },
    { name: "Sequatchie", bbox: [35.1472, -85.6073, 35.5674, -85.2259] },
    { name: "Sevier", bbox: [35.563, -83.7943, 36.0385, -83.2507] },
    { name: "Shelby", bbox: [34.9942, -90.3099, 35.5333, -89.6328] },
    { name: "Smith", bbox: [36.086, -86.1368, 36.4261, -85.7801] },
    { name: "Stewart", bbox: [36.3287, -88.0705, 36.6781, -87.5924] },
    { name: "Sullivan", bbox: [36.3965, -82.6807, 36.6162, -81.8267] },
    { name: "Sumner", bbox: [36.2451, -86.7548, 36.6518, -86.2055] },
    { name: "Tipton", bbox: [35.3747, -90.1793, 35.6504, -89.4699] },
    { name: "Trousdale", bbox: [36.2959, -86.2833, 36.4875, -85.9789] },
    { name: "Unicoi", bbox: [35.9547, -82.6151, 36.2528, -82.2221] },
    { name: "Union", bbox: [36.1646, -84.0043, 36.4359, -83.6674] },
    { name: "Van Buren", bbox: [35.533, -85.6029, 35.8227, -85.2478] },
    { name: "Warren", bbox: [35.5241, -85.9851, 35.8397, -85.5575] },
    { name: "Washington", bbox: [36.0962, -82.7026, 36.4457, -82.2999] },
    { name: "Wayne", bbox: [35.0033, -88.0247, 35.4833, -87.5754] },
    { name: "Weakley", bbox: [36.0627, -88.9598, 36.5029, -88.5163] },
    { name: "White", bbox: [35.7934, -85.6826, 36.0819, -85.2131] },
    { name: "Williamson", bbox: [35.7066, -87.2151, 36.0527, -86.6133] },
    { name: "Wilson", bbox: [35.9544, -86.5943, 36.3475, -86.0148] },
  ],
  TX: [
    { name: "Anderson", bbox: [31.5041, -96.0622, 32.0845, -95.2589] },
    { name: "Andrews", bbox: [32.0858, -103.0647, 32.5232, -102.211] },
    { name: "Angelina", bbox: [31.0333, -95.0056, 31.5269, -94.1296] },
    { name: "Aransas", bbox: [27.8375, -97.2608, 28.3191, -96.7872] },
    { name: "Archer", bbox: [33.3962, -98.9539, 33.836, -98.4207] },
    { name: "Armstrong", bbox: [34.7475, -101.6294, 35.1831, -101.0863] },
    { name: "Atascosa", bbox: [28.6127, -98.8049, 29.2507, -98.0983] },
    { name: "Austin", bbox: [29.6017, -96.622, 30.0962, -96.0249] },
    { name: "Bailey", bbox: [33.8247, -103.0473, 34.3129, -102.6151] },
    { name: "Bandera", bbox: [29.5622, -99.6031, 29.9077, -98.7788] },
    { name: "Bastrop", bbox: [29.7865, -97.6494, 30.4196, -97.0245] },
    { name: "Baylor", bbox: [33.3975, -99.4757, 33.834, -98.9531] },
    { name: "Bee", bbox: [28.1297, -98.0898, 28.7196, -97.3756] },
    { name: "Bell", bbox: [30.7524, -97.9138, 31.3202, -97.0702] },
    { name: "Bexar", bbox: [29.1144, -98.8066, 29.7607, -98.1268] },
    { name: "Blanco", bbox: [29.9376, -98.5917, 30.5021, -98.1256] },
    { name: "Borden", bbox: [32.5241, -101.6913, 32.9636, -101.1734] },
    { name: "Bosque", bbox: [31.5878, -98.0055, 32.2036, -97.2773] },
    { name: "Bowie", bbox: [33.2411, -94.7469, 33.703, -94.0429] },
    { name: "Brazoria", bbox: [28.8248, -95.874, 29.5965, -95.0565] },
    { name: "Brazos", bbox: [30.3303, -96.6017, 30.9737, -96.08] },
    { name: "Brewster", bbox: [28.9721, -103.8007, 30.6659, -102.3208] },
    { name: "Briscoe", bbox: [34.3123, -101.4716, 34.7483, -100.9449] },
    { name: "Brooks", bbox: [26.7809, -98.5237, 27.2651, -97.9855] },
    { name: "Brown", bbox: [31.4609, -99.2028, 32.0796, -98.6684] },
    { name: "Burleson", bbox: [30.2968, -96.9636, 30.7308, -96.272] },
    { name: "Burnet", bbox: [30.4262, -98.4458, 31.0349, -97.8285] },
    { name: "Caldwell", bbox: [29.6307, -97.8939, 30.0729, -97.3158] },
    { name: "Calhoun", bbox: [28.0613, -96.9304, 28.7042, -96.3229] },
    { name: "Callahan", bbox: [32.0792, -99.6314, 32.5148, -99.1143] },
    { name: "Cameron", bbox: [25.8565, -97.8631, 26.4113, -97.1456] },
    { name: "Camp", bbox: [32.9026, -95.1522, 33.0693, -94.7199] },
    { name: "Carson", bbox: [35.1821, -101.623, 35.6253, -101.0859] },
    { name: "Cass", bbox: [32.8795, -94.654, 33.298, -94.0427] },
    { name: "Castro", bbox: [34.313, -102.5256, 34.7482, -101.998] },
    { name: "Chambers", bbox: [29.5246, -94.9815, 29.8895, -94.3542] },
    { name: "Cherokee", bbox: [31.4257, -95.4599, 32.138, -94.8659] },
    { name: "Childress", bbox: [34.3118, -100.4178, 34.7475, -99.9975] },
    { name: "Clay", bbox: [33.4668, -98.4338, 34.1571, -97.9457] },
    { name: "Cochran", bbox: [33.3884, -103.0567, 33.8251, -102.5948] },
    { name: "Coke", bbox: [31.693, -100.8254, 32.0866, -100.2351] },
    { name: "Coleman", bbox: [31.4099, -99.7217, 32.0821, -99.1959] },
    { name: "Collin", bbox: [32.9818, -96.844, 33.4055, -96.2954] },
    { name: "Collingsworth", bbox: [34.7464, -100.541, 35.1831, -100.0004] },
    { name: "Colorado", bbox: [29.2478, -96.8742, 29.9615, -96.1754] },
    { name: "Comal", bbox: [29.5945, -98.6461, 30.038, -97.9993] },
    { name: "Comanche", bbox: [31.684, -98.9244, 32.2614, -98.1566] },
    { name: "Concho", bbox: [31.0873, -100.1152, 31.5803, -99.6018] },
    { name: "Cooke", bbox: [33.4164, -97.4871, 33.949, -96.9439] },
    { name: "Coryell", bbox: [31.0694, -98.18, 31.711, -97.4186] },
    { name: "Cottle", bbox: [33.8357, -100.5187, 34.3141, -99.9976] },
    { name: "Crane", bbox: [31.0862, -102.7677, 31.6517, -102.3012] },
    { name: "Crockett", bbox: [30.2878, -102.3888, 31.0872, -100.9606] },
    { name: "Crosby", bbox: [33.3948, -101.5636, 33.8336, -101.0388] },
    { name: "Culberson", bbox: [30.6636, -104.9186, 32.0005, -104.0245] },
    { name: "Dallam", bbox: [36.0552, -103.0417, 36.5004, -102.1625] },
    { name: "Dallas", bbox: [32.5452, -97.0384, 32.9893, -96.5169] },
    { name: "Dawson", bbox: [32.5233, -102.2085, 32.9618, -101.6887] },
    { name: "DeWitt", bbox: [28.8133, -97.7551, 29.3845, -96.9764] },
    { name: "Deaf Smith", bbox: [34.7469, -103.0428, 35.1832, -102.1675] },
    { name: "Delta", bbox: [33.2193, -95.8618, 33.4951, -95.3066] },
    { name: "Denton", bbox: [32.9876, -97.3985, 33.4305, -96.834] },
    { name: "Dickens", bbox: [33.3972, -101.0412, 33.8357, -100.5174] },
    { name: "Dimmit", bbox: [28.1978, -100.1143, 28.6481, -99.3942] },
    { name: "Donley", bbox: [34.7477, -101.0907, 35.1831, -100.539] },
    { name: "Duval", bbox: [27.2625, -98.8033, 28.058, -98.2325] },
    { name: "Eastland", bbox: [32.078, -99.1187, 32.5153, -98.4751] },
    { name: "Ector", bbox: [31.6513, -102.7991, 32.087, -102.287] },
    { name: "Edwards", bbox: [29.6233, -100.7004, 30.2907, -99.7541] },
    { name: "El Paso", bbox: [31.3865, -106.6278, 32.0023, -105.9977] },
    { name: "Ellis", bbox: [32.0521, -97.0868, 32.5494, -96.3831] },
    { name: "Erath", bbox: [31.9175, -98.5512, 32.513, -97.8649] },
    { name: "Falls", bbox: [30.9862, -97.2781, 31.5223, -96.5969] },
    { name: "Fannin", bbox: [33.3411, -96.3846, 33.8575, -95.8463] },
    { name: "Fayette", bbox: [29.6281, -97.3179, 30.1605, -96.5698] },
    { name: "Fisher", bbox: [32.5228, -100.6606, 32.9635, -100.1442] },
    { name: "Floyd", bbox: [33.8305, -101.5649, 34.3125, -101.0412] },
    { name: "Foard", bbox: [33.7338, -100.0485, 34.2298, -99.4745] },
    { name: "Fort Bend", bbox: [29.2626, -96.0889, 29.7883, -95.4241] },
    { name: "Franklin", bbox: [32.9618, -95.309, 33.3895, -95.1255] },
    { name: "Freestone", bbox: [31.4134, -96.4967, 32.0125, -95.7873] },
    { name: "Frio", bbox: [28.6406, -99.4139, 29.0913, -98.8008] },
    { name: "Gaines", bbox: [32.5222, -103.0649, 32.9591, -102.2027] },
    { name: "Galveston", bbox: [29.0778, -95.2331, 29.5975, -94.3709] },
    { name: "Garza", bbox: [32.961, -101.5574, 33.3972, -101.0387] },
    { name: "Gillespie", bbox: [30.1343, -99.304, 30.4999, -98.5879] },
    { name: "Glasscock", bbox: [31.6509, -101.7761, 32.0875, -101.2642] },
    { name: "Goliad", bbox: [28.3887, -97.7785, 28.9252, -97.1589] },
    { name: "Gonzales", bbox: [29.1098, -97.8588, 29.7847, -97.1305] },
    { name: "Gray", bbox: [35.1821, -101.0863, 35.6193, -100.539] },
    { name: "Grayson", bbox: [33.3978, -96.9446, 33.9596, -96.3785] },
    { name: "Gregg", bbox: [32.36, -94.9869, 32.6522, -94.5792] },
    { name: "Grimes", bbox: [30.2252, -96.1878, 30.8641, -95.8043] },
    { name: "Guadalupe", bbox: [29.3768, -98.3109, 29.8582, -97.6332] },
    { name: "Hale", bbox: [33.8247, -102.0904, 34.3131, -101.5636] },
    { name: "Hall", bbox: [34.3128, -100.9461, 34.7483, -100.4159] },
    { name: "Hamilton", bbox: [31.4164, -98.4637, 32.0179, -97.7664] },
    { name: "Hansford", bbox: [36.0553, -101.6239, 36.4995, -101.0852] },
    { name: "Hardeman", bbox: [34.056, -99.9979, 34.5793, -99.4742] },
    { name: "Hardin", bbox: [30.113, -94.7327, 30.527, -94.0717] },
    { name: "Harris", bbox: [29.4981, -95.9607, 30.1706, -94.9087] },
    { name: "Harrison", bbox: [32.3307, -94.7021, 32.7931, -94.0428] },
    { name: "Hartley", bbox: [35.6225, -103.0416, 36.0552, -102.1628] },
    { name: "Haskell", bbox: [32.957, -99.991, 33.399, -99.4713] },
    { name: "Hays", bbox: [29.7524, -98.2976, 30.3563, -97.7102] },
    { name: "Hemphill", bbox: [35.6191, -100.5402, 36.0565, -100.0004] },
    { name: "Henderson", bbox: [32.0059, -96.4521, 32.3586, -95.4285] },
    { name: "Hidalgo", bbox: [26.0437, -98.5867, 26.7831, -97.8618] },
    { name: "Hill", bbox: [31.7089, -97.486, 32.2655, -96.7191] },
    { name: "Hockley", bbox: [33.3885, -102.6154, 33.8251, -102.0759] },
    { name: "Hood", bbox: [32.2335, -98.0685, 32.5588, -97.6153] },
    { name: "Hopkins", bbox: [32.9604, -95.8633, 33.3772, -95.3086] },
    { name: "Houston", bbox: [30.9304, -95.7644, 31.5929, -94.9581] },
    { name: "Howard", bbox: [32.0871, -101.695, 32.5252, -101.1746] },
    { name: "Hudspeth", bbox: [30.6238, -105.998, 32.0023, -104.9076] },
    { name: "Hunt", bbox: [32.8372, -96.2973, 33.4095, -95.8587] },
    { name: "Hutchinson", bbox: [35.6241, -101.6235, 36.0554, -101.0857] },
    { name: "Irion", bbox: [31.0794, -101.2748, 31.53, -100.6888] },
    { name: "Jack", bbox: [33.0013, -98.4266, 33.4671, -97.9182] },
    { name: "Jackson", bbox: [28.6756, -96.9386, 29.2639, -96.3092] },
    { name: "Jasper", bbox: [30.2417, -94.4578, 31.1581, -93.8657] },
    { name: "Jeff Davis", bbox: [30.4122, -104.9854, 31.1052, -103.44] },
    { name: "Jefferson", bbox: [29.5615, -94.4451, 30.1877, -93.838] },
    { name: "Jim Hogg", bbox: [26.7835, -98.9547, 27.354, -98.4179] },
    { name: "Jim Wells", bbox: [27.261, -98.2355, 28.058, -97.7985] },
    { name: "Johnson", bbox: [32.1336, -97.6171, 32.5555, -97.0862] },
    { name: "Jones", bbox: [32.5147, -100.1465, 32.9601, -99.612] },
    { name: "Karnes", bbox: [28.668, -98.191, 29.2217, -97.5746] },
    { name: "Kaufman", bbox: [32.3575, -96.53, 32.8417, -96.0759] },
    { name: "Kendall", bbox: [29.7202, -98.9201, 30.139, -98.414] },
    { name: "Kenedy", bbox: [26.0668, -97.9859, 27.2817, -97.1543] },
    { name: "Kent", bbox: [32.9629, -101.0388, 33.3979, -100.5174] },
    { name: "Kerr", bbox: [29.7814, -99.7576, 30.2907, -98.9177] },
    { name: "Kimble", bbox: [30.2867, -100.1165, 30.7108, -99.3017] },
    { name: "King", bbox: [33.3974, -100.5187, 33.836, -99.991] },
    { name: "Kinney", bbox: [29.084, -100.7937, 29.6239, -100.1114] },
    { name: "Kleberg", bbox: [27.2093, -98.0598, 27.8434, -97.0454] },
    { name: "Knox", bbox: [33.3974, -99.9964, 33.836, -99.4724] },
    { name: "La Salle", bbox: [28.0304, -99.3957, 28.6475, -98.8008] },
    { name: "Lamar", bbox: [33.3807, -95.8577, 33.9342, -95.3086] },
    { name: "Lamb", bbox: [33.8247, -102.6154, 34.3131, -102.0857] },
    { name: "Lampasas", bbox: [31.0295, -98.5627, 31.4637, -97.9071] },
    { name: "Lavaca", bbox: [29.0632, -97.2401, 29.6327, -96.5606] },
    { name: "Lee", bbox: [30.032, -97.3345, 30.5572, -96.6409] },
    { name: "Leon", bbox: [30.9737, -96.3311, 31.6184, -95.6572] },
    { name: "Liberty", bbox: [29.8843, -95.1659, 30.4936, -94.4422] },
    { name: "Limestone", bbox: [31.2209, -96.9322, 31.8149, -96.2366] },
    { name: "Lipscomb", bbox: [36.0557, -100.5467, 36.4997, -100.0004] },
    { name: "Live Oak", bbox: [28.0569, -98.335, 28.7869, -97.8088] },
    { name: "Llano", bbox: [30.4861, -98.9646, 30.9214, -98.351] },
    { name: "Loving", bbox: [31.6514, -103.9802, 32.0004, -103.3265] },
    { name: "Lubbock", bbox: [33.3896, -102.0857, 33.8305, -101.5569] },
    { name: "Lynn", bbox: [32.9597, -102.0762, 33.3948, -101.5569] },
    { name: "Madison", bbox: [30.823, -96.241, 31.0942, -95.6179] },
    { name: "Marion", bbox: [32.693, -94.7059, 32.8811, -94.0427] },
    { name: "Martin", bbox: [32.0868, -102.2112, 32.5252, -101.6887] },
    { name: "Mason", bbox: [30.4985, -99.4848, 30.941, -98.9641] },
    { name: "Matagorda", bbox: [28.3839, -96.3819, 29.2297, -95.507] },
    { name: "Maverick", bbox: [28.1969, -100.6684, 29.0863, -100.1114] },
    { name: "McCulloch", bbox: [30.9406, -99.6036, 31.4919, -99.0906] },
    { name: "McLennan", bbox: [31.2442, -97.6052, 31.8631, -96.8011] },
    { name: "McMullen", bbox: [28.0575, -98.8033, 28.6483, -98.3343] },
    { name: "Medina", bbox: [29.0904, -99.4139, 29.6907, -98.8048] },
    { name: "Menard", bbox: [30.7104, -100.1162, 31.088, -99.4839] },
    { name: "Midland", bbox: [31.6513, -102.2873, 32.087, -101.7758] },
    { name: "Milam", bbox: [30.4573, -97.3155, 31.1059, -96.6213] },
    { name: "Mills", bbox: [31.2306, -98.9916, 31.7236, -98.2668] },
    { name: "Mitchell", bbox: [32.0854, -101.184, 32.5277, -100.6606] },
    { name: "Montague", bbox: [33.4337, -97.979, 33.9914, -97.4841] },
    { name: "Montgomery", bbox: [30.0322, -95.8302, 30.6303, -95.0967] },
    { name: "Moore", bbox: [35.62, -102.163, 36.0554, -101.6228] },
    { name: "Morris", bbox: [32.8792, -94.8198, 33.3636, -94.6523] },
    { name: "Motley", bbox: [33.8336, -101.0415, 34.3141, -100.5173] },
    { name: "Nacogdoches", bbox: [31.2248, -94.9672, 31.8456, -94.311] },
    { name: "Navarro", bbox: [31.7962, -96.8962, 32.3289, -96.0548] },
    { name: "Newton", bbox: [30.2427, -93.9111, 31.1866, -93.5276] },
    { name: "Nolan", bbox: [32.0824, -100.6654, 32.5253, -100.1465] },
    { name: "Nueces", bbox: [27.5584, -97.9421, 27.9957, -97.254] },
    { name: "Ochiltree", bbox: [36.0565, -101.0857, 36.4997, -100.5461] },
    { name: "Oldham", bbox: [35.1832, -103.0425, 35.6275, -102.1628] },
    { name: "Orange", bbox: [29.9144, -94.1176, 30.2443, -93.6953] },
    { name: "Palo Pinto", bbox: [32.5116, -98.5763, 33.0079, -98.0561] },
    { name: "Panola", bbox: [31.9732, -94.6, 32.3941, -94.0156] },
    { name: "Parker", bbox: [32.5554, -98.0668, 33.0033, -97.5442] },
    { name: "Parmer", bbox: [34.3127, -103.044, 34.7474, -102.5252] },
    { name: "Pecos", bbox: [30.0528, -103.5851, 31.3713, -101.7684] },
    { name: "Polk", bbox: [30.489, -95.2002, 31.1466, -94.5379] },
    { name: "Potter", bbox: [35.1831, -102.1675, 35.6202, -101.6228] },
    { name: "Presidio", bbox: [29.2629, -104.9854, 30.6292, -103.7927] },
    { name: "Rains", bbox: [32.7204, -95.9873, 32.9799, -95.635] },
    { name: "Randall", bbox: [34.7474, -102.1688, 35.1832, -101.6229] },
    { name: "Reagan", bbox: [31.0794, -101.7762, 31.6513, -101.2671] },
    { name: "Real", bbox: [29.6235, -100.0309, 30.0824, -99.6009] },
    { name: "Red River", bbox: [33.3289, -95.3105, 33.962, -94.7461] },
    { name: "Reeves", bbox: [30.7665, -104.1024, 32.0001, -103.011] },
    { name: "Refugio", bbox: [28.0758, -97.5411, 28.5535, -96.767] },
    { name: "Roberts", bbox: [35.6191, -101.0861, 36.0576, -100.5402] },
    { name: "Robertson", bbox: [30.6957, -96.8291, 31.3571, -96.241] },
    { name: "Rockwall", bbox: [32.8136, -96.519, 32.9823, -96.2972] },
    { name: "Runnels", bbox: [31.5768, -100.2358, 32.0826, -99.714] },
    { name: "Rusk", bbox: [31.8443, -94.9854, 32.3949, -94.4524] },
    { name: "Sabine", bbox: [31.1343, -94.0442, 31.5862, -93.5997] },
    { name: "San Augustine", bbox: [31.0993, -94.3991, 31.6536, -93.9832] },
    { name: "San Jacinto", bbox: [30.345, -95.3592, 30.9067, -94.8304] },
    { name: "San Patricio", bbox: [27.8221, -97.9041, 28.1768, -97.1348] },
    { name: "San Saba", bbox: [30.9214, -99.0924, 31.4841, -98.4397] },
    { name: "Schleicher", bbox: [30.7061, -100.9622, 31.088, -100.1152] },
    { name: "Scurry", bbox: [32.5253, -101.1746, 32.9702, -100.6559] },
    { name: "Shackelford", bbox: [32.5147, -99.612, 32.957, -99.096] },
    { name: "Shelby", bbox: [31.5694, -94.5114, 31.9799, -93.8125] },
    { name: "Sherman", bbox: [36.0552, -102.163, 36.5003, -101.6235] },
    { name: "Smith", bbox: [32.1356, -95.5945, 32.687, -94.9853] },
    { name: "Somervell", bbox: [32.0873, -97.9456, 32.3186, -97.6151] },
    { name: "Starr", bbox: [26.2503, -99.1721, 26.7857, -98.3207] },
    { name: "Stephens", bbox: [32.5148, -99.0961, 32.957, -98.5756] },
    { name: "Sterling", bbox: [31.5565, -101.2676, 32.0872, -100.8216] },
    { name: "Stonewall", bbox: [32.96, -100.5192, 33.3979, -99.9888] },
    { name: "Sutton", bbox: [30.2878, -100.9606, 30.7104, -100.1162] },
    { name: "Swisher", bbox: [34.3123, -101.9985, 34.7482, -101.4716] },
    { name: "Tarrant", bbox: [32.5487, -97.5506, 32.9942, -97.0323] },
    { name: "Taylor", bbox: [32.0813, -100.1519, 32.5228, -99.6296] },
    { name: "Terrell", bbox: [29.7772, -102.567, 30.656, -101.6462] },
    { name: "Terry", bbox: [32.9588, -102.595, 33.3896, -102.0759] },
    { name: "Throckmorton", bbox: [32.9569, -99.4724, 33.399, -98.9509] },
    { name: "Titus", bbox: [32.9829, -95.1261, 33.3895, -94.8088] },
    { name: "Tom Green", bbox: [31.0866, -101.2679, 31.7054, -100.1112] },
    { name: "Travis", bbox: [30.0245, -98.173, 30.6282, -97.3695] },
    { name: "Trinity", bbox: [30.8246, -95.4348, 31.3869, -94.8429] },
    { name: "Tyler", bbox: [30.526, -94.658, 31.059, -94.051] },
    { name: "Upshur", bbox: [32.5372, -95.1534, 32.9045, -94.7018] },
    { name: "Upton", bbox: [31.0798, -102.318, 31.6514, -101.7758] },
    { name: "Uvalde", bbox: [29.0863, -100.1121, 29.6275, -99.4118] },
    { name: "Val Verde", bbox: [29.2421, -101.7618, 30.2883, -100.6991] },
    { name: "Van Zandt", bbox: [32.3552, -96.0768, 32.8385, -95.4492] },
    { name: "Victoria", bbox: [28.4996, -97.3059, 29.104, -96.6459] },
    { name: "Walker", bbox: [30.5044, -95.8631, 31.0581, -95.3275] },
    { name: "Waller", bbox: [29.7279, -96.1914, 30.2456, -95.8033] },
    { name: "Ward", bbox: [31.2679, -103.6109, 31.6518, -102.7672] },
    { name: "Washington", bbox: [30.0443, -96.7946, 30.3843, -96.0859] },
    { name: "Webb", bbox: [27.2647, -100.2095, 28.2046, -98.7981] },
    { name: "Wharton", bbox: [28.9633, -96.6403, 29.6338, -95.8419] },
    { name: "Wheeler", bbox: [35.1827, -100.5402, 35.6193, -100.0004] },
    { name: "Wichita", bbox: [33.834, -98.9531, 34.1956, -98.4236] },
    { name: "Wilbarger", bbox: [33.834, -99.4757, 34.4421, -98.9525] },
    { name: "Willacy", bbox: [26.2993, -98.0042, 26.6118, -97.3825] },
    { name: "Williamson", bbox: [30.4028, -98.0499, 30.9062, -97.1552] },
    { name: "Wilson", bbox: [28.8823, -98.4073, 29.4418, -97.7284] },
    { name: "Winkler", bbox: [31.6513, -103.3275, 32.0871, -102.7989] },
    { name: "Wise", bbox: [32.9908, -97.9216, 33.4341, -97.383] },
    { name: "Wood", bbox: [32.544, -95.6654, 33.0134, -95.1521] },
    { name: "Yoakum", bbox: [32.9588, -103.0647, 33.3885, -102.5948] },
    { name: "Young", bbox: [32.9523, -98.9539, 33.3975, -98.4207] },
    { name: "Zapata", bbox: [26.5709, -99.4539, 27.3192, -98.9542] },
    { name: "Zavala", bbox: [28.6406, -100.1143, 29.0913, -99.409] },
  ],
  UT: [
    { name: "Beaver", bbox: [38.1473, -114.0502, 38.5765, -112.3354] },
    { name: "Box Elder", bbox: [40.9999, -114.0421, 42.0012, -111.8855] },
    { name: "Cache", bbox: [41.3758, -112.164, 41.9995, -111.4269] },
    { name: "Carbon", bbox: [39.4675, -111.2475, 39.8133, -109.8847] },
    { name: "Daggett", bbox: [40.6626, -110.0007, 41.0015, -109.0483] },
    { name: "Davis", bbox: [40.7734, -112.4934, 41.1527, -111.7386] },
    { name: "Duchesne", bbox: [39.806, -110.9019, 40.8342, -109.9676] },
    { name: "Emery", bbox: [38.5, -111.3059, 39.7046, -109.9943] },
    { name: "Garfield", bbox: [37.5356, -112.6892, 38.1519, -109.9279] },
    { name: "Grand", bbox: [38.5, -110.1793, 39.4977, -109.0514] },
    { name: "Iron", bbox: [37.4741, -114.0525, 38.1487, -112.4682] },
    { name: "Juab", bbox: [39.3145, -114.0477, 40.0116, -111.5851] },
    { name: "Kane", bbox: [37.0003, -112.9012, 37.5434, -110.6391] },
    { name: "Millard", bbox: [38.5723, -114.0502, 39.5541, -112.0142] },
    { name: "Morgan", bbox: [40.7918, -111.8584, 41.3614, -111.2214] },
    { name: "Piute", bbox: [38.1499, -112.5185, 38.5099, -111.7667] },
    { name: "Rich", bbox: [41.1443, -111.5108, 42.0016, -111.0463] },
    { name: "Salt Lake", bbox: [40.4173, -112.2635, 40.9218, -111.5531] },
    { name: "San Juan", bbox: [36.998, -111.4128, 38.5, -109.0417] },
    { name: "Sanpete", bbox: [39.0323, -112.0157, 39.8133, -111.2473] },
    { name: "Sevier", bbox: [38.502, -112.5224, 39.0454, -111.2994] },
    { name: "Summit", bbox: [40.5484, -111.641, 41.2517, -110.0007] },
    { name: "Tooele", bbox: [39.9042, -114.0471, 41.0767, -112.1452] },
    { name: "Uintah", bbox: [39.4617, -110.038, 40.8586, -109.0482] },
    { name: "Utah", bbox: [39.7779, -112.2122, 40.5771, -110.8573] },
    { name: "Wasatch", bbox: [39.8991, -111.6117, 40.6904, -110.8919] },
    { name: "Washington", bbox: [37.0, -114.0527, 37.6183, -112.8994] },
    { name: "Wayne", bbox: [38.1501, -111.8489, 38.5102, -109.8873] },
    { name: "Weber", bbox: [41.0767, -112.4934, 41.4337, -111.4206] },
  ],
  VA: [
    { name: "Accomack", bbox: [37.4499, -76.0465, 38.0272, -75.2423] },
    { name: "Albemarle", bbox: [37.7331, -78.8392, 38.2779, -78.2081] },
    { name: "Alexandria", bbox: [38.7852, -77.088, 38.845, -77.033] },
    { name: "Alleghany", bbox: [37.5966, -80.2961, 37.9544, -79.6508] },
    { name: "Amelia", bbox: [37.1926, -78.235, 37.4921, -77.6506] },
    { name: "Amherst", bbox: [37.3947, -79.4369, 37.8031, -78.8692] },
    { name: "Appomattox", bbox: [37.2054, -79.0185, 37.5525, -78.5944] },
    { name: "Arlington", bbox: [38.825, -77.1722, 38.9343, -77.0317] },
    { name: "Augusta", bbox: [37.8817, -79.5122, 38.4794, -78.7494] },
    { name: "Bath", bbox: [37.8716, -80.0553, 38.2649, -79.4369] },
    { name: "Bedford", bbox: [37.0059, -79.8476, 37.617, -79.1833] },
    { name: "Bland", bbox: [36.9524, -81.4622, 37.2935, -80.8546] },
    { name: "Botetourt", bbox: [37.3092, -80.074, 37.801, -79.4986] },
    { name: "Bristol", bbox: [36.5946, -82.2433, 36.6385, -82.1145] },
    { name: "Brunswick", bbox: [36.5442, -78.0462, 37.0228, -77.6558] },
    { name: "Buchanan", bbox: [37.0417, -82.3059, 37.5378, -81.7384] },
    { name: "Buckingham", bbox: [37.3397, -78.8252, 37.7967, -78.2397] },
    { name: "Buena Vista", bbox: [37.7024, -79.3826, 37.7606, -79.3288] },
    { name: "Campbell", bbox: [37.0223, -79.4429, 37.4299, -78.8242] },
    { name: "Caroline", bbox: [37.7796, -77.6422, 38.2522, -77.0701] },
    { name: "Carroll", bbox: [36.5581, -81.0424, 36.9318, -80.4642] },
    { name: "Charles City", bbox: [37.2231, -77.2707, 37.4906, -76.8735] },
    { name: "Charlotte", bbox: [36.6979, -78.9046, 37.2488, -78.4433] },
    { name: "Charlottesville", bbox: [38.0114, -78.5204, 38.0653, -78.449] },
    { name: "Chesapeake", bbox: [36.5504, -76.4915, 36.8663, -76.0682] },
    { name: "Chesterfield", bbox: [37.2227, -77.8551, 37.5626, -77.2442] },
    { name: "Clarke", bbox: [38.9795, -78.152, 39.2646, -77.8282] },
    { name: "Colonial Heights", bbox: [37.2332, -77.4317, 37.2822, -77.3623] },
    { name: "Covington", bbox: [37.7482, -80.0089, 37.8136, -79.9665] },
    { name: "Craig", bbox: [37.3149, -80.4756, 37.6475, -79.969] },
    { name: "Culpeper", bbox: [38.3114, -78.232, 38.6959, -77.6187] },
    { name: "Cumberland", bbox: [37.3093, -78.4651, 37.7485, -78.0723] },
    { name: "Danville", bbox: [36.541, -79.5011, 36.6445, -79.3045] },
    { name: "Dickenson", bbox: [36.9709, -82.5535, 37.3011, -82.1359] },
    { name: "Dinwiddie", bbox: [36.8738, -77.9003, 37.2651, -77.3968] },
    { name: "Emporia", bbox: [36.6749, -77.5574, 36.7191, -77.5092] },
    { name: "Essex", bbox: [37.7286, -77.1701, 38.1616, -76.6819] },
    { name: "Fairfax", bbox: [38.6172, -77.5358, 39.0586, -77.0392] },
    { name: "Falls Church", bbox: [38.8722, -77.1943, 38.8963, -77.1503] },
    { name: "Fauquier", bbox: [38.4097, -78.1306, 39.0138, -77.5309] },
    { name: "Floyd", bbox: [36.7087, -80.634, 37.1229, -80.1215] },
    { name: "Fluvanna", bbox: [37.6905, -78.4916, 38.0064, -78.0633] },
    { name: "Franklin", bbox: [36.6482, -80.2355, 37.2255, -76.9097] },
    { name: "Frederick", bbox: [39.008, -78.5441, 39.466, -78.0332] },
    { name: "Fredericksburg", bbox: [38.2702, -77.5323, 38.3259, -77.4471] },
    { name: "Galax", bbox: [36.6285, -80.9478, 36.6941, -80.8773] },
    { name: "Giles", bbox: [37.1475, -81.0145, 37.4817, -80.4334] },
    { name: "Gloucester", bbox: [37.241, -76.7123, 37.6032, -76.3495] },
    { name: "Goochland", bbox: [37.5626, -78.1593, 37.9051, -77.6301] },
    { name: "Grayson", bbox: [36.5591, -81.6775, 36.8064, -80.838] },
    { name: "Greene", bbox: [38.1848, -78.6632, 38.4755, -78.287] },
    { name: "Greensville", bbox: [36.5447, -77.7671, 36.8969, -77.2969] },
    { name: "Halifax", bbox: [36.5415, -79.2186, 37.0615, -78.6485] },
    { name: "Hampton", bbox: [36.9628, -76.4645, 37.1175, -76.2713] },
    { name: "Hanover", bbox: [37.5364, -77.7969, 38.0083, -77.1237] },
    { name: "Harrisonburg", bbox: [38.3898, -78.9146, 38.4885, -78.8243] },
    { name: "Henrico", bbox: [37.3761, -77.654, 37.707, -77.1773] },
    { name: "Henry", bbox: [36.5419, -80.0944, 36.8561, -79.6407] },
    { name: "Highland", bbox: [38.1804, -79.8101, 38.5915, -79.3123] },
    { name: "Hopewell", bbox: [37.2616, -77.3345, 37.313, -77.284] },
    { name: "Isle of Wight", bbox: [36.6441, -76.9261, 37.1421, -76.4841] },
    { name: "James City", bbox: [37.1671, -76.9045, 37.4671, -76.5777] },
    { name: "King George", bbox: [38.1411, -77.3267, 38.4005, -76.9977] },
    { name: "King William", bbox: [37.5176, -77.3452, 37.9002, -76.7777] },
    { name: "King and Queen", bbox: [37.4313, -77.1814, 37.972, -76.6471] },
    { name: "Lancaster", bbox: [37.6104, -76.6423, 37.8388, -76.2794] },
    { name: "Lee", bbox: [36.5938, -83.6754, 36.9004, -82.7713] },
    { name: "Lexington", bbox: [37.7662, -79.4619, 37.7913, -79.4153] },
    { name: "Loudoun", bbox: [38.8475, -77.962, 39.3211, -77.328] },
    { name: "Louisa", bbox: [37.7291, -78.3066, 38.1516, -77.6873] },
    { name: "Lunenburg", bbox: [36.7779, -78.493, 37.1201, -78.0036] },
    { name: "Lynchburg", bbox: [37.333, -79.2687, 37.4659, -79.0852] },
    { name: "Madison", bbox: [38.2303, -78.4529, 38.6273, -78.0946] },
    { name: "Manassas", bbox: [38.724, -77.5265, 38.7814, -77.4475] },
    { name: "Manassas Park", bbox: [38.7534, -77.4757, 38.7882, -77.4207] },
    { name: "Martinsville", bbox: [36.6476, -79.9041, 36.7152, -79.8266] },
    { name: "Mathews", bbox: [37.31, -76.4376, 37.5355, -76.2453] },
    { name: "Mecklenburg", bbox: [36.541, -78.7341, 36.8912, -78.0274] },
    { name: "Middlesex", bbox: [37.5104, -76.7511, 37.7703, -76.298] },
    { name: "Montgomery", bbox: [36.9846, -80.6069, 37.3668, -80.178] },
    { name: "Nelson", bbox: [37.5356, -79.1719, 38.0476, -78.644] },
    { name: "New Kent", bbox: [37.3777, -77.2285, 37.6269, -76.742] },
    { name: "Newport News", bbox: [37.0197, -76.6248, 37.2206, -76.4355] },
    { name: "Norfolk", bbox: [36.8208, -76.3447, 36.9687, -76.177] },
    { name: "Northampton", bbox: [37.1142, -76.0258, 37.5573, -75.6618] },
    { name: "Northumberland", bbox: [37.6807, -76.6342, 38.0348, -76.2367] },
    { name: "Norton", bbox: [36.9053, -82.6603, 36.9567, -82.5889] },
    { name: "Nottoway", bbox: [36.9888, -78.2394, 37.2962, -77.7959] },
    { name: "Orange", bbox: [38.1174, -78.3698, 38.389, -77.7032] },
    { name: "Page", bbox: [38.4215, -78.6913, 38.8302, -78.2849] },
    { name: "Patrick", bbox: [36.5426, -80.6122, 36.8721, -80.0415] },
    { name: "Petersburg", bbox: [37.1709, -77.4475, 37.245, -77.3767] },
    { name: "Pittsylvania", bbox: [36.5407, -79.7149, 37.1256, -79.0923] },
    { name: "Poquoson", bbox: [37.1052, -76.4136, 37.1707, -76.2872] },
    { name: "Portsmouth", bbox: [36.7861, -76.4204, 36.9245, -76.29] },
    { name: "Powhatan", bbox: [37.4184, -78.132, 37.6914, -77.654] },
    { name: "Prince Edward", bbox: [37.0794, -78.6925, 37.398, -78.2312] },
    { name: "Prince George", bbox: [36.993, -77.3992, 37.3208, -76.9724] },
    { name: "Prince William", bbox: [38.5047, -77.7154, 38.9426, -77.2224] },
    { name: "Pulaski", bbox: [36.879, -80.9127, 37.2449, -80.5297] },
    { name: "Radford", bbox: [37.0896, -80.5964, 37.1484, -80.5073] },
    { name: "Rappahannock", bbox: [38.5238, -78.3383, 38.8649, -77.9355] },
    { name: "Richmond", bbox: [37.4471, -77.5961, 38.1244, -76.5078] },
    { name: "Roanoke", bbox: [37.1082, -80.262, 37.4223, -79.8471] },
    { name: "Rockbridge", bbox: [37.5329, -79.6836, 38.0861, -79.1574] },
    { name: "Rockingham", bbox: [38.2066, -79.2258, 38.8501, -78.486] },
    { name: "Russell", bbox: [36.7094, -82.4066, 37.1425, -81.7805] },
    { name: "Salem", bbox: [37.2628, -80.1205, 37.3082, -80.0188] },
    { name: "Scott", bbox: [36.5937, -82.9851, 36.8785, -82.2938] },
    { name: "Shenandoah", bbox: [38.6047, -78.8693, 39.1015, -78.3005] },
    { name: "Smyth", bbox: [36.6387, -81.8368, 37.0101, -81.2616] },
    { name: "Southampton", bbox: [36.5438, -77.5019, 36.9962, -76.8162] },
    { name: "Spotsylvania", bbox: [37.9909, -77.9548, 38.3678, -77.3703] },
    { name: "Stafford", bbox: [38.2424, -77.6348, 38.5909, -77.2862] },
    { name: "Staunton", bbox: [38.1211, -79.0971, 38.1958, -79.023] },
    { name: "Suffolk", bbox: [36.5439, -76.9154, 36.9289, -76.4067] },
    { name: "Surry", bbox: [36.9445, -77.1554, 37.2485, -76.6638] },
    { name: "Sussex", bbox: [36.7077, -77.619, 37.112, -76.9535] },
    { name: "Tazewell", bbox: [36.933, -81.9011, 37.3377, -81.2251] },
    { name: "Virginia Beach", bbox: [36.5506, -76.2261, 36.9319, -75.867] },
    { name: "Warren", bbox: [38.7592, -78.3867, 39.0363, -78.0042] },
    { name: "Washington", bbox: [36.5942, -82.3321, 36.929, -81.6058] },
    { name: "Waynesboro", bbox: [38.0396, -78.9496, 38.1, -78.8558] },
    { name: "Westmoreland", bbox: [37.9666, -77.0617, 38.278, -76.5195] },
    { name: "Williamsburg", bbox: [37.2499, -76.7425, 37.3063, -76.6646] },
    { name: "Winchester", bbox: [39.131, -78.1969, 39.2009, -78.137] },
    { name: "Wise", bbox: [36.7999, -82.8856, 37.2009, -82.2986] },
    { name: "Wythe", bbox: [36.7631, -81.3794, 37.0733, -80.7405] },
    { name: "York", bbox: [37.0919, -76.7417, 37.3801, -76.3893] },
  ],
  VT: [
    { name: "Addison", bbox: [43.7533, -73.4374, 44.2934, -72.7423] },
    { name: "Bennington", bbox: [42.741, -73.2909, 43.3147, -72.8194] },
    { name: "Caledonia", bbox: [44.1576, -72.4343, 44.769, -71.8373] },
    { name: "Chittenden", bbox: [44.1613, -73.362, 44.7229, -72.805] },
    { name: "Essex", bbox: [44.3593, -71.9743, 45.0136, -71.4646] },
    { name: "Franklin", bbox: [44.6331, -73.2563, 45.0167, -72.5326] },
    { name: "Grand Isle", bbox: [44.5631, -73.3902, 45.0136, -73.1913] },
    { name: "Lamoille", bbox: [44.3982, -72.9241, 44.7862, -72.3748] },
    { name: "Orange", bbox: [43.7711, -72.7913, 44.221, -72.0401] },
    { name: "Orleans", bbox: [44.5423, -72.5782, 45.0118, -71.8744] },
    { name: "Rutland", bbox: [43.3007, -73.4312, 43.8581, -72.7009] },
    { name: "Washington", bbox: [44.0129, -72.9522, 44.5061, -72.2237] },
    { name: "Windham", bbox: [42.7269, -73.0186, 43.2555, -72.4312] },
    { name: "Windsor", bbox: [43.2225, -72.9802, 43.9619, -72.2057] },
  ],
  WA: [
    { name: "Adams", bbox: [46.7377, -119.3694, 47.2617, -117.9589] },
    { name: "Asotin", bbox: [45.9954, -117.4801, 46.4623, -116.916] },
    { name: "Benton", bbox: [45.836, -119.8741, 46.7274, -118.9411] },
    { name: "Chelan", bbox: [47.2609, -121.1802, 48.5452, -119.8703] },
    { name: "Clallam", bbox: [47.8668, -124.7332, 48.3907, -122.9179] },
    { name: "Clark", bbox: [45.5435, -122.796, 46.0539, -122.2456] },
    { name: "Columbia", bbox: [45.9989, -118.2416, 46.6248, -117.6032] },
    { name: "Cowlitz", bbox: [45.8505, -123.2178, 46.3879, -122.24] },
    { name: "Douglas", bbox: [47.2201, -120.3181, 48.1505, -118.9555] },
    { name: "Ferry", bbox: [47.8416, -118.8697, 49.0002, -118.105] },
    { name: "Franklin", bbox: [46.1929, -119.4532, 46.7389, -118.2098] },
    { name: "Garfield", bbox: [45.9979, -117.8633, 46.7003, -117.2288] },
    { name: "Grant", bbox: [46.6286, -120.0429, 47.962, -118.9735] },
    { name: "Grays Harbor", bbox: [46.7924, -124.3537, 47.5336, -123.1584] },
    { name: "Island", bbox: [47.904, -122.77, 48.4116, -122.3496] },
    { name: "Jefferson", bbox: [47.5176, -124.6108, 48.1432, -122.6103] },
    { name: "King", bbox: [47.0868, -122.5384, 47.7799, -121.0684] },
    { name: "Kitsap", bbox: [47.403, -123.0378, 47.9408, -122.4703] },
    { name: "Kittitas", bbox: [46.7372, -121.4327, 47.5971, -119.9275] },
    { name: "Klickitat", bbox: [45.6295, -121.6125, 46.044, -119.8663] },
    { name: "Lewis", bbox: [46.3842, -123.3708, 46.7944, -121.3523] },
    { name: "Lincoln", bbox: [47.2604, -118.9795, 47.9577, -117.8208] },
    { name: "Mason", bbox: [47.0827, -123.5044, 47.607, -122.8002] },
    { name: "Okanogan", bbox: [47.9408, -120.8512, 49.0012, -118.8354] },
    { name: "Pacific", bbox: [46.2398, -124.0984, 46.7942, -123.3582] },
    { name: "Pend Oreille", bbox: [48.0456, -117.6295, 49.0, -117.0324] },
    { name: "Pierce", bbox: [46.7297, -122.85, 47.404, -121.3797] },
    { name: "San Juan", bbox: [48.4182, -123.2371, 48.7223, -122.7421] },
    { name: "Skagit", bbox: [48.2955, -122.7399, 48.6575, -120.7016] },
    { name: "Skamania", bbox: [45.5477, -122.249, 46.3882, -121.5224] },
    { name: "Snohomish", bbox: [47.7753, -122.4058, 48.2976, -120.9064] },
    { name: "Spokane", bbox: [47.2593, -117.8237, 48.0479, -117.0398] },
    { name: "Stevens", bbox: [47.7951, -118.4024, 49.0001, -117.4295] },
    { name: "Thurston", bbox: [46.7626, -123.2021, 47.1942, -122.2027] },
    { name: "Wahkiakum", bbox: [46.1448, -123.7279, 46.3856, -123.2131] },
    { name: "Walla Walla", bbox: [45.9999, -119.0414, 46.597, -117.9913] },
    { name: "Whatcom", bbox: [48.6409, -123.0905, 49.0024, -120.6547] },
    { name: "Whitman", bbox: [46.4198, -118.2491, 47.2604, -117.0397] },
    { name: "Yakima", bbox: [46.0407, -121.5239, 47.089, -119.8663] },
  ],
  WI: [
    { name: "Adams", bbox: [43.641, -90.0288, 44.2495, -89.5979] },
    { name: "Ashland", bbox: [45.9811, -90.9274, 47.0776, -90.3021] },
    { name: "Barron", bbox: [45.2065, -92.1565, 45.6399, -91.5403] },
    { name: "Bayfield", bbox: [46.1546, -91.5514, 46.9622, -90.7509] },
    { name: "Brown", bbox: [44.2405, -88.2452, 44.6796, -87.7624] },
    { name: "Buffalo", bbox: [44.024, -92.0839, 44.5966, -91.5291] },
    { name: "Burnett", bbox: [45.6397, -92.8857, 46.1576, -92.0314] },
    { name: "Calumet", bbox: [43.8915, -88.4044, 44.2441, -88.0418] },
    { name: "Chippewa", bbox: [44.856, -91.6656, 45.292, -90.9222] },
    { name: "Clark", bbox: [44.4223, -90.9234, 45.0338, -90.315] },
    { name: "Columbia", bbox: [43.2848, -89.7858, 43.6431, -89.0068] },
    { name: "Crawford", bbox: [42.9868, -91.2102, 43.423, -90.6668] },
    { name: "Dane", bbox: [42.845, -89.8382, 43.2929, -89.0089] },
    { name: "Dodge", bbox: [43.1947, -89.0091, 43.6335, -88.4004] },
    { name: "Door", bbox: [44.6756, -87.7361, 45.4285, -86.8054] },
    { name: "Douglas", bbox: [46.157, -92.2939, 46.7575, -91.5513] },
    { name: "Dunn", bbox: [44.6836, -92.1565, 45.2096, -91.6504] },
    { name: "Eau Claire", bbox: [44.5962, -91.6505, 44.8573, -90.9222] },
    { name: "Florence", bbox: [45.7131, -88.6832, 46.0212, -88.0583] },
    { name: "Fond du Lac", bbox: [43.5429, -88.8861, 43.9382, -88.1609] },
    { name: "Forest", bbox: [45.377, -89.0476, 46.0736, -88.4253] },
    { name: "Grant", bbox: [42.5071, -91.1631, 43.2115, -90.4264] },
    { name: "Green", bbox: [42.5003, -89.8384, 42.8574, -89.366] },
    { name: "Green Lake", bbox: [43.633, -89.2455, 43.9832, -88.8857] },
    { name: "Iowa", bbox: [42.8129, -90.4298, 43.2069, -89.8381] },
    { name: "Iron", bbox: [45.9813, -90.5522, 46.5896, -89.9288] },
    { name: "Jackson", bbox: [44.0708, -91.1658, 44.597, -90.312] },
    { name: "Jefferson", bbox: [42.8425, -89.0135, 43.1979, -88.5358] },
    { name: "Juneau", bbox: [43.6409, -90.3126, 44.2495, -89.7858] },
    { name: "Kenosha", bbox: [42.4919, -88.3059, 42.6697, -87.8005] },
    { name: "Kewaunee", bbox: [44.3272, -87.7662, 44.677, -87.3732] },
    { name: "La Crosse", bbox: [43.7253, -91.4201, 44.0797, -90.9105] },
    { name: "Lafayette", bbox: [42.5055, -90.4269, 42.8138, -89.8376] },
    { name: "Langlade", bbox: [45.0289, -89.426, 45.4699, -88.6412] },
    { name: "Lincoln", bbox: [45.1191, -90.0461, 45.5554, -89.4248] },
    { name: "Manitowoc", bbox: [43.8917, -88.0432, 44.3276, -87.5074] },
    { name: "Marathon", bbox: [44.6814, -90.3163, 45.1206, -89.2237] },
    { name: "Marinette", bbox: [44.9658, -88.4281, 45.7954, -87.4902] },
    { name: "Marquette", bbox: [43.6426, -89.6, 43.9828, -89.1686] },
    { name: "Menominee", bbox: [44.8554, -88.9822, 45.1177, -88.4837] },
    { name: "Milwaukee", bbox: [42.8422, -88.0699, 43.1925, -87.827] },
    { name: "Monroe", bbox: [43.7253, -90.9728, 44.1583, -90.3122] },
    { name: "Oconto", bbox: [44.6776, -88.6801, 45.3787, -87.7626] },
    { name: "Oneida", bbox: [45.4648, -90.0444, 45.9015, -89.0463] },
    { name: "Outagamie", bbox: [44.2419, -88.7398, 44.5906, -88.1906] },
    { name: "Ozaukee", bbox: [43.192, -88.0634, 43.543, -87.7932] },
    { name: "Pepin", bbox: [44.4062, -92.3164, 44.6844, -91.6502] },
    { name: "Pierce", bbox: [44.5396, -92.8024, 44.862, -92.1352] },
    { name: "Polk", bbox: [45.2096, -92.8881, 45.7287, -92.1544] },
    { name: "Portage", bbox: [44.2435, -89.8449, 44.6849, -89.2237] },
    { name: "Price", bbox: [45.3778, -90.6787, 45.9819, -90.0423] },
    { name: "Racine", bbox: [42.6108, -88.3064, 42.8433, -87.7667] },
    { name: "Richland", bbox: [43.1645, -90.6717, 43.555, -90.192] },
    { name: "Rock", bbox: [42.494, -89.3691, 42.8473, -88.7765] },
    { name: "Rusk", bbox: [45.292, -91.5413, 45.6383, -90.6787] },
    { name: "Sauk", bbox: [43.1645, -90.3124, 43.6411, -89.5994] },
    { name: "Sawyer", bbox: [45.6376, -91.5513, 46.157, -90.677] },
    { name: "Shawano", bbox: [44.5847, -89.2238, 45.0295, -88.2427] },
    { name: "Sheboygan", bbox: [43.5424, -88.1623, 43.8922, -87.7001] },
    { name: "St. Croix", bbox: [44.8578, -92.7929, 45.2102, -92.1361] },
    { name: "Taylor", bbox: [45.0311, -90.9252, 45.3819, -90.0423] },
    { name: "Trempealeau", bbox: [43.9842, -91.613, 44.597, -91.1518] },
    { name: "Vernon", bbox: [43.4229, -91.2733, 43.7313, -90.311] },
    { name: "Vilas", bbox: [45.8566, -90.044, 46.3001, -88.9326] },
    { name: "Walworth", bbox: [42.4936, -88.7771, 42.843, -88.3047] },
    { name: "Washburn", bbox: [45.6376, -92.0496, 46.1576, -91.5403] },
    { name: "Washington", bbox: [43.1921, -88.418, 43.5435, -88.0405] },
    { name: "Waukesha", bbox: [42.8414, -88.542, 43.196, -88.0634] },
    { name: "Waupaca", bbox: [44.2426, -89.2249, 44.6814, -88.6052] },
    { name: "Waushara", bbox: [43.9821, -89.598, 44.2457, -88.8862] },
    { name: "Winnebago", bbox: [43.893, -88.8867, 44.2441, -88.4032] },
    { name: "Wood", bbox: [44.2477, -90.3163, 44.6852, -89.7247] },
  ],
  WV: [
    { name: "Barbour", bbox: [38.9472, -80.2272, 39.2996, -79.8097] },
    { name: "Berkeley", bbox: [39.2646, -78.2288, 39.6199, -77.8254] },
    { name: "Boone", bbox: [37.7887, -81.9797, 38.2204, -81.4566] },
    { name: "Braxton", bbox: [38.507, -81.0317, 38.9042, -80.4461] },
    { name: "Brooke", bbox: [40.1597, -80.6854, 40.3998, -80.518] },
    { name: "Cabell", bbox: [38.2292, -82.5067, 38.5985, -82.0471] },
    { name: "Calhoun", bbox: [38.612, -81.2784, 39.0306, -80.9849] },
    { name: "Clay", bbox: [38.2637, -81.2839, 38.6678, -80.8174] },
    { name: "Doddridge", bbox: [39.0957, -80.9138, 39.4504, -80.5257] },
    { name: "Fayette", bbox: [37.8191, -81.3808, 38.2635, -80.7699] },
    { name: "Gilmer", bbox: [38.7179, -81.0567, 39.1094, -80.6058] },
    { name: "Grant", bbox: [38.8133, -79.4872, 39.3401, -78.9799] },
    { name: "Greenbrier", bbox: [37.6839, -80.8822, 38.2673, -79.9598] },
    { name: "Hampshire", bbox: [39.0886, -78.9799, 39.5351, -78.3405] },
    { name: "Hancock", bbox: [40.396, -80.668, 40.6388, -80.518] },
    { name: "Hardy", bbox: [38.7614, -79.1343, 39.2376, -78.5081] },
    { name: "Harrison", bbox: [39.1008, -80.6037, 39.4696, -80.1664] },
    { name: "Jackson", bbox: [38.5544, -81.9086, 39.0954, -81.5026] },
    { name: "Jefferson", bbox: [39.1323, -78.0332, 39.494, -77.719] },
    { name: "Kanawha", bbox: [37.968, -81.9152, 38.6264, -81.1941] },
    { name: "Lewis", bbox: [38.7234, -80.7283, 39.1671, -80.3002] },
    { name: "Lincoln", bbox: [37.9436, -82.3064, 38.3744, -81.8182] },
    { name: "Logan", bbox: [37.6427, -82.1907, 38.0254, -81.6075] },
    { name: "Marion", bbox: [39.3865, -80.4982, 39.6373, -79.9389] },
    { name: "Marshall", bbox: [39.7208, -80.8286, 40.0332, -80.5191] },
    { name: "Mason", bbox: [38.4745, -82.2216, 39.0301, -81.7728] },
    { name: "McDowell", bbox: [37.2025, -81.9966, 37.5489, -81.3112] },
    { name: "Mercer", bbox: [37.2349, -81.3622, 37.5887, -80.8495] },
    { name: "Mineral", bbox: [39.2376, -79.28, 39.6275, -78.6573] },
    { name: "Mingo", bbox: [37.5119, -82.4002, 37.9748, -81.8029] },
    { name: "Monongalia", bbox: [39.4356, -80.4214, 39.7213, -79.7638] },
    { name: "Monroe", bbox: [37.3724, -80.8585, 37.7317, -80.221] },
    { name: "Morgan", bbox: [39.3912, -78.4686, 39.696, -78.0234] },
    { name: "Nicholas", bbox: [38.0791, -81.2316, 38.5576, -80.4365] },
    { name: "Ohio", bbox: [40.0164, -80.7331, 40.1876, -80.519] },
    { name: "Pendleton", bbox: [38.4119, -79.6491, 38.9575, -79.0573] },
    { name: "Pleasants", bbox: [39.2683, -81.3713, 39.4674, -81.0078] },
    { name: "Pocahontas", bbox: [38.0361, -80.3633, 38.7369, -79.6268] },
    { name: "Preston", bbox: [39.1949, -79.8997, 39.7212, -79.4767] },
    { name: "Putnam", bbox: [38.2691, -82.0646, 38.6841, -81.6963] },
    { name: "Raleigh", bbox: [37.5104, -81.5713, 37.9873, -80.8823] },
    { name: "Randolph", bbox: [38.3885, -80.2801, 39.1158, -79.3496] },
    { name: "Ritchie", bbox: [39.0096, -81.3288, 39.3891, -80.813] },
    { name: "Roane", bbox: [38.5276, -81.5466, 38.9416, -81.0837] },
    { name: "Summers", bbox: [37.4283, -81.0946, 37.8689, -80.6604] },
    { name: "Taylor", bbox: [39.2423, -80.1973, 39.4525, -79.8947] },
    { name: "Tucker", bbox: [38.9645, -79.8251, 39.2714, -79.2893] },
    { name: "Tyler", bbox: [39.2943, -81.1277, 39.6069, -80.6186] },
    { name: "Upshur", bbox: [38.6949, -80.3931, 39.1131, -80.0558] },
    { name: "Wayne", bbox: [37.8518, -82.6447, 38.4218, -82.2039] },
    { name: "Webster", bbox: [38.2258, -80.6783, 38.7392, -80.1839] },
    { name: "Wetzel", bbox: [39.4291, -80.9438, 39.7214, -80.3958] },
    { name: "Wirt", bbox: [38.8956, -81.5814, 39.1856, -81.1625] },
    { name: "Wood", bbox: [39.0262, -81.7499, 39.4104, -81.2395] },
    { name: "Wyoming", bbox: [37.4245, -81.8559, 37.7912, -81.2221] },
  ],
  WY: [
    { name: "Albany", bbox: [40.9969, -106.3229, 42.4332, -105.2738] },
    { name: "Big Horn", bbox: [44.1657, -108.6213, 45.001, -107.145] },
    { name: "Campbell", bbox: [43.495, -106.0248, 45.0004, -105.0766] },
    { name: "Carbon", bbox: [40.9991, -107.9297, 42.4344, -106.0684] },
    { name: "Converse", bbox: [42.2901, -106.0781, 43.4996, -104.8924] },
    { name: "Crook", bbox: [44.1762, -105.0822, 45.0004, -104.0545] },
    { name: "Fremont", bbox: [42.2618, -110.0532, 44.008, -107.5014] },
    { name: "Goshen", bbox: [41.5643, -104.6556, 42.6118, -104.0525] },
    { name: "Hot Springs", bbox: [43.4598, -109.3129, 44.0798, -107.5951] },
    { name: "Johnson", bbox: [43.4924, -107.3696, 44.564, -106.0092] },
    { name: "Laramie", bbox: [40.9982, -105.2782, 41.6567, -104.0522] },
    { name: "Lincoln", bbox: [41.5775, -111.0471, 43.3159, -110.048] },
    { name: "Natrona", bbox: [42.4311, -107.5435, 43.5014, -106.0727] },
    { name: "Niobrara", bbox: [42.6088, -104.8999, 43.5033, -104.0526] },
    { name: "Park", bbox: [43.8033, -111.0569, 45.0059, -108.5506] },
    { name: "Platte", bbox: [41.653, -105.2865, 42.6095, -104.6533] },
    { name: "Sheridan", bbox: [44.5568, -107.9115, 45.0009, -106.0097] },
    { name: "Sublette", bbox: [42.2633, -110.6235, 43.4648, -109.0438] },
    { name: "Sweetwater", bbox: [40.9971, -110.0537, 42.2707, -107.5038] },
    { name: "Teton", bbox: [43.2352, -111.0555, 44.6663, -110.0516] },
    { name: "Uinta", bbox: [40.9947, -111.0467, 41.5798, -110.048] },
    { name: "Washakie", bbox: [43.5003, -108.5508, 44.1685, -107.1107] },
    { name: "Weston", bbox: [43.4984, -105.0798, 44.1804, -104.0545] },
  ],
};

export const countiesFor = (state) => COUNTY_BBOX[state] || [];
